var tu = Object.defineProperty, nu = Object.defineProperties;
var su = Object.getOwnPropertyDescriptors;
var vs = Object.getOwnPropertySymbols;
var Ni = Object.prototype.hasOwnProperty, $i = Object.prototype.propertyIsEnumerable;
var Ii = (e) => {
  throw TypeError(e);
}, Fi = Math.pow, Di = (e, t, n) => t in e ? tu(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, I = (e, t) => {
  for (var n in t || (t = {}))
    Ni.call(t, n) && Di(e, n, t[n]);
  if (vs)
    for (var n of vs(t))
      $i.call(t, n) && Di(e, n, t[n]);
  return e;
}, ie = (e, t) => nu(e, su(t));
var pr = (e, t) => {
  var n = {};
  for (var s in e)
    Ni.call(e, s) && t.indexOf(s) < 0 && (n[s] = e[s]);
  if (e != null && vs)
    for (var s of vs(e))
      t.indexOf(s) < 0 && $i.call(e, s) && (n[s] = e[s]);
  return n;
};
var mr = (e, t, n) => t.has(e) || Ii("Cannot " + n);
var b = (e, t, n) => (mr(e, t, "read from private field"), n ? n.call(e) : t.get(e)), X = (e, t, n) => t.has(e) ? Ii("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), B = (e, t, n, s) => (mr(e, t, "write to private field"), s ? s.call(e, n) : t.set(e, n), n), _e = (e, t, n) => (mr(e, t, "access private method"), n);
var bs = (e, t, n, s) => ({
  set _(r) {
    B(e, t, r, n);
  },
  get _() {
    return b(e, t, s);
  }
});
var ze = (e, t, n) => new Promise((s, r) => {
  var i = (a) => {
    try {
      l(n.next(a));
    } catch (c) {
      r(c);
    }
  }, o = (a) => {
    try {
      l(n.throw(a));
    } catch (c) {
      r(c);
    }
  }, l = (a) => a.done ? s(a.value) : Promise.resolve(a.value).then(i, o);
  l((n = n.apply(e, t)).next());
});
/**
* @vue/shared v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Zr(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n of e.split(",")) t[n] = 1;
  return (n) => n in t;
}
const ee = {}, yn = [], ht = () => {
}, ru = () => !1, Zs = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), ei = (e) => e.startsWith("onUpdate:"), de = Object.assign, ti = (e, t) => {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}, iu = Object.prototype.hasOwnProperty, ne = (e, t) => iu.call(e, t), L = Array.isArray, vn = (e) => cs(e) === "[object Map]", Dn = (e) => cs(e) === "[object Set]", ji = (e) => cs(e) === "[object Date]", K = (e) => typeof e == "function", ce = (e) => typeof e == "string", tt = (e) => typeof e == "symbol", oe = (e) => e !== null && typeof e == "object", cl = (e) => (oe(e) || K(e)) && K(e.then) && K(e.catch), fl = Object.prototype.toString, cs = (e) => fl.call(e), ou = (e) => cs(e).slice(8, -1), er = (e) => cs(e) === "[object Object]", ni = (e) => ce(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, kn = /* @__PURE__ */ Zr(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), tr = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, lu = /-(\w)/g, Pe = tr(
  (e) => e.replace(lu, (t, n) => n ? n.toUpperCase() : "")
), au = /\B([A-Z])/g, Ue = tr(
  (e) => e.replace(au, "-$1").toLowerCase()
), nr = tr((e) => e.charAt(0).toUpperCase() + e.slice(1)), gr = tr(
  (e) => e ? `on${nr(e)}` : ""
), ke = (e, t) => !Object.is(e, t), Rs = (e, ...t) => {
  for (let n = 0; n < e.length; n++)
    e[n](...t);
}, Rr = (e, t, n, s = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: s,
    value: n
  });
}, Ls = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}, Dr = (e) => {
  const t = ce(e) ? Number(e) : NaN;
  return isNaN(t) ? e : t;
};
let Li;
const sr = () => Li || (Li = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : typeof global != "undefined" ? global : {});
function si(e) {
  if (L(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const s = e[n], r = ce(s) ? du(s) : si(s);
      if (r)
        for (const i in r)
          t[i] = r[i];
    }
    return t;
  } else if (ce(e) || oe(e))
    return e;
}
const uu = /;(?![^(]*\))/g, cu = /:([^]+)/, fu = /\/\*[^]*?\*\//g;
function du(e) {
  const t = {};
  return e.replace(fu, "").split(uu).forEach((n) => {
    if (n) {
      const s = n.split(cu);
      s.length > 1 && (t[s[0].trim()] = s[1].trim());
    }
  }), t;
}
function ri(e) {
  let t = "";
  if (ce(e))
    t = e;
  else if (L(e))
    for (let n = 0; n < e.length; n++) {
      const s = ri(e[n]);
      s && (t += s + " ");
    }
  else if (oe(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
const hu = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", pu = /* @__PURE__ */ Zr(hu);
function dl(e) {
  return !!e || e === "";
}
function mu(e, t) {
  if (e.length !== t.length) return !1;
  let n = !0;
  for (let s = 0; n && s < e.length; s++)
    n = un(e[s], t[s]);
  return n;
}
function un(e, t) {
  if (e === t) return !0;
  let n = ji(e), s = ji(t);
  if (n || s)
    return n && s ? e.getTime() === t.getTime() : !1;
  if (n = tt(e), s = tt(t), n || s)
    return e === t;
  if (n = L(e), s = L(t), n || s)
    return n && s ? mu(e, t) : !1;
  if (n = oe(e), s = oe(t), n || s) {
    if (!n || !s)
      return !1;
    const r = Object.keys(e).length, i = Object.keys(t).length;
    if (r !== i)
      return !1;
    for (const o in e) {
      const l = e.hasOwnProperty(o), a = t.hasOwnProperty(o);
      if (l && !a || !l && a || !un(e[o], t[o]))
        return !1;
    }
  }
  return String(e) === String(t);
}
function ii(e, t) {
  return e.findIndex((n) => un(n, t));
}
const hl = (e) => !!(e && e.__v_isRef === !0), gu = (e) => ce(e) ? e : e == null ? "" : L(e) || oe(e) && (e.toString === fl || !K(e.toString)) ? hl(e) ? gu(e.value) : JSON.stringify(e, pl, 2) : String(e), pl = (e, t) => hl(t) ? pl(e, t.value) : vn(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (n, [s, r], i) => (n[yr(s, i) + " =>"] = r, n),
    {}
  )
} : Dn(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((n) => yr(n))
} : tt(t) ? yr(t) : oe(t) && !L(t) && !er(t) ? String(t) : t, yr = (e, t = "") => {
  var n;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    tt(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e
  );
};
/**
* @vue/reactivity v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let Ce;
class yu {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = Ce, !t && Ce && (this.index = (Ce.scopes || (Ce.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, n;
      if (this.scopes)
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].pause();
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, n;
      if (this.scopes)
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].resume();
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const n = Ce;
      try {
        return Ce = this, t();
      } finally {
        Ce = n;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    ++this._on === 1 && (this.prevScope = Ce, Ce = this);
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    this._on > 0 && --this._on === 0 && (Ce = this.prevScope, this.prevScope = void 0);
  }
  stop(t) {
    if (this._active) {
      this._active = !1;
      let n, s;
      for (n = 0, s = this.effects.length; n < s; n++)
        this.effects[n].stop();
      for (this.effects.length = 0, n = 0, s = this.cleanups.length; n < s; n++)
        this.cleanups[n]();
      if (this.cleanups.length = 0, this.scopes) {
        for (n = 0, s = this.scopes.length; n < s; n++)
          this.scopes[n].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !t) {
        const r = this.parent.scopes.pop();
        r && r !== this && (this.parent.scopes[this.index] = r, r.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function vu() {
  return Ce;
}
function Wh(e, t = !1) {
  Ce && Ce.cleanups.push(e);
}
let ae;
const vr = /* @__PURE__ */ new WeakSet();
class ml {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, Ce && Ce.active && Ce.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, vr.has(this) && (vr.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || yl(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, ki(this), vl(this);
    const t = ae, n = et;
    ae = this, et = !0;
    try {
      return this.fn();
    } finally {
      bl(this), ae = t, et = n, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        ai(t);
      this.deps = this.depsTail = void 0, ki(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? vr.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    Nr(this) && this.run();
  }
  get dirty() {
    return Nr(this);
  }
}
let gl = 0, Un, Hn;
function yl(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = Hn, Hn = e;
    return;
  }
  e.next = Un, Un = e;
}
function oi() {
  gl++;
}
function li() {
  if (--gl > 0)
    return;
  if (Hn) {
    let t = Hn;
    for (Hn = void 0; t; ) {
      const n = t.next;
      t.next = void 0, t.flags &= -9, t = n;
    }
  }
  let e;
  for (; Un; ) {
    let t = Un;
    for (Un = void 0; t; ) {
      const n = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (s) {
          e || (e = s);
        }
      t = n;
    }
  }
  if (e) throw e;
}
function vl(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function bl(e) {
  let t, n = e.depsTail, s = n;
  for (; s; ) {
    const r = s.prevDep;
    s.version === -1 ? (s === n && (n = r), ai(s), bu(s)) : t = s, s.dep.activeLink = s.prevActiveLink, s.prevActiveLink = void 0, s = r;
  }
  e.deps = t, e.depsTail = n;
}
function Nr(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (_l(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function _l(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Gn) || (e.globalVersion = Gn, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !Nr(e))))
    return;
  e.flags |= 2;
  const t = e.dep, n = ae, s = et;
  ae = e, et = !0;
  try {
    vl(e);
    const r = e.fn(e._value);
    (t.version === 0 || ke(r, e._value)) && (e.flags |= 128, e._value = r, t.version++);
  } catch (r) {
    throw t.version++, r;
  } finally {
    ae = n, et = s, bl(e), e.flags &= -3;
  }
}
function ai(e, t = !1) {
  const { dep: n, prevSub: s, nextSub: r } = e;
  if (s && (s.nextSub = r, e.prevSub = void 0), r && (r.prevSub = s, e.nextSub = void 0), n.subs === e && (n.subs = s, !s && n.computed)) {
    n.computed.flags &= -5;
    for (let i = n.computed.deps; i; i = i.nextDep)
      ai(i, !0);
  }
  !t && !--n.sc && n.map && n.map.delete(n.key);
}
function bu(e) {
  const { prevDep: t, nextDep: n } = e;
  t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
let et = !0;
const Sl = [];
function Ct() {
  Sl.push(et), et = !1;
}
function Ot() {
  const e = Sl.pop();
  et = e === void 0 ? !0 : e;
}
function ki(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const n = ae;
    ae = void 0;
    try {
      t();
    } finally {
      ae = n;
    }
  }
}
let Gn = 0;
class _u {
  constructor(t, n) {
    this.sub = t, this.dep = n, this.version = n.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class rr {
  // TODO isolatedDeclarations "__v_skip"
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0;
  }
  track(t) {
    if (!ae || !et || ae === this.computed)
      return;
    let n = this.activeLink;
    if (n === void 0 || n.sub !== ae)
      n = this.activeLink = new _u(ae, this), ae.deps ? (n.prevDep = ae.depsTail, ae.depsTail.nextDep = n, ae.depsTail = n) : ae.deps = ae.depsTail = n, wl(n);
    else if (n.version === -1 && (n.version = this.version, n.nextDep)) {
      const s = n.nextDep;
      s.prevDep = n.prevDep, n.prevDep && (n.prevDep.nextDep = s), n.prevDep = ae.depsTail, n.nextDep = void 0, ae.depsTail.nextDep = n, ae.depsTail = n, ae.deps === n && (ae.deps = s);
    }
    return n;
  }
  trigger(t) {
    this.version++, Gn++, this.notify(t);
  }
  notify(t) {
    oi();
    try {
      for (let n = this.subs; n; n = n.prevSub)
        n.sub.notify() && n.sub.dep.notify();
    } finally {
      li();
    }
  }
}
function wl(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let s = t.deps; s; s = s.nextDep)
        wl(s);
    }
    const n = e.dep.subs;
    n !== e && (e.prevSub = n, n && (n.nextSub = e)), e.dep.subs = e;
  }
}
const ks = /* @__PURE__ */ new WeakMap(), rn = Symbol(
  ""
), $r = Symbol(
  ""
), zn = Symbol(
  ""
);
function Te(e, t, n) {
  if (et && ae) {
    let s = ks.get(e);
    s || ks.set(e, s = /* @__PURE__ */ new Map());
    let r = s.get(n);
    r || (s.set(n, r = new rr()), r.map = s, r.key = n), r.track();
  }
}
function _t(e, t, n, s, r, i) {
  const o = ks.get(e);
  if (!o) {
    Gn++;
    return;
  }
  const l = (a) => {
    a && a.trigger();
  };
  if (oi(), t === "clear")
    o.forEach(l);
  else {
    const a = L(e), c = a && ni(n);
    if (a && n === "length") {
      const u = Number(s);
      o.forEach((f, h) => {
        (h === "length" || h === zn || !tt(h) && h >= u) && l(f);
      });
    } else
      switch ((n !== void 0 || o.has(void 0)) && l(o.get(n)), c && l(o.get(zn)), t) {
        case "add":
          a ? c && l(o.get("length")) : (l(o.get(rn)), vn(e) && l(o.get($r)));
          break;
        case "delete":
          a || (l(o.get(rn)), vn(e) && l(o.get($r)));
          break;
        case "set":
          vn(e) && l(o.get(rn));
          break;
      }
  }
  li();
}
function Su(e, t) {
  const n = ks.get(e);
  return n && n.get(t);
}
function fn(e) {
  const t = Z(e);
  return t === e ? t : (Te(t, "iterate", zn), We(e) ? t : t.map(ve));
}
function ir(e) {
  return Te(e = Z(e), "iterate", zn), e;
}
const wu = {
  __proto__: null,
  [Symbol.iterator]() {
    return br(this, Symbol.iterator, ve);
  },
  concat(...e) {
    return fn(this).concat(
      ...e.map((t) => L(t) ? fn(t) : t)
    );
  },
  entries() {
    return br(this, "entries", (e) => (e[1] = ve(e[1]), e));
  },
  every(e, t) {
    return pt(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return pt(this, "filter", e, t, (n) => n.map(ve), arguments);
  },
  find(e, t) {
    return pt(this, "find", e, t, ve, arguments);
  },
  findIndex(e, t) {
    return pt(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return pt(this, "findLast", e, t, ve, arguments);
  },
  findLastIndex(e, t) {
    return pt(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return pt(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return _r(this, "includes", e);
  },
  indexOf(...e) {
    return _r(this, "indexOf", e);
  },
  join(e) {
    return fn(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return _r(this, "lastIndexOf", e);
  },
  map(e, t) {
    return pt(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return In(this, "pop");
  },
  push(...e) {
    return In(this, "push", e);
  },
  reduce(e, ...t) {
    return Ui(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return Ui(this, "reduceRight", e, t);
  },
  shift() {
    return In(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return pt(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return In(this, "splice", e);
  },
  toReversed() {
    return fn(this).toReversed();
  },
  toSorted(e) {
    return fn(this).toSorted(e);
  },
  toSpliced(...e) {
    return fn(this).toSpliced(...e);
  },
  unshift(...e) {
    return In(this, "unshift", e);
  },
  values() {
    return br(this, "values", ve);
  }
};
function br(e, t, n) {
  const s = ir(e), r = s[t]();
  return s !== e && !We(e) && (r._next = r.next, r.next = () => {
    const i = r._next();
    return i.value && (i.value = n(i.value)), i;
  }), r;
}
const Cu = Array.prototype;
function pt(e, t, n, s, r, i) {
  const o = ir(e), l = o !== e && !We(e), a = o[t];
  if (a !== Cu[t]) {
    const f = a.apply(e, i);
    return l ? ve(f) : f;
  }
  let c = n;
  o !== e && (l ? c = function(f, h) {
    return n.call(this, ve(f), h, e);
  } : n.length > 2 && (c = function(f, h) {
    return n.call(this, f, h, e);
  }));
  const u = a.call(o, c, s);
  return l && r ? r(u) : u;
}
function Ui(e, t, n, s) {
  const r = ir(e);
  let i = n;
  return r !== e && (We(e) ? n.length > 3 && (i = function(o, l, a) {
    return n.call(this, o, l, a, e);
  }) : i = function(o, l, a) {
    return n.call(this, o, ve(l), a, e);
  }), r[t](i, ...s);
}
function _r(e, t, n) {
  const s = Z(e);
  Te(s, "iterate", zn);
  const r = s[t](...n);
  return (r === -1 || r === !1) && di(n[0]) ? (n[0] = Z(n[0]), s[t](...n)) : r;
}
function In(e, t, n = []) {
  Ct(), oi();
  const s = Z(e)[t].apply(e, n);
  return li(), Ot(), s;
}
const Ou = /* @__PURE__ */ Zr("__proto__,__v_isRef,__isVue"), Cl = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(tt)
);
function Tu(e) {
  tt(e) || (e = String(e));
  const t = Z(this);
  return Te(t, "has", e), t.hasOwnProperty(e);
}
class Ol {
  constructor(t = !1, n = !1) {
    this._isReadonly = t, this._isShallow = n;
  }
  get(t, n, s) {
    if (n === "__v_skip") return t.__v_skip;
    const r = this._isReadonly, i = this._isShallow;
    if (n === "__v_isReactive")
      return !r;
    if (n === "__v_isReadonly")
      return r;
    if (n === "__v_isShallow")
      return i;
    if (n === "__v_raw")
      return s === (r ? i ? Iu : Al : i ? El : xl).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(s) ? t : void 0;
    const o = L(t);
    if (!r) {
      let a;
      if (o && (a = wu[n]))
        return a;
      if (n === "hasOwnProperty")
        return Tu;
    }
    const l = Reflect.get(
      t,
      n,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      pe(t) ? t : s
    );
    return (tt(n) ? Cl.has(n) : Ou(n)) || (r || Te(t, "get", n), i) ? l : pe(l) ? o && ni(n) ? l : l.value : oe(l) ? r ? ci(l) : or(l) : l;
  }
}
class Tl extends Ol {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, s, r) {
    let i = t[n];
    if (!this._isShallow) {
      const a = Vt(i);
      if (!We(s) && !Vt(s) && (i = Z(i), s = Z(s)), !L(t) && pe(i) && !pe(s))
        return a ? !1 : (i.value = s, !0);
    }
    const o = L(t) && ni(n) ? Number(n) < t.length : ne(t, n), l = Reflect.set(
      t,
      n,
      s,
      pe(t) ? t : r
    );
    return t === Z(r) && (o ? ke(s, i) && _t(t, "set", n, s) : _t(t, "add", n, s)), l;
  }
  deleteProperty(t, n) {
    const s = ne(t, n);
    t[n];
    const r = Reflect.deleteProperty(t, n);
    return r && s && _t(t, "delete", n, void 0), r;
  }
  has(t, n) {
    const s = Reflect.has(t, n);
    return (!tt(n) || !Cl.has(n)) && Te(t, "has", n), s;
  }
  ownKeys(t) {
    return Te(
      t,
      "iterate",
      L(t) ? "length" : rn
    ), Reflect.ownKeys(t);
  }
}
class xu extends Ol {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return !0;
  }
  deleteProperty(t, n) {
    return !0;
  }
}
const Eu = /* @__PURE__ */ new Tl(), Au = /* @__PURE__ */ new xu(), Pu = /* @__PURE__ */ new Tl(!0);
const Ir = (e) => e, _s = (e) => Reflect.getPrototypeOf(e);
function Mu(e, t, n) {
  return function(...s) {
    const r = this.__v_raw, i = Z(r), o = vn(i), l = e === "entries" || e === Symbol.iterator && o, a = e === "keys" && o, c = r[e](...s), u = n ? Ir : t ? Us : ve;
    return !t && Te(
      i,
      "iterate",
      a ? $r : rn
    ), {
      // iterator protocol
      next() {
        const { value: f, done: h } = c.next();
        return h ? { value: f, done: h } : {
          value: l ? [u(f[0]), u(f[1])] : u(f),
          done: h
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function Ss(e) {
  return function(...t) {
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function Ru(e, t) {
  const n = {
    get(r) {
      const i = this.__v_raw, o = Z(i), l = Z(r);
      e || (ke(r, l) && Te(o, "get", r), Te(o, "get", l));
      const { has: a } = _s(o), c = t ? Ir : e ? Us : ve;
      if (a.call(o, r))
        return c(i.get(r));
      if (a.call(o, l))
        return c(i.get(l));
      i !== o && i.get(r);
    },
    get size() {
      const r = this.__v_raw;
      return !e && Te(Z(r), "iterate", rn), Reflect.get(r, "size", r);
    },
    has(r) {
      const i = this.__v_raw, o = Z(i), l = Z(r);
      return e || (ke(r, l) && Te(o, "has", r), Te(o, "has", l)), r === l ? i.has(r) : i.has(r) || i.has(l);
    },
    forEach(r, i) {
      const o = this, l = o.__v_raw, a = Z(l), c = t ? Ir : e ? Us : ve;
      return !e && Te(a, "iterate", rn), l.forEach((u, f) => r.call(i, c(u), c(f), o));
    }
  };
  return de(
    n,
    e ? {
      add: Ss("add"),
      set: Ss("set"),
      delete: Ss("delete"),
      clear: Ss("clear")
    } : {
      add(r) {
        !t && !We(r) && !Vt(r) && (r = Z(r));
        const i = Z(this);
        return _s(i).has.call(i, r) || (i.add(r), _t(i, "add", r, r)), this;
      },
      set(r, i) {
        !t && !We(i) && !Vt(i) && (i = Z(i));
        const o = Z(this), { has: l, get: a } = _s(o);
        let c = l.call(o, r);
        c || (r = Z(r), c = l.call(o, r));
        const u = a.call(o, r);
        return o.set(r, i), c ? ke(i, u) && _t(o, "set", r, i) : _t(o, "add", r, i), this;
      },
      delete(r) {
        const i = Z(this), { has: o, get: l } = _s(i);
        let a = o.call(i, r);
        a || (r = Z(r), a = o.call(i, r)), l && l.call(i, r);
        const c = i.delete(r);
        return a && _t(i, "delete", r, void 0), c;
      },
      clear() {
        const r = Z(this), i = r.size !== 0, o = r.clear();
        return i && _t(
          r,
          "clear",
          void 0,
          void 0
        ), o;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((r) => {
    n[r] = Mu(r, e, t);
  }), n;
}
function ui(e, t) {
  const n = Ru(e, t);
  return (s, r, i) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? s : Reflect.get(
    ne(n, r) && r in s ? n : s,
    r,
    i
  );
}
const Du = {
  get: /* @__PURE__ */ ui(!1, !1)
}, Nu = {
  get: /* @__PURE__ */ ui(!1, !0)
}, $u = {
  get: /* @__PURE__ */ ui(!0, !1)
};
const xl = /* @__PURE__ */ new WeakMap(), El = /* @__PURE__ */ new WeakMap(), Al = /* @__PURE__ */ new WeakMap(), Iu = /* @__PURE__ */ new WeakMap();
function Fu(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function ju(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Fu(ou(e));
}
function or(e) {
  return Vt(e) ? e : fi(
    e,
    !1,
    Eu,
    Du,
    xl
  );
}
function Lu(e) {
  return fi(
    e,
    !1,
    Pu,
    Nu,
    El
  );
}
function ci(e) {
  return fi(
    e,
    !0,
    Au,
    $u,
    Al
  );
}
function fi(e, t, n, s, r) {
  if (!oe(e) || e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const i = ju(e);
  if (i === 0)
    return e;
  const o = r.get(e);
  if (o)
    return o;
  const l = new Proxy(
    e,
    i === 2 ? s : n
  );
  return r.set(e, l), l;
}
function bn(e) {
  return Vt(e) ? bn(e.__v_raw) : !!(e && e.__v_isReactive);
}
function Vt(e) {
  return !!(e && e.__v_isReadonly);
}
function We(e) {
  return !!(e && e.__v_isShallow);
}
function di(e) {
  return e ? !!e.__v_raw : !1;
}
function Z(e) {
  const t = e && e.__v_raw;
  return t ? Z(t) : e;
}
function ku(e) {
  return !ne(e, "__v_skip") && Object.isExtensible(e) && Rr(e, "__v_skip", !0), e;
}
const ve = (e) => oe(e) ? or(e) : e, Us = (e) => oe(e) ? ci(e) : e;
function pe(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function Vn(e) {
  return Pl(e, !1);
}
function Uu(e) {
  return Pl(e, !0);
}
function Pl(e, t) {
  return pe(e) ? e : new Hu(e, t);
}
class Hu {
  constructor(t, n) {
    this.dep = new rr(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = n ? t : Z(t), this._value = n ? t : ve(t), this.__v_isShallow = n;
  }
  get value() {
    return this.dep.track(), this._value;
  }
  set value(t) {
    const n = this._rawValue, s = this.__v_isShallow || We(t) || Vt(t);
    t = s ? t : Z(t), ke(t, n) && (this._rawValue = t, this._value = s ? t : ve(t), this.dep.trigger());
  }
}
function hi(e) {
  return pe(e) ? e.value : e;
}
const Vu = {
  get: (e, t, n) => t === "__v_raw" ? e : hi(Reflect.get(e, t, n)),
  set: (e, t, n, s) => {
    const r = e[t];
    return pe(r) && !pe(n) ? (r.value = n, !0) : Reflect.set(e, t, n, s);
  }
};
function Ml(e) {
  return bn(e) ? e : new Proxy(e, Vu);
}
class Ku {
  constructor(t) {
    this.__v_isRef = !0, this._value = void 0;
    const n = this.dep = new rr(), { get: s, set: r } = t(n.track.bind(n), n.trigger.bind(n));
    this._get = s, this._set = r;
  }
  get value() {
    return this._value = this._get();
  }
  set value(t) {
    this._set(t);
  }
}
function Qu(e) {
  return new Ku(e);
}
function Gh(e) {
  const t = L(e) ? new Array(e.length) : {};
  for (const n in e)
    t[n] = Bu(e, n);
  return t;
}
class qu {
  constructor(t, n, s) {
    this._object = t, this._key = n, this._defaultValue = s, this.__v_isRef = !0, this._value = void 0;
  }
  get value() {
    const t = this._object[this._key];
    return this._value = t === void 0 ? this._defaultValue : t;
  }
  set value(t) {
    this._object[this._key] = t;
  }
  get dep() {
    return Su(Z(this._object), this._key);
  }
}
function Bu(e, t, n) {
  const s = e[t];
  return pe(s) ? s : new qu(e, t, n);
}
class Wu {
  constructor(t, n, s) {
    this.fn = t, this.setter = n, this._value = void 0, this.dep = new rr(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = Gn - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !n, this.isSSR = s;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    ae !== this)
      return yl(this, !0), !0;
  }
  get value() {
    const t = this.dep.track();
    return _l(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter && this.setter(t);
  }
}
function Gu(e, t, n = !1) {
  let s, r;
  return K(e) ? s = e : (s = e.get, r = e.set), new Wu(s, r, n);
}
const ws = {}, Hs = /* @__PURE__ */ new WeakMap();
let Xt;
function zu(e, t = !1, n = Xt) {
  if (n) {
    let s = Hs.get(n);
    s || Hs.set(n, s = []), s.push(e);
  }
}
function Yu(e, t, n = ee) {
  const { immediate: s, deep: r, once: i, scheduler: o, augmentJob: l, call: a } = n, c = (T) => r ? T : We(T) || r === !1 || r === 0 ? St(T, 1) : St(T);
  let u, f, h, m, g = !1, v = !1;
  if (pe(e) ? (f = () => e.value, g = We(e)) : bn(e) ? (f = () => c(e), g = !0) : L(e) ? (v = !0, g = e.some((T) => bn(T) || We(T)), f = () => e.map((T) => {
    if (pe(T))
      return T.value;
    if (bn(T))
      return c(T);
    if (K(T))
      return a ? a(T, 2) : T();
  })) : K(e) ? t ? f = a ? () => a(e, 2) : e : f = () => {
    if (h) {
      Ct();
      try {
        h();
      } finally {
        Ot();
      }
    }
    const T = Xt;
    Xt = u;
    try {
      return a ? a(e, 3, [m]) : e(m);
    } finally {
      Xt = T;
    }
  } : f = ht, t && r) {
    const T = f, F = r === !0 ? 1 / 0 : r;
    f = () => St(T(), F);
  }
  const M = vu(), S = () => {
    u.stop(), M && M.active && ti(M.effects, u);
  };
  if (i && t) {
    const T = t;
    t = (...F) => {
      T(...F), S();
    };
  }
  let P = v ? new Array(e.length).fill(ws) : ws;
  const $ = (T) => {
    if (!(!(u.flags & 1) || !u.dirty && !T))
      if (t) {
        const F = u.run();
        if (r || g || (v ? F.some((j, Q) => ke(j, P[Q])) : ke(F, P))) {
          h && h();
          const j = Xt;
          Xt = u;
          try {
            const Q = [
              F,
              // pass undefined as the old value when it's changed for the first time
              P === ws ? void 0 : v && P[0] === ws ? [] : P,
              m
            ];
            P = F, a ? a(t, 3, Q) : (
              // @ts-expect-error
              t(...Q)
            );
          } finally {
            Xt = j;
          }
        }
      } else
        u.run();
  };
  return l && l($), u = new ml(f), u.scheduler = o ? () => o($, !1) : $, m = (T) => zu(T, !1, u), h = u.onStop = () => {
    const T = Hs.get(u);
    if (T) {
      if (a)
        a(T, 4);
      else
        for (const F of T) F();
      Hs.delete(u);
    }
  }, t ? s ? $(!0) : P = u.run() : o ? o($.bind(null, !0), !0) : u.run(), S.pause = u.pause.bind(u), S.resume = u.resume.bind(u), S.stop = S, S;
}
function St(e, t = 1 / 0, n) {
  if (t <= 0 || !oe(e) || e.__v_skip || (n = n || /* @__PURE__ */ new Set(), n.has(e)))
    return e;
  if (n.add(e), t--, pe(e))
    St(e.value, t, n);
  else if (L(e))
    for (let s = 0; s < e.length; s++)
      St(e[s], t, n);
  else if (Dn(e) || vn(e))
    e.forEach((s) => {
      St(s, t, n);
    });
  else if (er(e)) {
    for (const s in e)
      St(e[s], t, n);
    for (const s of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, s) && St(e[s], t, n);
  }
  return e;
}
/**
* @vue/runtime-core v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function fs(e, t, n, s) {
  try {
    return s ? e(...s) : e();
  } catch (r) {
    lr(r, t, n);
  }
}
function nt(e, t, n, s) {
  if (K(e)) {
    const r = fs(e, t, n, s);
    return r && cl(r) && r.catch((i) => {
      lr(i, t, n);
    }), r;
  }
  if (L(e)) {
    const r = [];
    for (let i = 0; i < e.length; i++)
      r.push(nt(e[i], t, n, s));
    return r;
  }
}
function lr(e, t, n, s = !0) {
  const r = t ? t.vnode : null, { errorHandler: i, throwUnhandledErrorInProduction: o } = t && t.appContext.config || ee;
  if (t) {
    let l = t.parent;
    const a = t.proxy, c = `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; l; ) {
      const u = l.ec;
      if (u) {
        for (let f = 0; f < u.length; f++)
          if (u[f](e, a, c) === !1)
            return;
      }
      l = l.parent;
    }
    if (i) {
      Ct(), fs(i, null, 10, [
        e,
        a,
        c
      ]), Ot();
      return;
    }
  }
  Ju(e, n, r, s, o);
}
function Ju(e, t, n, s = !0, r = !1) {
  if (r)
    throw e;
  console.error(e);
}
const Ne = [];
let lt = -1;
const _n = [];
let Rt = null, hn = 0;
const Rl = /* @__PURE__ */ Promise.resolve();
let Vs = null;
function ds(e) {
  const t = Vs || Rl;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function Xu(e) {
  let t = lt + 1, n = Ne.length;
  for (; t < n; ) {
    const s = t + n >>> 1, r = Ne[s], i = Yn(r);
    i < e || i === e && r.flags & 2 ? t = s + 1 : n = s;
  }
  return t;
}
function pi(e) {
  if (!(e.flags & 1)) {
    const t = Yn(e), n = Ne[Ne.length - 1];
    !n || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= Yn(n) ? Ne.push(e) : Ne.splice(Xu(t), 0, e), e.flags |= 1, Dl();
  }
}
function Dl() {
  Vs || (Vs = Rl.then($l));
}
function Zu(e) {
  L(e) ? _n.push(...e) : Rt && e.id === -1 ? Rt.splice(hn + 1, 0, e) : e.flags & 1 || (_n.push(e), e.flags |= 1), Dl();
}
function Hi(e, t, n = lt + 1) {
  for (; n < Ne.length; n++) {
    const s = Ne[n];
    if (s && s.flags & 2) {
      if (e && s.id !== e.uid)
        continue;
      Ne.splice(n, 1), n--, s.flags & 4 && (s.flags &= -2), s(), s.flags & 4 || (s.flags &= -2);
    }
  }
}
function Nl(e) {
  if (_n.length) {
    const t = [...new Set(_n)].sort(
      (n, s) => Yn(n) - Yn(s)
    );
    if (_n.length = 0, Rt) {
      Rt.push(...t);
      return;
    }
    for (Rt = t, hn = 0; hn < Rt.length; hn++) {
      const n = Rt[hn];
      n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), n.flags &= -2;
    }
    Rt = null, hn = 0;
  }
}
const Yn = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function $l(e) {
  try {
    for (lt = 0; lt < Ne.length; lt++) {
      const t = Ne[lt];
      t && !(t.flags & 8) && (t.flags & 4 && (t.flags &= -2), fs(
        t,
        t.i,
        t.i ? 15 : 14
      ), t.flags & 4 || (t.flags &= -2));
    }
  } finally {
    for (; lt < Ne.length; lt++) {
      const t = Ne[lt];
      t && (t.flags &= -2);
    }
    lt = -1, Ne.length = 0, Nl(), Vs = null, (Ne.length || _n.length) && $l();
  }
}
let be = null, Il = null;
function Ks(e) {
  const t = be;
  return be = e, Il = e && e.type.__scopeId || null, t;
}
function ec(e, t = be, n) {
  if (!t || e._n)
    return e;
  const s = (...r) => {
    s._d && eo(-1);
    const i = Ks(t);
    let o;
    try {
      o = e(...r);
    } finally {
      Ks(i), s._d && eo(1);
    }
    return o;
  };
  return s._n = !0, s._c = !0, s._d = !0, s;
}
function zh(e, t) {
  if (be === null)
    return e;
  const n = dr(be), s = e.dirs || (e.dirs = []);
  for (let r = 0; r < t.length; r++) {
    let [i, o, l, a = ee] = t[r];
    i && (K(i) && (i = {
      mounted: i,
      updated: i
    }), i.deep && St(o), s.push({
      dir: i,
      instance: n,
      value: o,
      oldValue: void 0,
      arg: l,
      modifiers: a
    }));
  }
  return e;
}
function Gt(e, t, n, s) {
  const r = e.dirs, i = t && t.dirs;
  for (let o = 0; o < r.length; o++) {
    const l = r[o];
    i && (l.oldValue = i[o].value);
    let a = l.dir[s];
    a && (Ct(), nt(a, n, 8, [
      e.el,
      l,
      e,
      t
    ]), Ot());
  }
}
const Fl = Symbol("_vte"), jl = (e) => e.__isTeleport, Kn = (e) => e && (e.disabled || e.disabled === ""), Vi = (e) => e && (e.defer || e.defer === ""), Ki = (e) => typeof SVGElement != "undefined" && e instanceof SVGElement, Qi = (e) => typeof MathMLElement == "function" && e instanceof MathMLElement, Fr = (e, t) => {
  const n = e && e.to;
  return ce(n) ? t ? t(n) : null : n;
}, Ll = {
  name: "Teleport",
  __isTeleport: !0,
  process(e, t, n, s, r, i, o, l, a, c) {
    const {
      mc: u,
      pc: f,
      pbc: h,
      o: { insert: m, querySelector: g, createText: v, createComment: M }
    } = c, S = Kn(t.props);
    let { shapeFlag: P, children: $, dynamicChildren: T } = t;
    if (e == null) {
      const F = t.el = v(""), j = t.anchor = v("");
      m(F, n, s), m(j, n, s);
      const Q = (x, k) => {
        P & 16 && (r && r.isCE && (r.ce._teleportTarget = x), u(
          $,
          x,
          k,
          r,
          i,
          o,
          l,
          a
        ));
      }, q = () => {
        const x = t.target = Fr(t.props, g), k = kl(x, t, v, m);
        x && (o !== "svg" && Ki(x) ? o = "svg" : o !== "mathml" && Qi(x) && (o = "mathml"), S || (Q(x, k), Ds(t, !1)));
      };
      S && (Q(n, j), Ds(t, !0)), Vi(t.props) ? (t.el.__isMounted = !1, De(() => {
        q(), delete t.el.__isMounted;
      }, i)) : q();
    } else {
      if (Vi(t.props) && e.el.__isMounted === !1) {
        De(() => {
          Ll.process(
            e,
            t,
            n,
            s,
            r,
            i,
            o,
            l,
            a,
            c
          );
        }, i);
        return;
      }
      t.el = e.el, t.targetStart = e.targetStart;
      const F = t.anchor = e.anchor, j = t.target = e.target, Q = t.targetAnchor = e.targetAnchor, q = Kn(e.props), x = q ? n : j, k = q ? F : Q;
      if (o === "svg" || Ki(j) ? o = "svg" : (o === "mathml" || Qi(j)) && (o = "mathml"), T ? (h(
        e.dynamicChildren,
        T,
        x,
        r,
        i,
        o,
        l
      ), _i(e, t, !0)) : a || f(
        e,
        t,
        x,
        k,
        r,
        i,
        o,
        l,
        !1
      ), S)
        q ? t.props && e.props && t.props.to !== e.props.to && (t.props.to = e.props.to) : Cs(
          t,
          n,
          F,
          c,
          1
        );
      else if ((t.props && t.props.to) !== (e.props && e.props.to)) {
        const W = t.target = Fr(
          t.props,
          g
        );
        W && Cs(
          t,
          W,
          null,
          c,
          0
        );
      } else q && Cs(
        t,
        j,
        Q,
        c,
        1
      );
      Ds(t, S);
    }
  },
  remove(e, t, n, { um: s, o: { remove: r } }, i) {
    const {
      shapeFlag: o,
      children: l,
      anchor: a,
      targetStart: c,
      targetAnchor: u,
      target: f,
      props: h
    } = e;
    if (f && (r(c), r(u)), i && r(a), o & 16) {
      const m = i || !Kn(h);
      for (let g = 0; g < l.length; g++) {
        const v = l[g];
        s(
          v,
          t,
          n,
          m,
          !!v.dynamicChildren
        );
      }
    }
  },
  move: Cs,
  hydrate: tc
};
function Cs(e, t, n, { o: { insert: s }, m: r }, i = 2) {
  i === 0 && s(e.targetAnchor, t, n);
  const { el: o, anchor: l, shapeFlag: a, children: c, props: u } = e, f = i === 2;
  if (f && s(o, t, n), (!f || Kn(u)) && a & 16)
    for (let h = 0; h < c.length; h++)
      r(
        c[h],
        t,
        n,
        2
      );
  f && s(l, t, n);
}
function tc(e, t, n, s, r, i, {
  o: { nextSibling: o, parentNode: l, querySelector: a, insert: c, createText: u }
}, f) {
  const h = t.target = Fr(
    t.props,
    a
  );
  if (h) {
    const m = Kn(t.props), g = h._lpa || h.firstChild;
    if (t.shapeFlag & 16)
      if (m)
        t.anchor = f(
          o(e),
          t,
          l(e),
          n,
          s,
          r,
          i
        ), t.targetStart = g, t.targetAnchor = g && o(g);
      else {
        t.anchor = o(e);
        let v = g;
        for (; v; ) {
          if (v && v.nodeType === 8) {
            if (v.data === "teleport start anchor")
              t.targetStart = v;
            else if (v.data === "teleport anchor") {
              t.targetAnchor = v, h._lpa = t.targetAnchor && o(t.targetAnchor);
              break;
            }
          }
          v = o(v);
        }
        t.targetAnchor || kl(h, t, u, c), f(
          g && o(g),
          t,
          h,
          n,
          s,
          r,
          i
        );
      }
    Ds(t, m);
  }
  return t.anchor && o(t.anchor);
}
const Yh = Ll;
function Ds(e, t) {
  const n = e.ctx;
  if (n && n.ut) {
    let s, r;
    for (t ? (s = e.el, r = e.anchor) : (s = e.targetStart, r = e.targetAnchor); s && s !== r; )
      s.nodeType === 1 && s.setAttribute("data-v-owner", n.uid), s = s.nextSibling;
    n.ut();
  }
}
function kl(e, t, n, s) {
  const r = t.targetStart = n(""), i = t.targetAnchor = n("");
  return r[Fl] = i, e && (s(r, e), s(i, e)), i;
}
const Dt = Symbol("_leaveCb"), Os = Symbol("_enterCb");
function nc() {
  const e = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return mi(() => {
    e.isMounted = !0;
  }), Wl(() => {
    e.isUnmounting = !0;
  }), e;
}
const qe = [Function, Array], Ul = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: qe,
  onEnter: qe,
  onAfterEnter: qe,
  onEnterCancelled: qe,
  // leave
  onBeforeLeave: qe,
  onLeave: qe,
  onAfterLeave: qe,
  onLeaveCancelled: qe,
  // appear
  onBeforeAppear: qe,
  onAppear: qe,
  onAfterAppear: qe,
  onAppearCancelled: qe
}, Hl = (e) => {
  const t = e.subTree;
  return t.component ? Hl(t.component) : t;
}, sc = {
  name: "BaseTransition",
  props: Ul,
  setup(e, { slots: t }) {
    const n = Tt(), s = nc();
    return () => {
      const r = t.default && Ql(t.default(), !0);
      if (!r || !r.length)
        return;
      const i = Vl(r), o = Z(e), { mode: l } = o;
      if (s.isLeaving)
        return Sr(i);
      const a = qi(i);
      if (!a)
        return Sr(i);
      let c = jr(
        a,
        o,
        s,
        n,
        // #11061, ensure enterHooks is fresh after clone
        (f) => c = f
      );
      a.type !== xe && Jn(a, c);
      let u = n.subTree && qi(n.subTree);
      if (u && u.type !== xe && !Zt(a, u) && Hl(n).type !== xe) {
        let f = jr(
          u,
          o,
          s,
          n
        );
        if (Jn(u, f), l === "out-in" && a.type !== xe)
          return s.isLeaving = !0, f.afterLeave = () => {
            s.isLeaving = !1, n.job.flags & 8 || n.update(), delete f.afterLeave, u = void 0;
          }, Sr(i);
        l === "in-out" && a.type !== xe ? f.delayLeave = (h, m, g) => {
          const v = Kl(
            s,
            u
          );
          v[String(u.key)] = u, h[Dt] = () => {
            m(), h[Dt] = void 0, delete c.delayedLeave, u = void 0;
          }, c.delayedLeave = () => {
            g(), delete c.delayedLeave, u = void 0;
          };
        } : u = void 0;
      } else u && (u = void 0);
      return i;
    };
  }
};
function Vl(e) {
  let t = e[0];
  if (e.length > 1) {
    for (const n of e)
      if (n.type !== xe) {
        t = n;
        break;
      }
  }
  return t;
}
const rc = sc;
function Kl(e, t) {
  const { leavingVNodes: n } = e;
  let s = n.get(t.type);
  return s || (s = /* @__PURE__ */ Object.create(null), n.set(t.type, s)), s;
}
function jr(e, t, n, s, r) {
  const {
    appear: i,
    mode: o,
    persisted: l = !1,
    onBeforeEnter: a,
    onEnter: c,
    onAfterEnter: u,
    onEnterCancelled: f,
    onBeforeLeave: h,
    onLeave: m,
    onAfterLeave: g,
    onLeaveCancelled: v,
    onBeforeAppear: M,
    onAppear: S,
    onAfterAppear: P,
    onAppearCancelled: $
  } = t, T = String(e.key), F = Kl(n, e), j = (x, k) => {
    x && nt(
      x,
      s,
      9,
      k
    );
  }, Q = (x, k) => {
    const W = k[1];
    j(x, k), L(x) ? x.every((N) => N.length <= 1) && W() : x.length <= 1 && W();
  }, q = {
    mode: o,
    persisted: l,
    beforeEnter(x) {
      let k = a;
      if (!n.isMounted)
        if (i)
          k = M || a;
        else
          return;
      x[Dt] && x[Dt](
        !0
        /* cancelled */
      );
      const W = F[T];
      W && Zt(e, W) && W.el[Dt] && W.el[Dt](), j(k, [x]);
    },
    enter(x) {
      let k = c, W = u, N = f;
      if (!n.isMounted)
        if (i)
          k = S || c, W = P || u, N = $ || f;
        else
          return;
      let Y = !1;
      const re = x[Os] = (ye) => {
        Y || (Y = !0, ye ? j(N, [x]) : j(W, [x]), q.delayedLeave && q.delayedLeave(), x[Os] = void 0);
      };
      k ? Q(k, [x, re]) : re();
    },
    leave(x, k) {
      const W = String(e.key);
      if (x[Os] && x[Os](
        !0
        /* cancelled */
      ), n.isUnmounting)
        return k();
      j(h, [x]);
      let N = !1;
      const Y = x[Dt] = (re) => {
        N || (N = !0, k(), re ? j(v, [x]) : j(g, [x]), x[Dt] = void 0, F[W] === e && delete F[W]);
      };
      F[W] = e, m ? Q(m, [x, Y]) : Y();
    },
    clone(x) {
      const k = jr(
        x,
        t,
        n,
        s,
        r
      );
      return r && r(k), k;
    }
  };
  return q;
}
function Sr(e) {
  if (ar(e))
    return e = Kt(e), e.children = null, e;
}
function qi(e) {
  if (!ar(e))
    return jl(e.type) && e.children ? Vl(e.children) : e;
  if (e.component)
    return e.component.subTree;
  const { shapeFlag: t, children: n } = e;
  if (n) {
    if (t & 16)
      return n[0];
    if (t & 32 && K(n.default))
      return n.default();
  }
}
function Jn(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, Jn(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
function Ql(e, t = !1, n) {
  let s = [], r = 0;
  for (let i = 0; i < e.length; i++) {
    let o = e[i];
    const l = n == null ? o.key : String(n) + String(o.key != null ? o.key : i);
    o.type === Ke ? (o.patchFlag & 128 && r++, s = s.concat(
      Ql(o.children, t, l)
    )) : (t || o.type !== xe) && s.push(l != null ? Kt(o, { key: l }) : o);
  }
  if (r > 1)
    for (let i = 0; i < s.length; i++)
      s[i].patchFlag = -2;
  return s;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function ic(e, t) {
  return K(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    de({ name: e.name }, t, { setup: e })
  ) : e;
}
function Jh() {
  const e = Tt();
  return e ? (e.appContext.config.idPrefix || "v") + "-" + e.ids[0] + e.ids[1]++ : "";
}
function ql(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
function Xh(e) {
  const t = Tt(), n = Uu(null);
  if (t) {
    const r = t.refs === ee ? t.refs = {} : t.refs;
    Object.defineProperty(r, e, {
      enumerable: !0,
      get: () => n.value,
      set: (i) => n.value = i
    });
  }
  return n;
}
function Qn(e, t, n, s, r = !1) {
  if (L(e)) {
    e.forEach(
      (g, v) => Qn(
        g,
        t && (L(t) ? t[v] : t),
        n,
        s,
        r
      )
    );
    return;
  }
  if (Sn(s) && !r) {
    s.shapeFlag & 512 && s.type.__asyncResolved && s.component.subTree.component && Qn(e, t, n, s.component.subTree);
    return;
  }
  const i = s.shapeFlag & 4 ? dr(s.component) : s.el, o = r ? null : i, { i: l, r: a } = e, c = t && t.r, u = l.refs === ee ? l.refs = {} : l.refs, f = l.setupState, h = Z(f), m = f === ee ? () => !1 : (g) => ne(h, g);
  if (c != null && c !== a && (ce(c) ? (u[c] = null, m(c) && (f[c] = null)) : pe(c) && (c.value = null)), K(a))
    fs(a, l, 12, [o, u]);
  else {
    const g = ce(a), v = pe(a);
    if (g || v) {
      const M = () => {
        if (e.f) {
          const S = g ? m(a) ? f[a] : u[a] : a.value;
          r ? L(S) && ti(S, i) : L(S) ? S.includes(i) || S.push(i) : g ? (u[a] = [i], m(a) && (f[a] = u[a])) : (a.value = [i], e.k && (u[e.k] = a.value));
        } else g ? (u[a] = o, m(a) && (f[a] = o)) : v && (a.value = o, e.k && (u[e.k] = o));
      };
      o ? (M.id = -1, De(M, n)) : M();
    }
  }
}
sr().requestIdleCallback;
sr().cancelIdleCallback;
const Sn = (e) => !!e.type.__asyncLoader, ar = (e) => e.type.__isKeepAlive;
function oc(e, t) {
  Bl(e, "a", t);
}
function lc(e, t) {
  Bl(e, "da", t);
}
function Bl(e, t, n = Ee) {
  const s = e.__wdc || (e.__wdc = () => {
    let r = n;
    for (; r; ) {
      if (r.isDeactivated)
        return;
      r = r.parent;
    }
    return e();
  });
  if (ur(t, s, n), n) {
    let r = n.parent;
    for (; r && r.parent; )
      ar(r.parent.vnode) && ac(s, t, n, r), r = r.parent;
  }
}
function ac(e, t, n, s) {
  const r = ur(
    t,
    e,
    s,
    !0
    /* prepend */
  );
  Gl(() => {
    ti(s[t], r);
  }, n);
}
function ur(e, t, n = Ee, s = !1) {
  if (n) {
    const r = n[e] || (n[e] = []), i = t.__weh || (t.__weh = (...o) => {
      Ct();
      const l = hs(n), a = nt(t, n, e, o);
      return l(), Ot(), a;
    });
    return s ? r.unshift(i) : r.push(i), i;
  }
}
const xt = (e) => (t, n = Ee) => {
  (!es || e === "sp") && ur(e, (...s) => t(...s), n);
}, uc = xt("bm"), mi = xt("m"), cc = xt(
  "bu"
), fc = xt("u"), Wl = xt(
  "bum"
), Gl = xt("um"), dc = xt(
  "sp"
), hc = xt("rtg"), pc = xt("rtc");
function mc(e, t = Ee) {
  ur("ec", e, t);
}
const gi = "components", gc = "directives";
function Zh(e, t) {
  return yi(gi, e, !0, t) || e;
}
const zl = Symbol.for("v-ndc");
function ep(e) {
  return ce(e) ? yi(gi, e, !1) || e : e || zl;
}
function tp(e) {
  return yi(gc, e);
}
function yi(e, t, n = !0, s = !1) {
  const r = be || Ee;
  if (r) {
    const i = r.type;
    if (e === gi) {
      const l = rf(
        i,
        !1
      );
      if (l && (l === t || l === Pe(t) || l === nr(Pe(t))))
        return i;
    }
    const o = (
      // local registration
      // check instance[type] first which is resolved for options API
      Bi(r[e] || i[e], t) || // global registration
      Bi(r.appContext[e], t)
    );
    return !o && s ? i : o;
  }
}
function Bi(e, t) {
  return e && (e[t] || e[Pe(t)] || e[nr(Pe(t))]);
}
function np(e, t, n, s) {
  let r;
  const i = n, o = L(e);
  if (o || ce(e)) {
    const l = o && bn(e);
    let a = !1, c = !1;
    l && (a = !We(e), c = Vt(e), e = ir(e)), r = new Array(e.length);
    for (let u = 0, f = e.length; u < f; u++)
      r[u] = t(
        a ? c ? Us(ve(e[u])) : ve(e[u]) : e[u],
        u,
        void 0,
        i
      );
  } else if (typeof e == "number") {
    r = new Array(e);
    for (let l = 0; l < e; l++)
      r[l] = t(l + 1, l, void 0, i);
  } else if (oe(e))
    if (e[Symbol.iterator])
      r = Array.from(
        e,
        (l, a) => t(l, a, void 0, i)
      );
    else {
      const l = Object.keys(e);
      r = new Array(l.length);
      for (let a = 0, c = l.length; a < c; a++) {
        const u = l[a];
        r[a] = t(e[u], u, a, i);
      }
    }
  else
    r = [];
  return r;
}
function sp(e, t, n = {}, s, r) {
  if (be.ce || be.parent && Sn(be.parent) && be.parent.ce)
    return t !== "default" && (n.name = t), Vr(), Kr(
      Ke,
      null,
      [Ae("slot", n, s && s())],
      64
    );
  let i = e[t];
  i && i._c && (i._d = !1), Vr();
  const o = i && Yl(i(n)), l = n.key || // slot content array of a dynamic conditional slot may have a branch
  // key attached in the `createSlots` helper, respect that
  o && o.key, a = Kr(
    Ke,
    {
      key: (l && !tt(l) ? l : `_${t}`) + // #7256 force differentiate fallback content from actual content
      (!o && s ? "_fb" : "")
    },
    o || (s ? s() : []),
    o && e._ === 1 ? 64 : -2
  );
  return !r && a.scopeId && (a.slotScopeIds = [a.scopeId + "-s"]), i && i._c && (i._d = !0), a;
}
function Yl(e) {
  return e.some((t) => Zn(t) ? !(t.type === xe || t.type === Ke && !Yl(t.children)) : !0) ? e : null;
}
const Lr = (e) => e ? ga(e) ? dr(e) : Lr(e.parent) : null, qn = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ de(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => e.props,
    $attrs: (e) => e.attrs,
    $slots: (e) => e.slots,
    $refs: (e) => e.refs,
    $parent: (e) => Lr(e.parent),
    $root: (e) => Lr(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => Xl(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      pi(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = ds.bind(e.proxy)),
    $watch: (e) => Uc.bind(e)
  })
), wr = (e, t) => e !== ee && !e.__isScriptSetup && ne(e, t), yc = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: n, setupState: s, data: r, props: i, accessCache: o, type: l, appContext: a } = e;
    let c;
    if (t[0] !== "$") {
      const m = o[t];
      if (m !== void 0)
        switch (m) {
          case 1:
            return s[t];
          case 2:
            return r[t];
          case 4:
            return n[t];
          case 3:
            return i[t];
        }
      else {
        if (wr(s, t))
          return o[t] = 1, s[t];
        if (r !== ee && ne(r, t))
          return o[t] = 2, r[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (c = e.propsOptions[0]) && ne(c, t)
        )
          return o[t] = 3, i[t];
        if (n !== ee && ne(n, t))
          return o[t] = 4, n[t];
        kr && (o[t] = 0);
      }
    }
    const u = qn[t];
    let f, h;
    if (u)
      return t === "$attrs" && Te(e.attrs, "get", ""), u(e);
    if (
      // css module (injected by vue-loader)
      (f = l.__cssModules) && (f = f[t])
    )
      return f;
    if (n !== ee && ne(n, t))
      return o[t] = 4, n[t];
    if (
      // global properties
      h = a.config.globalProperties, ne(h, t)
    )
      return h[t];
  },
  set({ _: e }, t, n) {
    const { data: s, setupState: r, ctx: i } = e;
    return wr(r, t) ? (r[t] = n, !0) : s !== ee && ne(s, t) ? (s[t] = n, !0) : ne(e.props, t) || t[0] === "$" && t.slice(1) in e ? !1 : (i[t] = n, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: n, ctx: s, appContext: r, propsOptions: i }
  }, o) {
    let l;
    return !!n[o] || e !== ee && ne(e, o) || wr(t, o) || (l = i[0]) && ne(l, o) || ne(s, o) || ne(qn, o) || ne(r.config.globalProperties, o);
  },
  defineProperty(e, t, n) {
    return n.get != null ? e._.accessCache[t] = 0 : ne(n, "value") && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
  }
};
function rp() {
  return vc().attrs;
}
function vc(e) {
  const t = Tt();
  return t.setupContext || (t.setupContext = va(t));
}
function Qs(e) {
  return L(e) ? e.reduce(
    (t, n) => (t[n] = null, t),
    {}
  ) : e;
}
function ip(e, t) {
  return !e || !t ? e || t : L(e) && L(t) ? e.concat(t) : de({}, Qs(e), Qs(t));
}
let kr = !0;
function bc(e) {
  const t = Xl(e), n = e.proxy, s = e.ctx;
  kr = !1, t.beforeCreate && Wi(t.beforeCreate, e, "bc");
  const {
    // state
    data: r,
    computed: i,
    methods: o,
    watch: l,
    provide: a,
    inject: c,
    // lifecycle
    created: u,
    beforeMount: f,
    mounted: h,
    beforeUpdate: m,
    updated: g,
    activated: v,
    deactivated: M,
    beforeDestroy: S,
    beforeUnmount: P,
    destroyed: $,
    unmounted: T,
    render: F,
    renderTracked: j,
    renderTriggered: Q,
    errorCaptured: q,
    serverPrefetch: x,
    // public API
    expose: k,
    inheritAttrs: W,
    // assets
    components: N,
    directives: Y,
    filters: re
  } = t;
  if (c && _c(c, s, null), o)
    for (const te in o) {
      const J = o[te];
      K(J) && (s[te] = J.bind(n));
    }
  if (r) {
    const te = r.call(n, n);
    oe(te) && (e.data = or(te));
  }
  if (kr = !0, i)
    for (const te in i) {
      const J = i[te], Ie = K(J) ? J.bind(n, n) : K(J.get) ? J.get.bind(n, n) : ht, Fe = !K(J) && K(J.set) ? J.set.bind(n) : ht, me = lf({
        get: Ie,
        set: Fe
      });
      Object.defineProperty(s, te, {
        enumerable: !0,
        configurable: !0,
        get: () => me.value,
        set: (ge) => me.value = ge
      });
    }
  if (l)
    for (const te in l)
      Jl(l[te], s, n, te);
  if (a) {
    const te = K(a) ? a.call(n) : a;
    Reflect.ownKeys(te).forEach((J) => {
      xc(J, te[J]);
    });
  }
  u && Wi(u, e, "c");
  function ue(te, J) {
    L(J) ? J.forEach((Ie) => te(Ie.bind(n))) : J && te(J.bind(n));
  }
  if (ue(uc, f), ue(mi, h), ue(cc, m), ue(fc, g), ue(oc, v), ue(lc, M), ue(mc, q), ue(pc, j), ue(hc, Q), ue(Wl, P), ue(Gl, T), ue(dc, x), L(k))
    if (k.length) {
      const te = e.exposed || (e.exposed = {});
      k.forEach((J) => {
        Object.defineProperty(te, J, {
          get: () => n[J],
          set: (Ie) => n[J] = Ie,
          enumerable: !0
        });
      });
    } else e.exposed || (e.exposed = {});
  F && e.render === ht && (e.render = F), W != null && (e.inheritAttrs = W), N && (e.components = N), Y && (e.directives = Y), x && ql(e);
}
function _c(e, t, n = ht) {
  L(e) && (e = Ur(e));
  for (const s in e) {
    const r = e[s];
    let i;
    oe(r) ? "default" in r ? i = Ns(
      r.from || s,
      r.default,
      !0
    ) : i = Ns(r.from || s) : i = Ns(r), pe(i) ? Object.defineProperty(t, s, {
      enumerable: !0,
      configurable: !0,
      get: () => i.value,
      set: (o) => i.value = o
    }) : t[s] = i;
  }
}
function Wi(e, t, n) {
  nt(
    L(e) ? e.map((s) => s.bind(t.proxy)) : e.bind(t.proxy),
    t,
    n
  );
}
function Jl(e, t, n, s) {
  let r = s.includes(".") ? ua(n, s) : () => n[s];
  if (ce(e)) {
    const i = t[e];
    K(i) && Ut(r, i);
  } else if (K(e))
    Ut(r, e.bind(n));
  else if (oe(e))
    if (L(e))
      e.forEach((i) => Jl(i, t, n, s));
    else {
      const i = K(e.handler) ? e.handler.bind(n) : t[e.handler];
      K(i) && Ut(r, i, e);
    }
}
function Xl(e) {
  const t = e.type, { mixins: n, extends: s } = t, {
    mixins: r,
    optionsCache: i,
    config: { optionMergeStrategies: o }
  } = e.appContext, l = i.get(t);
  let a;
  return l ? a = l : !r.length && !n && !s ? a = t : (a = {}, r.length && r.forEach(
    (c) => qs(a, c, o, !0)
  ), qs(a, t, o)), oe(t) && i.set(t, a), a;
}
function qs(e, t, n, s = !1) {
  const { mixins: r, extends: i } = t;
  i && qs(e, i, n, !0), r && r.forEach(
    (o) => qs(e, o, n, !0)
  );
  for (const o in t)
    if (!(s && o === "expose")) {
      const l = Sc[o] || n && n[o];
      e[o] = l ? l(e[o], t[o]) : t[o];
    }
  return e;
}
const Sc = {
  data: Gi,
  props: zi,
  emits: zi,
  // objects
  methods: Ln,
  computed: Ln,
  // lifecycle
  beforeCreate: Me,
  created: Me,
  beforeMount: Me,
  mounted: Me,
  beforeUpdate: Me,
  updated: Me,
  beforeDestroy: Me,
  beforeUnmount: Me,
  destroyed: Me,
  unmounted: Me,
  activated: Me,
  deactivated: Me,
  errorCaptured: Me,
  serverPrefetch: Me,
  // assets
  components: Ln,
  directives: Ln,
  // watch
  watch: Cc,
  // provide / inject
  provide: Gi,
  inject: wc
};
function Gi(e, t) {
  return t ? e ? function() {
    return de(
      K(e) ? e.call(this, this) : e,
      K(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function wc(e, t) {
  return Ln(Ur(e), Ur(t));
}
function Ur(e) {
  if (L(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++)
      t[e[n]] = e[n];
    return t;
  }
  return e;
}
function Me(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function Ln(e, t) {
  return e ? de(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function zi(e, t) {
  return e ? L(e) && L(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : de(
    /* @__PURE__ */ Object.create(null),
    Qs(e),
    Qs(t != null ? t : {})
  ) : t;
}
function Cc(e, t) {
  if (!e) return t;
  if (!t) return e;
  const n = de(/* @__PURE__ */ Object.create(null), e);
  for (const s in t)
    n[s] = Me(e[s], t[s]);
  return n;
}
function Zl() {
  return {
    app: null,
    config: {
      isNativeTag: ru,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let Oc = 0;
function Tc(e, t) {
  return function(s, r = null) {
    K(s) || (s = de({}, s)), r != null && !oe(r) && (r = null);
    const i = Zl(), o = /* @__PURE__ */ new WeakSet(), l = [];
    let a = !1;
    const c = i.app = {
      _uid: Oc++,
      _component: s,
      _props: r,
      _container: null,
      _context: i,
      _instance: null,
      version: uf,
      get config() {
        return i.config;
      },
      set config(u) {
      },
      use(u, ...f) {
        return o.has(u) || (u && K(u.install) ? (o.add(u), u.install(c, ...f)) : K(u) && (o.add(u), u(c, ...f))), c;
      },
      mixin(u) {
        return i.mixins.includes(u) || i.mixins.push(u), c;
      },
      component(u, f) {
        return f ? (i.components[u] = f, c) : i.components[u];
      },
      directive(u, f) {
        return f ? (i.directives[u] = f, c) : i.directives[u];
      },
      mount(u, f, h) {
        if (!a) {
          const m = c._ceVNode || Ae(s, r);
          return m.appContext = i, h === !0 ? h = "svg" : h === !1 && (h = void 0), e(m, u, h), a = !0, c._container = u, u.__vue_app__ = c, dr(m.component);
        }
      },
      onUnmount(u) {
        l.push(u);
      },
      unmount() {
        a && (nt(
          l,
          c._instance,
          16
        ), e(null, c._container), delete c._container.__vue_app__);
      },
      provide(u, f) {
        return i.provides[u] = f, c;
      },
      runWithContext(u) {
        const f = on;
        on = c;
        try {
          return u();
        } finally {
          on = f;
        }
      }
    };
    return c;
  };
}
let on = null;
function xc(e, t) {
  if (Ee) {
    let n = Ee.provides;
    const s = Ee.parent && Ee.parent.provides;
    s === n && (n = Ee.provides = Object.create(s)), n[e] = t;
  }
}
function Ns(e, t, n = !1) {
  const s = Tt();
  if (s || on) {
    let r = on ? on._context.provides : s ? s.parent == null || s.ce ? s.vnode.appContext && s.vnode.appContext.provides : s.parent.provides : void 0;
    if (r && e in r)
      return r[e];
    if (arguments.length > 1)
      return n && K(t) ? t.call(s && s.proxy) : t;
  }
}
function op() {
  return !!(Tt() || on);
}
const ea = {}, ta = () => Object.create(ea), na = (e) => Object.getPrototypeOf(e) === ea;
function Ec(e, t, n, s = !1) {
  const r = {}, i = ta();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), sa(e, t, r, i);
  for (const o in e.propsOptions[0])
    o in r || (r[o] = void 0);
  n ? e.props = s ? r : Lu(r) : e.type.props ? e.props = r : e.props = i, e.attrs = i;
}
function Ac(e, t, n, s) {
  const {
    props: r,
    attrs: i,
    vnode: { patchFlag: o }
  } = e, l = Z(r), [a] = e.propsOptions;
  let c = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (s || o > 0) && !(o & 16)
  ) {
    if (o & 8) {
      const u = e.vnode.dynamicProps;
      for (let f = 0; f < u.length; f++) {
        let h = u[f];
        if (cr(e.emitsOptions, h))
          continue;
        const m = t[h];
        if (a)
          if (ne(i, h))
            m !== i[h] && (i[h] = m, c = !0);
          else {
            const g = Pe(h);
            r[g] = Hr(
              a,
              l,
              g,
              m,
              e,
              !1
            );
          }
        else
          m !== i[h] && (i[h] = m, c = !0);
      }
    }
  } else {
    sa(e, t, r, i) && (c = !0);
    let u;
    for (const f in l)
      (!t || // for camelCase
      !ne(t, f) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((u = Ue(f)) === f || !ne(t, u))) && (a ? n && // for camelCase
      (n[f] !== void 0 || // for kebab-case
      n[u] !== void 0) && (r[f] = Hr(
        a,
        l,
        f,
        void 0,
        e,
        !0
      )) : delete r[f]);
    if (i !== l)
      for (const f in i)
        (!t || !ne(t, f)) && (delete i[f], c = !0);
  }
  c && _t(e.attrs, "set", "");
}
function sa(e, t, n, s) {
  const [r, i] = e.propsOptions;
  let o = !1, l;
  if (t)
    for (let a in t) {
      if (kn(a))
        continue;
      const c = t[a];
      let u;
      r && ne(r, u = Pe(a)) ? !i || !i.includes(u) ? n[u] = c : (l || (l = {}))[u] = c : cr(e.emitsOptions, a) || (!(a in s) || c !== s[a]) && (s[a] = c, o = !0);
    }
  if (i) {
    const a = Z(n), c = l || ee;
    for (let u = 0; u < i.length; u++) {
      const f = i[u];
      n[f] = Hr(
        r,
        a,
        f,
        c[f],
        e,
        !ne(c, f)
      );
    }
  }
  return o;
}
function Hr(e, t, n, s, r, i) {
  const o = e[n];
  if (o != null) {
    const l = ne(o, "default");
    if (l && s === void 0) {
      const a = o.default;
      if (o.type !== Function && !o.skipFactory && K(a)) {
        const { propsDefaults: c } = r;
        if (n in c)
          s = c[n];
        else {
          const u = hs(r);
          s = c[n] = a.call(
            null,
            t
          ), u();
        }
      } else
        s = a;
      r.ce && r.ce._setProp(n, s);
    }
    o[
      0
      /* shouldCast */
    ] && (i && !l ? s = !1 : o[
      1
      /* shouldCastTrue */
    ] && (s === "" || s === Ue(n)) && (s = !0));
  }
  return s;
}
const Pc = /* @__PURE__ */ new WeakMap();
function ra(e, t, n = !1) {
  const s = n ? Pc : t.propsCache, r = s.get(e);
  if (r)
    return r;
  const i = e.props, o = {}, l = [];
  let a = !1;
  if (!K(e)) {
    const u = (f) => {
      a = !0;
      const [h, m] = ra(f, t, !0);
      de(o, h), m && l.push(...m);
    };
    !n && t.mixins.length && t.mixins.forEach(u), e.extends && u(e.extends), e.mixins && e.mixins.forEach(u);
  }
  if (!i && !a)
    return oe(e) && s.set(e, yn), yn;
  if (L(i))
    for (let u = 0; u < i.length; u++) {
      const f = Pe(i[u]);
      Yi(f) && (o[f] = ee);
    }
  else if (i)
    for (const u in i) {
      const f = Pe(u);
      if (Yi(f)) {
        const h = i[u], m = o[f] = L(h) || K(h) ? { type: h } : de({}, h), g = m.type;
        let v = !1, M = !0;
        if (L(g))
          for (let S = 0; S < g.length; ++S) {
            const P = g[S], $ = K(P) && P.name;
            if ($ === "Boolean") {
              v = !0;
              break;
            } else $ === "String" && (M = !1);
          }
        else
          v = K(g) && g.name === "Boolean";
        m[
          0
          /* shouldCast */
        ] = v, m[
          1
          /* shouldCastTrue */
        ] = M, (v || ne(m, "default")) && l.push(f);
      }
    }
  const c = [o, l];
  return oe(e) && s.set(e, c), c;
}
function Yi(e) {
  return e[0] !== "$" && !kn(e);
}
const vi = (e) => e === "_" || e === "__" || e === "_ctx" || e === "$stable", bi = (e) => L(e) ? e.map(ft) : [ft(e)], Mc = (e, t, n) => {
  if (t._n)
    return t;
  const s = ec((...r) => bi(t(...r)), n);
  return s._c = !1, s;
}, ia = (e, t, n) => {
  const s = e._ctx;
  for (const r in e) {
    if (vi(r)) continue;
    const i = e[r];
    if (K(i))
      t[r] = Mc(r, i, s);
    else if (i != null) {
      const o = bi(i);
      t[r] = () => o;
    }
  }
}, oa = (e, t) => {
  const n = bi(t);
  e.slots.default = () => n;
}, la = (e, t, n) => {
  for (const s in t)
    (n || !vi(s)) && (e[s] = t[s]);
}, Rc = (e, t, n) => {
  const s = e.slots = ta();
  if (e.vnode.shapeFlag & 32) {
    const r = t.__;
    r && Rr(s, "__", r, !0);
    const i = t._;
    i ? (la(s, t, n), n && Rr(s, "_", i, !0)) : ia(t, s);
  } else t && oa(e, t);
}, Dc = (e, t, n) => {
  const { vnode: s, slots: r } = e;
  let i = !0, o = ee;
  if (s.shapeFlag & 32) {
    const l = t._;
    l ? n && l === 1 ? i = !1 : la(r, t, n) : (i = !t.$stable, ia(t, r)), o = t;
  } else t && (oa(e, t), o = { default: 1 });
  if (i)
    for (const l in r)
      !vi(l) && o[l] == null && delete r[l];
}, De = Bc;
function Nc(e) {
  return $c(e);
}
function $c(e, t) {
  const n = sr();
  n.__VUE__ = !0;
  const {
    insert: s,
    remove: r,
    patchProp: i,
    createElement: o,
    createText: l,
    createComment: a,
    setText: c,
    setElementText: u,
    parentNode: f,
    nextSibling: h,
    setScopeId: m = ht,
    insertStaticContent: g
  } = e, v = (d, p, y, C = null, _ = null, w = null, R = void 0, A = null, E = !!p.dynamicChildren) => {
    if (d === p)
      return;
    d && !Zt(d, p) && (C = cn(d), ge(d, _, w, !0), d = null), p.patchFlag === -2 && (E = !1, p.dynamicChildren = null);
    const { type: O, ref: H, shapeFlag: D } = p;
    switch (O) {
      case fr:
        M(d, p, y, C);
        break;
      case xe:
        S(d, p, y, C);
        break;
      case $s:
        d == null && P(p, y, C, R);
        break;
      case Ke:
        N(
          d,
          p,
          y,
          C,
          _,
          w,
          R,
          A,
          E
        );
        break;
      default:
        D & 1 ? F(
          d,
          p,
          y,
          C,
          _,
          w,
          R,
          A,
          E
        ) : D & 6 ? Y(
          d,
          p,
          y,
          C,
          _,
          w,
          R,
          A,
          E
        ) : (D & 64 || D & 128) && O.process(
          d,
          p,
          y,
          C,
          _,
          w,
          R,
          A,
          E,
          Wt
        );
    }
    H != null && _ ? Qn(H, d && d.ref, w, p || d, !p) : H == null && d && d.ref != null && Qn(d.ref, null, w, d, !0);
  }, M = (d, p, y, C) => {
    if (d == null)
      s(
        p.el = l(p.children),
        y,
        C
      );
    else {
      const _ = p.el = d.el;
      p.children !== d.children && c(_, p.children);
    }
  }, S = (d, p, y, C) => {
    d == null ? s(
      p.el = a(p.children || ""),
      y,
      C
    ) : p.el = d.el;
  }, P = (d, p, y, C) => {
    [d.el, d.anchor] = g(
      d.children,
      p,
      y,
      C,
      d.el,
      d.anchor
    );
  }, $ = ({ el: d, anchor: p }, y, C) => {
    let _;
    for (; d && d !== p; )
      _ = h(d), s(d, y, C), d = _;
    s(p, y, C);
  }, T = ({ el: d, anchor: p }) => {
    let y;
    for (; d && d !== p; )
      y = h(d), r(d), d = y;
    r(p);
  }, F = (d, p, y, C, _, w, R, A, E) => {
    p.type === "svg" ? R = "svg" : p.type === "math" && (R = "mathml"), d == null ? j(
      p,
      y,
      C,
      _,
      w,
      R,
      A,
      E
    ) : x(
      d,
      p,
      _,
      w,
      R,
      A,
      E
    );
  }, j = (d, p, y, C, _, w, R, A) => {
    let E, O;
    const { props: H, shapeFlag: D, transition: U, dirs: V } = d;
    if (E = d.el = o(
      d.type,
      w,
      H && H.is,
      H
    ), D & 8 ? u(E, d.children) : D & 16 && q(
      d.children,
      E,
      null,
      C,
      _,
      Cr(d, w),
      R,
      A
    ), V && Gt(d, null, C, "created"), Q(E, d, d.scopeId, R, C), H) {
      for (const le in H)
        le !== "value" && !kn(le) && i(E, le, null, H[le], w, C);
      "value" in H && i(E, "value", null, H.value, w), (O = H.onVnodeBeforeMount) && ot(O, C, d);
    }
    V && Gt(d, null, C, "beforeMount");
    const z = Ic(_, U);
    z && U.beforeEnter(E), s(E, p, y), ((O = H && H.onVnodeMounted) || z || V) && De(() => {
      O && ot(O, C, d), z && U.enter(E), V && Gt(d, null, C, "mounted");
    }, _);
  }, Q = (d, p, y, C, _) => {
    if (y && m(d, y), C)
      for (let w = 0; w < C.length; w++)
        m(d, C[w]);
    if (_) {
      let w = _.subTree;
      if (p === w || da(w.type) && (w.ssContent === p || w.ssFallback === p)) {
        const R = _.vnode;
        Q(
          d,
          R,
          R.scopeId,
          R.slotScopeIds,
          _.parent
        );
      }
    }
  }, q = (d, p, y, C, _, w, R, A, E = 0) => {
    for (let O = E; O < d.length; O++) {
      const H = d[O] = A ? Nt(d[O]) : ft(d[O]);
      v(
        null,
        H,
        p,
        y,
        C,
        _,
        w,
        R,
        A
      );
    }
  }, x = (d, p, y, C, _, w, R) => {
    const A = p.el = d.el;
    let { patchFlag: E, dynamicChildren: O, dirs: H } = p;
    E |= d.patchFlag & 16;
    const D = d.props || ee, U = p.props || ee;
    let V;
    if (y && zt(y, !1), (V = U.onVnodeBeforeUpdate) && ot(V, y, p, d), H && Gt(p, d, y, "beforeUpdate"), y && zt(y, !0), (D.innerHTML && U.innerHTML == null || D.textContent && U.textContent == null) && u(A, ""), O ? k(
      d.dynamicChildren,
      O,
      A,
      y,
      C,
      Cr(p, _),
      w
    ) : R || J(
      d,
      p,
      A,
      null,
      y,
      C,
      Cr(p, _),
      w,
      !1
    ), E > 0) {
      if (E & 16)
        W(A, D, U, y, _);
      else if (E & 2 && D.class !== U.class && i(A, "class", null, U.class, _), E & 4 && i(A, "style", D.style, U.style, _), E & 8) {
        const z = p.dynamicProps;
        for (let le = 0; le < z.length; le++) {
          const se = z[le], je = D[se], Le = U[se];
          (Le !== je || se === "value") && i(A, se, je, Le, _, y);
        }
      }
      E & 1 && d.children !== p.children && u(A, p.children);
    } else !R && O == null && W(A, D, U, y, _);
    ((V = U.onVnodeUpdated) || H) && De(() => {
      V && ot(V, y, p, d), H && Gt(p, d, y, "updated");
    }, C);
  }, k = (d, p, y, C, _, w, R) => {
    for (let A = 0; A < p.length; A++) {
      const E = d[A], O = p[A], H = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        E.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (E.type === Ke || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Zt(E, O) || // - In the case of a component, it could contain anything.
        E.shapeFlag & 198) ? f(E.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          y
        )
      );
      v(
        E,
        O,
        H,
        null,
        C,
        _,
        w,
        R,
        !0
      );
    }
  }, W = (d, p, y, C, _) => {
    if (p !== y) {
      if (p !== ee)
        for (const w in p)
          !kn(w) && !(w in y) && i(
            d,
            w,
            p[w],
            null,
            _,
            C
          );
      for (const w in y) {
        if (kn(w)) continue;
        const R = y[w], A = p[w];
        R !== A && w !== "value" && i(d, w, A, R, _, C);
      }
      "value" in y && i(d, "value", p.value, y.value, _);
    }
  }, N = (d, p, y, C, _, w, R, A, E) => {
    const O = p.el = d ? d.el : l(""), H = p.anchor = d ? d.anchor : l("");
    let { patchFlag: D, dynamicChildren: U, slotScopeIds: V } = p;
    V && (A = A ? A.concat(V) : V), d == null ? (s(O, y, C), s(H, y, C), q(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      p.children || [],
      y,
      H,
      _,
      w,
      R,
      A,
      E
    )) : D > 0 && D & 64 && U && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    d.dynamicChildren ? (k(
      d.dynamicChildren,
      U,
      y,
      _,
      w,
      R,
      A
    ), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (p.key != null || _ && p === _.subTree) && _i(
      d,
      p,
      !0
      /* shallow */
    )) : J(
      d,
      p,
      y,
      H,
      _,
      w,
      R,
      A,
      E
    );
  }, Y = (d, p, y, C, _, w, R, A, E) => {
    p.slotScopeIds = A, d == null ? p.shapeFlag & 512 ? _.ctx.activate(
      p,
      y,
      C,
      R,
      E
    ) : re(
      p,
      y,
      C,
      _,
      w,
      R,
      E
    ) : ye(d, p, E);
  }, re = (d, p, y, C, _, w, R) => {
    const A = d.component = ef(
      d,
      C,
      _
    );
    if (ar(d) && (A.ctx.renderer = Wt), tf(A, !1, R), A.asyncDep) {
      if (_ && _.registerDep(A, ue, R), !d.el) {
        const E = A.subTree = Ae(xe);
        S(null, E, p, y), d.placeholder = E.el;
      }
    } else
      ue(
        A,
        d,
        p,
        y,
        _,
        w,
        R
      );
  }, ye = (d, p, y) => {
    const C = p.component = d.component;
    if (Qc(d, p, y))
      if (C.asyncDep && !C.asyncResolved) {
        te(C, p, y);
        return;
      } else
        C.next = p, C.update();
    else
      p.el = d.el, C.vnode = p;
  }, ue = (d, p, y, C, _, w, R) => {
    const A = () => {
      if (d.isMounted) {
        let { next: D, bu: U, u: V, parent: z, vnode: le } = d;
        {
          const rt = aa(d);
          if (rt) {
            D && (D.el = le.el, te(d, D, R)), rt.asyncDep.then(() => {
              d.isUnmounted || A();
            });
            return;
          }
        }
        let se = D, je;
        zt(d, !1), D ? (D.el = le.el, te(d, D, R)) : D = le, U && Rs(U), (je = D.props && D.props.onVnodeBeforeUpdate) && ot(je, z, D, le), zt(d, !0);
        const Le = Xi(d), st = d.subTree;
        d.subTree = Le, v(
          st,
          Le,
          // parent may have changed if it's in a teleport
          f(st.el),
          // anchor may have changed if it's in a fragment
          cn(st),
          d,
          _,
          w
        ), D.el = Le.el, se === null && qc(d, Le.el), V && De(V, _), (je = D.props && D.props.onVnodeUpdated) && De(
          () => ot(je, z, D, le),
          _
        );
      } else {
        let D;
        const { el: U, props: V } = p, { bm: z, m: le, parent: se, root: je, type: Le } = d, st = Sn(p);
        zt(d, !1), z && Rs(z), !st && (D = V && V.onVnodeBeforeMount) && ot(D, se, p), zt(d, !0);
        {
          je.ce && // @ts-expect-error _def is private
          je.ce._def.shadowRoot !== !1 && je.ce._injectChildStyle(Le);
          const rt = d.subTree = Xi(d);
          v(
            null,
            rt,
            y,
            C,
            d,
            _,
            w
          ), p.el = rt.el;
        }
        if (le && De(le, _), !st && (D = V && V.onVnodeMounted)) {
          const rt = p;
          De(
            () => ot(D, se, rt),
            _
          );
        }
        (p.shapeFlag & 256 || se && Sn(se.vnode) && se.vnode.shapeFlag & 256) && d.a && De(d.a, _), d.isMounted = !0, p = y = C = null;
      }
    };
    d.scope.on();
    const E = d.effect = new ml(A);
    d.scope.off();
    const O = d.update = E.run.bind(E), H = d.job = E.runIfDirty.bind(E);
    H.i = d, H.id = d.uid, E.scheduler = () => pi(H), zt(d, !0), O();
  }, te = (d, p, y) => {
    p.component = d;
    const C = d.vnode.props;
    d.vnode = p, d.next = null, Ac(d, p.props, C, y), Dc(d, p.children, y), Ct(), Hi(d), Ot();
  }, J = (d, p, y, C, _, w, R, A, E = !1) => {
    const O = d && d.children, H = d ? d.shapeFlag : 0, D = p.children, { patchFlag: U, shapeFlag: V } = p;
    if (U > 0) {
      if (U & 128) {
        Fe(
          O,
          D,
          y,
          C,
          _,
          w,
          R,
          A,
          E
        );
        return;
      } else if (U & 256) {
        Ie(
          O,
          D,
          y,
          C,
          _,
          w,
          R,
          A,
          E
        );
        return;
      }
    }
    V & 8 ? (H & 16 && At(O, _, w), D !== O && u(y, D)) : H & 16 ? V & 16 ? Fe(
      O,
      D,
      y,
      C,
      _,
      w,
      R,
      A,
      E
    ) : At(O, _, w, !0) : (H & 8 && u(y, ""), V & 16 && q(
      D,
      y,
      C,
      _,
      w,
      R,
      A,
      E
    ));
  }, Ie = (d, p, y, C, _, w, R, A, E) => {
    d = d || yn, p = p || yn;
    const O = d.length, H = p.length, D = Math.min(O, H);
    let U;
    for (U = 0; U < D; U++) {
      const V = p[U] = E ? Nt(p[U]) : ft(p[U]);
      v(
        d[U],
        V,
        y,
        null,
        _,
        w,
        R,
        A,
        E
      );
    }
    O > H ? At(
      d,
      _,
      w,
      !0,
      !1,
      D
    ) : q(
      p,
      y,
      C,
      _,
      w,
      R,
      A,
      E,
      D
    );
  }, Fe = (d, p, y, C, _, w, R, A, E) => {
    let O = 0;
    const H = p.length;
    let D = d.length - 1, U = H - 1;
    for (; O <= D && O <= U; ) {
      const V = d[O], z = p[O] = E ? Nt(p[O]) : ft(p[O]);
      if (Zt(V, z))
        v(
          V,
          z,
          y,
          null,
          _,
          w,
          R,
          A,
          E
        );
      else
        break;
      O++;
    }
    for (; O <= D && O <= U; ) {
      const V = d[D], z = p[U] = E ? Nt(p[U]) : ft(p[U]);
      if (Zt(V, z))
        v(
          V,
          z,
          y,
          null,
          _,
          w,
          R,
          A,
          E
        );
      else
        break;
      D--, U--;
    }
    if (O > D) {
      if (O <= U) {
        const V = U + 1, z = V < H ? p[V].el : C;
        for (; O <= U; )
          v(
            null,
            p[O] = E ? Nt(p[O]) : ft(p[O]),
            y,
            z,
            _,
            w,
            R,
            A,
            E
          ), O++;
      }
    } else if (O > U)
      for (; O <= D; )
        ge(d[O], _, w, !0), O++;
    else {
      const V = O, z = O, le = /* @__PURE__ */ new Map();
      for (O = z; O <= U; O++) {
        const He = p[O] = E ? Nt(p[O]) : ft(p[O]);
        He.key != null && le.set(He.key, O);
      }
      let se, je = 0;
      const Le = U - z + 1;
      let st = !1, rt = 0;
      const $n = new Array(Le);
      for (O = 0; O < Le; O++) $n[O] = 0;
      for (O = V; O <= D; O++) {
        const He = d[O];
        if (je >= Le) {
          ge(He, _, w, !0);
          continue;
        }
        let it;
        if (He.key != null)
          it = le.get(He.key);
        else
          for (se = z; se <= U; se++)
            if ($n[se - z] === 0 && Zt(He, p[se])) {
              it = se;
              break;
            }
        it === void 0 ? ge(He, _, w, !0) : ($n[it - z] = O + 1, it >= rt ? rt = it : st = !0, v(
          He,
          p[it],
          y,
          null,
          _,
          w,
          R,
          A,
          E
        ), je++);
      }
      const Pi = st ? Fc($n) : yn;
      for (se = Pi.length - 1, O = Le - 1; O >= 0; O--) {
        const He = z + O, it = p[He], Mi = p[He + 1], Ri = He + 1 < H ? (
          // #13559, fallback to el placeholder for unresolved async component
          Mi.el || Mi.placeholder
        ) : C;
        $n[O] === 0 ? v(
          null,
          it,
          y,
          Ri,
          _,
          w,
          R,
          A,
          E
        ) : st && (se < 0 || O !== Pi[se] ? me(it, y, Ri, 2) : se--);
      }
    }
  }, me = (d, p, y, C, _ = null) => {
    const { el: w, type: R, transition: A, children: E, shapeFlag: O } = d;
    if (O & 6) {
      me(d.component.subTree, p, y, C);
      return;
    }
    if (O & 128) {
      d.suspense.move(p, y, C);
      return;
    }
    if (O & 64) {
      R.move(d, p, y, Wt);
      return;
    }
    if (R === Ke) {
      s(w, p, y);
      for (let D = 0; D < E.length; D++)
        me(E[D], p, y, C);
      s(d.anchor, p, y);
      return;
    }
    if (R === $s) {
      $(d, p, y);
      return;
    }
    if (C !== 2 && O & 1 && A)
      if (C === 0)
        A.beforeEnter(w), s(w, p, y), De(() => A.enter(w), _);
      else {
        const { leave: D, delayLeave: U, afterLeave: V } = A, z = () => {
          d.ctx.isUnmounted ? r(w) : s(w, p, y);
        }, le = () => {
          D(w, () => {
            z(), V && V();
          });
        };
        U ? U(w, z, le) : le();
      }
    else
      s(w, p, y);
  }, ge = (d, p, y, C = !1, _ = !1) => {
    const {
      type: w,
      props: R,
      ref: A,
      children: E,
      dynamicChildren: O,
      shapeFlag: H,
      patchFlag: D,
      dirs: U,
      cacheIndex: V
    } = d;
    if (D === -2 && (_ = !1), A != null && (Ct(), Qn(A, null, y, d, !0), Ot()), V != null && (p.renderCache[V] = void 0), H & 256) {
      p.ctx.deactivate(d);
      return;
    }
    const z = H & 1 && U, le = !Sn(d);
    let se;
    if (le && (se = R && R.onVnodeBeforeUnmount) && ot(se, p, d), H & 6)
      gs(d.component, y, C);
    else {
      if (H & 128) {
        d.suspense.unmount(y, C);
        return;
      }
      z && Gt(d, null, p, "beforeUnmount"), H & 64 ? d.type.remove(
        d,
        p,
        y,
        Wt,
        C
      ) : O && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !O.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (w !== Ke || D > 0 && D & 64) ? At(
        O,
        p,
        y,
        !1,
        !0
      ) : (w === Ke && D & 384 || !_ && H & 16) && At(E, p, y), C && Bt(d);
    }
    (le && (se = R && R.onVnodeUnmounted) || z) && De(() => {
      se && ot(se, p, d), z && Gt(d, null, p, "unmounted");
    }, y);
  }, Bt = (d) => {
    const { type: p, el: y, anchor: C, transition: _ } = d;
    if (p === Ke) {
      Et(y, C);
      return;
    }
    if (p === $s) {
      T(d);
      return;
    }
    const w = () => {
      r(y), _ && !_.persisted && _.afterLeave && _.afterLeave();
    };
    if (d.shapeFlag & 1 && _ && !_.persisted) {
      const { leave: R, delayLeave: A } = _, E = () => R(y, w);
      A ? A(d.el, w, E) : E();
    } else
      w();
  }, Et = (d, p) => {
    let y;
    for (; d !== p; )
      y = h(d), r(d), d = y;
    r(p);
  }, gs = (d, p, y) => {
    const {
      bum: C,
      scope: _,
      job: w,
      subTree: R,
      um: A,
      m: E,
      a: O,
      parent: H,
      slots: { __: D }
    } = d;
    Ji(E), Ji(O), C && Rs(C), H && L(D) && D.forEach((U) => {
      H.renderCache[U] = void 0;
    }), _.stop(), w && (w.flags |= 8, ge(R, d, p, y)), A && De(A, p), De(() => {
      d.isUnmounted = !0;
    }, p), p && p.pendingBranch && !p.isUnmounted && d.asyncDep && !d.asyncResolved && d.suspenseId === p.pendingId && (p.deps--, p.deps === 0 && p.resolve());
  }, At = (d, p, y, C = !1, _ = !1, w = 0) => {
    for (let R = w; R < d.length; R++)
      ge(d[R], p, y, C, _);
  }, cn = (d) => {
    if (d.shapeFlag & 6)
      return cn(d.component.subTree);
    if (d.shapeFlag & 128)
      return d.suspense.next();
    const p = h(d.anchor || d.el), y = p && p[Fl];
    return y ? h(y) : p;
  };
  let Nn = !1;
  const ys = (d, p, y) => {
    d == null ? p._vnode && ge(p._vnode, null, null, !0) : v(
      p._vnode || null,
      d,
      p,
      null,
      null,
      null,
      y
    ), p._vnode = d, Nn || (Nn = !0, Hi(), Nl(), Nn = !1);
  }, Wt = {
    p: v,
    um: ge,
    m: me,
    r: Bt,
    mt: re,
    mc: q,
    pc: J,
    pbc: k,
    n: cn,
    o: e
  };
  return {
    render: ys,
    hydrate: void 0,
    createApp: Tc(ys)
  };
}
function Cr({ type: e, props: t }, n) {
  return n === "svg" && e === "foreignObject" || n === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : n;
}
function zt({ effect: e, job: t }, n) {
  n ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function Ic(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function _i(e, t, n = !1) {
  const s = e.children, r = t.children;
  if (L(s) && L(r))
    for (let i = 0; i < s.length; i++) {
      const o = s[i];
      let l = r[i];
      l.shapeFlag & 1 && !l.dynamicChildren && ((l.patchFlag <= 0 || l.patchFlag === 32) && (l = r[i] = Nt(r[i]), l.el = o.el), !n && l.patchFlag !== -2 && _i(o, l)), l.type === fr && (l.el = o.el), l.type === xe && !l.el && (l.el = o.el);
    }
}
function Fc(e) {
  const t = e.slice(), n = [0];
  let s, r, i, o, l;
  const a = e.length;
  for (s = 0; s < a; s++) {
    const c = e[s];
    if (c !== 0) {
      if (r = n[n.length - 1], e[r] < c) {
        t[s] = r, n.push(s);
        continue;
      }
      for (i = 0, o = n.length - 1; i < o; )
        l = i + o >> 1, e[n[l]] < c ? i = l + 1 : o = l;
      c < e[n[i]] && (i > 0 && (t[s] = n[i - 1]), n[i] = s);
    }
  }
  for (i = n.length, o = n[i - 1]; i-- > 0; )
    n[i] = o, o = t[o];
  return n;
}
function aa(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : aa(t);
}
function Ji(e) {
  if (e)
    for (let t = 0; t < e.length; t++)
      e[t].flags |= 8;
}
const jc = Symbol.for("v-scx"), Lc = () => Ns(jc);
function kc(e, t) {
  return Si(
    e,
    null,
    { flush: "sync" }
  );
}
function Ut(e, t, n) {
  return Si(e, t, n);
}
function Si(e, t, n = ee) {
  const { immediate: s, deep: r, flush: i, once: o } = n, l = de({}, n), a = t && s || !t && i !== "post";
  let c;
  if (es) {
    if (i === "sync") {
      const m = Lc();
      c = m.__watcherHandles || (m.__watcherHandles = []);
    } else if (!a) {
      const m = () => {
      };
      return m.stop = ht, m.resume = ht, m.pause = ht, m;
    }
  }
  const u = Ee;
  l.call = (m, g, v) => nt(m, u, g, v);
  let f = !1;
  i === "post" ? l.scheduler = (m) => {
    De(m, u && u.suspense);
  } : i !== "sync" && (f = !0, l.scheduler = (m, g) => {
    g ? m() : pi(m);
  }), l.augmentJob = (m) => {
    t && (m.flags |= 4), f && (m.flags |= 2, u && (m.id = u.uid, m.i = u));
  };
  const h = Yu(e, t, l);
  return es && (c ? c.push(h) : a && h()), h;
}
function Uc(e, t, n) {
  const s = this.proxy, r = ce(e) ? e.includes(".") ? ua(s, e) : () => s[e] : e.bind(s, s);
  let i;
  K(t) ? i = t : (i = t.handler, n = t);
  const o = hs(this), l = Si(r, i.bind(s), n);
  return o(), l;
}
function ua(e, t) {
  const n = t.split(".");
  return () => {
    let s = e;
    for (let r = 0; r < n.length && s; r++)
      s = s[n[r]];
    return s;
  };
}
function lp(e, t, n = ee) {
  const s = Tt(), r = Pe(t), i = Ue(t), o = ca(e, r), l = Qu((a, c) => {
    let u, f = ee, h;
    return kc(() => {
      const m = e[r];
      ke(u, m) && (u = m, c());
    }), {
      get() {
        return a(), n.get ? n.get(u) : u;
      },
      set(m) {
        const g = n.set ? n.set(m) : m;
        if (!ke(g, u) && !(f !== ee && ke(m, f)))
          return;
        const v = s.vnode.props;
        v && // check if parent has passed v-model
        (t in v || r in v || i in v) && (`onUpdate:${t}` in v || `onUpdate:${r}` in v || `onUpdate:${i}` in v) || (u = m, c()), s.emit(`update:${t}`, g), ke(m, g) && ke(m, f) && !ke(g, h) && c(), f = m, h = g;
      }
    };
  });
  return l[Symbol.iterator] = () => {
    let a = 0;
    return {
      next() {
        return a < 2 ? { value: a++ ? o || ee : l, done: !1 } : { done: !0 };
      }
    };
  }, l;
}
const ca = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${Pe(t)}Modifiers`] || e[`${Ue(t)}Modifiers`];
function Hc(e, t, ...n) {
  if (e.isUnmounted) return;
  const s = e.vnode.props || ee;
  let r = n;
  const i = t.startsWith("update:"), o = i && ca(s, t.slice(7));
  o && (o.trim && (r = n.map((u) => ce(u) ? u.trim() : u)), o.number && (r = n.map(Ls)));
  let l, a = s[l = gr(t)] || // also try camelCase event handler (#2249)
  s[l = gr(Pe(t))];
  !a && i && (a = s[l = gr(Ue(t))]), a && nt(
    a,
    e,
    6,
    r
  );
  const c = s[l + "Once"];
  if (c) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[l])
      return;
    e.emitted[l] = !0, nt(
      c,
      e,
      6,
      r
    );
  }
}
function fa(e, t, n = !1) {
  const s = t.emitsCache, r = s.get(e);
  if (r !== void 0)
    return r;
  const i = e.emits;
  let o = {}, l = !1;
  if (!K(e)) {
    const a = (c) => {
      const u = fa(c, t, !0);
      u && (l = !0, de(o, u));
    };
    !n && t.mixins.length && t.mixins.forEach(a), e.extends && a(e.extends), e.mixins && e.mixins.forEach(a);
  }
  return !i && !l ? (oe(e) && s.set(e, null), null) : (L(i) ? i.forEach((a) => o[a] = null) : de(o, i), oe(e) && s.set(e, o), o);
}
function cr(e, t) {
  return !e || !Zs(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), ne(e, t[0].toLowerCase() + t.slice(1)) || ne(e, Ue(t)) || ne(e, t));
}
function Xi(e) {
  const {
    type: t,
    vnode: n,
    proxy: s,
    withProxy: r,
    propsOptions: [i],
    slots: o,
    attrs: l,
    emit: a,
    render: c,
    renderCache: u,
    props: f,
    data: h,
    setupState: m,
    ctx: g,
    inheritAttrs: v
  } = e, M = Ks(e);
  let S, P;
  try {
    if (n.shapeFlag & 4) {
      const T = r || s, F = T;
      S = ft(
        c.call(
          F,
          T,
          u,
          f,
          m,
          h,
          g
        )
      ), P = l;
    } else {
      const T = t;
      S = ft(
        T.length > 1 ? T(
          f,
          { attrs: l, slots: o, emit: a }
        ) : T(
          f,
          null
        )
      ), P = t.props ? l : Vc(l);
    }
  } catch (T) {
    Bn.length = 0, lr(T, e, 1), S = Ae(xe);
  }
  let $ = S;
  if (P && v !== !1) {
    const T = Object.keys(P), { shapeFlag: F } = $;
    T.length && F & 7 && (i && T.some(ei) && (P = Kc(
      P,
      i
    )), $ = Kt($, P, !1, !0));
  }
  return n.dirs && ($ = Kt($, null, !1, !0), $.dirs = $.dirs ? $.dirs.concat(n.dirs) : n.dirs), n.transition && Jn($, n.transition), S = $, Ks(M), S;
}
const Vc = (e) => {
  let t;
  for (const n in e)
    (n === "class" || n === "style" || Zs(n)) && ((t || (t = {}))[n] = e[n]);
  return t;
}, Kc = (e, t) => {
  const n = {};
  for (const s in e)
    (!ei(s) || !(s.slice(9) in t)) && (n[s] = e[s]);
  return n;
};
function Qc(e, t, n) {
  const { props: s, children: r, component: i } = e, { props: o, children: l, patchFlag: a } = t, c = i.emitsOptions;
  if (t.dirs || t.transition)
    return !0;
  if (n && a >= 0) {
    if (a & 1024)
      return !0;
    if (a & 16)
      return s ? Zi(s, o, c) : !!o;
    if (a & 8) {
      const u = t.dynamicProps;
      for (let f = 0; f < u.length; f++) {
        const h = u[f];
        if (o[h] !== s[h] && !cr(c, h))
          return !0;
      }
    }
  } else
    return (r || l) && (!l || !l.$stable) ? !0 : s === o ? !1 : s ? o ? Zi(s, o, c) : !0 : !!o;
  return !1;
}
function Zi(e, t, n) {
  const s = Object.keys(t);
  if (s.length !== Object.keys(e).length)
    return !0;
  for (let r = 0; r < s.length; r++) {
    const i = s[r];
    if (t[i] !== e[i] && !cr(n, i))
      return !0;
  }
  return !1;
}
function qc({ vnode: e, parent: t }, n) {
  for (; t; ) {
    const s = t.subTree;
    if (s.suspense && s.suspense.activeBranch === e && (s.el = e.el), s === e)
      (e = t.vnode).el = n, t = t.parent;
    else
      break;
  }
}
const da = (e) => e.__isSuspense;
function Bc(e, t) {
  t && t.pendingBranch ? L(e) ? t.effects.push(...e) : t.effects.push(e) : Zu(e);
}
const Ke = Symbol.for("v-fgt"), fr = Symbol.for("v-txt"), xe = Symbol.for("v-cmt"), $s = Symbol.for("v-stc"), Bn = [];
let Qe = null;
function Vr(e = !1) {
  Bn.push(Qe = e ? null : []);
}
function Wc() {
  Bn.pop(), Qe = Bn[Bn.length - 1] || null;
}
let Xn = 1;
function eo(e, t = !1) {
  Xn += e, e < 0 && Qe && t && (Qe.hasOnce = !0);
}
function ha(e) {
  return e.dynamicChildren = Xn > 0 ? Qe || yn : null, Wc(), Xn > 0 && Qe && Qe.push(e), e;
}
function ap(e, t, n, s, r, i) {
  return ha(
    ma(
      e,
      t,
      n,
      s,
      r,
      i,
      !0
    )
  );
}
function Kr(e, t, n, s, r) {
  return ha(
    Ae(
      e,
      t,
      n,
      s,
      r,
      !0
    )
  );
}
function Zn(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Zt(e, t) {
  return e.type === t.type && e.key === t.key;
}
const pa = ({ key: e }) => e != null ? e : null, Is = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? ce(e) || pe(e) || K(e) ? { i: be, r: e, k: t, f: !!n } : e : null);
function ma(e, t = null, n = null, s = 0, r = null, i = e === Ke ? 0 : 1, o = !1, l = !1) {
  const a = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && pa(t),
    ref: t && Is(t),
    scopeId: Il,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: i,
    patchFlag: s,
    dynamicProps: r,
    dynamicChildren: null,
    appContext: null,
    ctx: be
  };
  return l ? (wi(a, n), i & 128 && e.normalize(a)) : n && (a.shapeFlag |= ce(n) ? 8 : 16), Xn > 0 && // avoid a block node from tracking itself
  !o && // has current parent block
  Qe && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (a.patchFlag > 0 || i & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  a.patchFlag !== 32 && Qe.push(a), a;
}
const Ae = Gc;
function Gc(e, t = null, n = null, s = 0, r = null, i = !1) {
  if ((!e || e === zl) && (e = xe), Zn(e)) {
    const l = Kt(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && wi(l, n), Xn > 0 && !i && Qe && (l.shapeFlag & 6 ? Qe[Qe.indexOf(e)] = l : Qe.push(l)), l.patchFlag = -2, l;
  }
  if (of(e) && (e = e.__vccOpts), t) {
    t = zc(t);
    let { class: l, style: a } = t;
    l && !ce(l) && (t.class = ri(l)), oe(a) && (di(a) && !L(a) && (a = de({}, a)), t.style = si(a));
  }
  const o = ce(e) ? 1 : da(e) ? 128 : jl(e) ? 64 : oe(e) ? 4 : K(e) ? 2 : 0;
  return ma(
    e,
    t,
    n,
    s,
    r,
    o,
    i,
    !0
  );
}
function zc(e) {
  return e ? di(e) || na(e) ? de({}, e) : e : null;
}
function Kt(e, t, n = !1, s = !1) {
  const { props: r, ref: i, patchFlag: o, children: l, transition: a } = e, c = t ? Jc(r || {}, t) : r, u = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: c,
    key: c && pa(c),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && i ? L(i) ? i.concat(Is(t)) : [i, Is(t)] : Is(t)
    ) : i,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: l,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== Ke ? o === -1 ? 16 : o | 16 : o,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: a,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && Kt(e.ssContent),
    ssFallback: e.ssFallback && Kt(e.ssFallback),
    placeholder: e.placeholder,
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return a && s && Jn(
    u,
    a.clone(u)
  ), u;
}
function Yc(e = " ", t = 0) {
  return Ae(fr, null, e, t);
}
function up(e, t) {
  const n = Ae($s, null, e);
  return n.staticCount = t, n;
}
function cp(e = "", t = !1) {
  return t ? (Vr(), Kr(xe, null, e)) : Ae(xe, null, e);
}
function ft(e) {
  return e == null || typeof e == "boolean" ? Ae(xe) : L(e) ? Ae(
    Ke,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : Zn(e) ? Nt(e) : Ae(fr, null, String(e));
}
function Nt(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : Kt(e);
}
function wi(e, t) {
  let n = 0;
  const { shapeFlag: s } = e;
  if (t == null)
    t = null;
  else if (L(t))
    n = 16;
  else if (typeof t == "object")
    if (s & 65) {
      const r = t.default;
      r && (r._c && (r._d = !1), wi(e, r()), r._c && (r._d = !0));
      return;
    } else {
      n = 32;
      const r = t._;
      !r && !na(t) ? t._ctx = be : r === 3 && be && (be.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else K(t) ? (t = { default: t, _ctx: be }, n = 32) : (t = String(t), s & 64 ? (n = 16, t = [Yc(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function Jc(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    for (const r in s)
      if (r === "class")
        t.class !== s.class && (t.class = ri([t.class, s.class]));
      else if (r === "style")
        t.style = si([t.style, s.style]);
      else if (Zs(r)) {
        const i = t[r], o = s[r];
        o && i !== o && !(L(i) && i.includes(o)) && (t[r] = i ? [].concat(i, o) : o);
      } else r !== "" && (t[r] = s[r]);
  }
  return t;
}
function ot(e, t, n, s = null) {
  nt(e, t, 7, [
    n,
    s
  ]);
}
const Xc = Zl();
let Zc = 0;
function ef(e, t, n) {
  const s = e.type, r = (t ? t.appContext : e.appContext) || Xc, i = {
    uid: Zc++,
    vnode: e,
    type: s,
    parent: t,
    appContext: r,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new yu(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(r.provides),
    ids: t ? t.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: ra(s, r),
    emitsOptions: fa(s, r),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: ee,
    // inheritAttrs
    inheritAttrs: s.inheritAttrs,
    // state
    ctx: ee,
    data: ee,
    props: ee,
    attrs: ee,
    slots: ee,
    refs: ee,
    setupState: ee,
    setupContext: null,
    // suspense related
    suspense: n,
    suspenseId: n ? n.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return i.ctx = { _: i }, i.root = t ? t.root : i, i.emit = Hc.bind(null, i), e.ce && e.ce(i), i;
}
let Ee = null;
const Tt = () => Ee || be;
let Bs, Qr;
{
  const e = sr(), t = (n, s) => {
    let r;
    return (r = e[n]) || (r = e[n] = []), r.push(s), (i) => {
      r.length > 1 ? r.forEach((o) => o(i)) : r[0](i);
    };
  };
  Bs = t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => Ee = n
  ), Qr = t(
    "__VUE_SSR_SETTERS__",
    (n) => es = n
  );
}
const hs = (e) => {
  const t = Ee;
  return Bs(e), e.scope.on(), () => {
    e.scope.off(), Bs(t);
  };
}, to = () => {
  Ee && Ee.scope.off(), Bs(null);
};
function ga(e) {
  return e.vnode.shapeFlag & 4;
}
let es = !1;
function tf(e, t = !1, n = !1) {
  t && Qr(t);
  const { props: s, children: r } = e.vnode, i = ga(e);
  Ec(e, s, i, t), Rc(e, r, n || t);
  const o = i ? nf(e, t) : void 0;
  return t && Qr(!1), o;
}
function nf(e, t) {
  const n = e.type;
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, yc);
  const { setup: s } = n;
  if (s) {
    Ct();
    const r = e.setupContext = s.length > 1 ? va(e) : null, i = hs(e), o = fs(
      s,
      e,
      0,
      [
        e.props,
        r
      ]
    ), l = cl(o);
    if (Ot(), i(), (l || e.sp) && !Sn(e) && ql(e), l) {
      if (o.then(to, to), t)
        return o.then((a) => {
          no(e, a);
        }).catch((a) => {
          lr(a, e, 0);
        });
      e.asyncDep = o;
    } else
      no(e, o);
  } else
    ya(e);
}
function no(e, t, n) {
  K(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : oe(t) && (e.setupState = Ml(t)), ya(e);
}
function ya(e, t, n) {
  const s = e.type;
  e.render || (e.render = s.render || ht);
  {
    const r = hs(e);
    Ct();
    try {
      bc(e);
    } finally {
      Ot(), r();
    }
  }
}
const sf = {
  get(e, t) {
    return Te(e, "get", ""), e[t];
  }
};
function va(e) {
  const t = (n) => {
    e.exposed = n || {};
  };
  return {
    attrs: new Proxy(e.attrs, sf),
    slots: e.slots,
    emit: e.emit,
    expose: t
  };
}
function dr(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(Ml(ku(e.exposed)), {
    get(t, n) {
      if (n in t)
        return t[n];
      if (n in qn)
        return qn[n](e);
    },
    has(t, n) {
      return n in t || n in qn;
    }
  })) : e.proxy;
}
function rf(e, t = !0) {
  return K(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function of(e) {
  return K(e) && "__vccOpts" in e;
}
const lf = (e, t) => Gu(e, t, es);
function af(e, t, n) {
  const s = arguments.length;
  return s === 2 ? oe(t) && !L(t) ? Zn(t) ? Ae(e, null, [t]) : Ae(e, t) : Ae(e, null, t) : (s > 3 ? n = Array.prototype.slice.call(arguments, 2) : s === 3 && Zn(n) && (n = [n]), Ae(e, t, n));
}
const uf = "3.5.18";
/**
* @vue/runtime-dom v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let qr;
const so = typeof window != "undefined" && window.trustedTypes;
if (so)
  try {
    qr = /* @__PURE__ */ so.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch (e) {
  }
const ba = qr ? (e) => qr.createHTML(e) : (e) => e, cf = "http://www.w3.org/2000/svg", ff = "http://www.w3.org/1998/Math/MathML", vt = typeof document != "undefined" ? document : null, ro = vt && /* @__PURE__ */ vt.createElement("template"), df = {
  insert: (e, t, n) => {
    t.insertBefore(e, n || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, n, s) => {
    const r = t === "svg" ? vt.createElementNS(cf, e) : t === "mathml" ? vt.createElementNS(ff, e) : n ? vt.createElement(e, { is: n }) : vt.createElement(e);
    return e === "select" && s && s.multiple != null && r.setAttribute("multiple", s.multiple), r;
  },
  createText: (e) => vt.createTextNode(e),
  createComment: (e) => vt.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => vt.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, n, s, r, i) {
    const o = n ? n.previousSibling : t.lastChild;
    if (r && (r === i || r.nextSibling))
      for (; t.insertBefore(r.cloneNode(!0), n), !(r === i || !(r = r.nextSibling)); )
        ;
    else {
      ro.innerHTML = ba(
        s === "svg" ? `<svg>${e}</svg>` : s === "mathml" ? `<math>${e}</math>` : e
      );
      const l = ro.content;
      if (s === "svg" || s === "mathml") {
        const a = l.firstChild;
        for (; a.firstChild; )
          l.appendChild(a.firstChild);
        l.removeChild(a);
      }
      t.insertBefore(l, n);
    }
    return [
      // first
      o ? o.nextSibling : t.firstChild,
      // last
      n ? n.previousSibling : t.lastChild
    ];
  }
}, Pt = "transition", Fn = "animation", ts = Symbol("_vtc"), _a = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, hf = /* @__PURE__ */ de(
  {},
  Ul,
  _a
), pf = (e) => (e.displayName = "Transition", e.props = hf, e), fp = /* @__PURE__ */ pf(
  (e, { slots: t }) => af(rc, mf(e), t)
), Yt = (e, t = []) => {
  L(e) ? e.forEach((n) => n(...t)) : e && e(...t);
}, io = (e) => e ? L(e) ? e.some((t) => t.length > 1) : e.length > 1 : !1;
function mf(e) {
  const t = {};
  for (const N in e)
    N in _a || (t[N] = e[N]);
  if (e.css === !1)
    return t;
  const {
    name: n = "v",
    type: s,
    duration: r,
    enterFromClass: i = `${n}-enter-from`,
    enterActiveClass: o = `${n}-enter-active`,
    enterToClass: l = `${n}-enter-to`,
    appearFromClass: a = i,
    appearActiveClass: c = o,
    appearToClass: u = l,
    leaveFromClass: f = `${n}-leave-from`,
    leaveActiveClass: h = `${n}-leave-active`,
    leaveToClass: m = `${n}-leave-to`
  } = e, g = gf(r), v = g && g[0], M = g && g[1], {
    onBeforeEnter: S,
    onEnter: P,
    onEnterCancelled: $,
    onLeave: T,
    onLeaveCancelled: F,
    onBeforeAppear: j = S,
    onAppear: Q = P,
    onAppearCancelled: q = $
  } = t, x = (N, Y, re, ye) => {
    N._enterCancelled = ye, Jt(N, Y ? u : l), Jt(N, Y ? c : o), re && re();
  }, k = (N, Y) => {
    N._isLeaving = !1, Jt(N, f), Jt(N, m), Jt(N, h), Y && Y();
  }, W = (N) => (Y, re) => {
    const ye = N ? Q : P, ue = () => x(Y, N, re);
    Yt(ye, [Y, ue]), oo(() => {
      Jt(Y, N ? a : i), mt(Y, N ? u : l), io(ye) || lo(Y, s, v, ue);
    });
  };
  return de(t, {
    onBeforeEnter(N) {
      Yt(S, [N]), mt(N, i), mt(N, o);
    },
    onBeforeAppear(N) {
      Yt(j, [N]), mt(N, a), mt(N, c);
    },
    onEnter: W(!1),
    onAppear: W(!0),
    onLeave(N, Y) {
      N._isLeaving = !0;
      const re = () => k(N, Y);
      mt(N, f), N._enterCancelled ? (mt(N, h), co()) : (co(), mt(N, h)), oo(() => {
        N._isLeaving && (Jt(N, f), mt(N, m), io(T) || lo(N, s, M, re));
      }), Yt(T, [N, re]);
    },
    onEnterCancelled(N) {
      x(N, !1, void 0, !0), Yt($, [N]);
    },
    onAppearCancelled(N) {
      x(N, !0, void 0, !0), Yt(q, [N]);
    },
    onLeaveCancelled(N) {
      k(N), Yt(F, [N]);
    }
  });
}
function gf(e) {
  if (e == null)
    return null;
  if (oe(e))
    return [Or(e.enter), Or(e.leave)];
  {
    const t = Or(e);
    return [t, t];
  }
}
function Or(e) {
  return Dr(e);
}
function mt(e, t) {
  t.split(/\s+/).forEach((n) => n && e.classList.add(n)), (e[ts] || (e[ts] = /* @__PURE__ */ new Set())).add(t);
}
function Jt(e, t) {
  t.split(/\s+/).forEach((s) => s && e.classList.remove(s));
  const n = e[ts];
  n && (n.delete(t), n.size || (e[ts] = void 0));
}
function oo(e) {
  requestAnimationFrame(() => {
    requestAnimationFrame(e);
  });
}
let yf = 0;
function lo(e, t, n, s) {
  const r = e._endId = ++yf, i = () => {
    r === e._endId && s();
  };
  if (n != null)
    return setTimeout(i, n);
  const { type: o, timeout: l, propCount: a } = vf(e, t);
  if (!o)
    return s();
  const c = o + "end";
  let u = 0;
  const f = () => {
    e.removeEventListener(c, h), i();
  }, h = (m) => {
    m.target === e && ++u >= a && f();
  };
  setTimeout(() => {
    u < a && f();
  }, l + 1), e.addEventListener(c, h);
}
function vf(e, t) {
  const n = window.getComputedStyle(e), s = (g) => (n[g] || "").split(", "), r = s(`${Pt}Delay`), i = s(`${Pt}Duration`), o = ao(r, i), l = s(`${Fn}Delay`), a = s(`${Fn}Duration`), c = ao(l, a);
  let u = null, f = 0, h = 0;
  t === Pt ? o > 0 && (u = Pt, f = o, h = i.length) : t === Fn ? c > 0 && (u = Fn, f = c, h = a.length) : (f = Math.max(o, c), u = f > 0 ? o > c ? Pt : Fn : null, h = u ? u === Pt ? i.length : a.length : 0);
  const m = u === Pt && /\b(transform|all)(,|$)/.test(
    s(`${Pt}Property`).toString()
  );
  return {
    type: u,
    timeout: f,
    propCount: h,
    hasTransform: m
  };
}
function ao(e, t) {
  for (; e.length < t.length; )
    e = e.concat(e);
  return Math.max(...t.map((n, s) => uo(n) + uo(e[s])));
}
function uo(e) {
  return e === "auto" ? 0 : Number(e.slice(0, -1).replace(",", ".")) * 1e3;
}
function co() {
  return document.body.offsetHeight;
}
function bf(e, t, n) {
  const s = e[ts];
  s && (t = (t ? [t, ...s] : [...s]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
const Ws = Symbol("_vod"), Sa = Symbol("_vsh"), dp = {
  beforeMount(e, { value: t }, { transition: n }) {
    e[Ws] = e.style.display === "none" ? "" : e.style.display, n && t ? n.beforeEnter(e) : jn(e, t);
  },
  mounted(e, { value: t }, { transition: n }) {
    n && t && n.enter(e);
  },
  updated(e, { value: t, oldValue: n }, { transition: s }) {
    !t != !n && (s ? t ? (s.beforeEnter(e), jn(e, !0), s.enter(e)) : s.leave(e, () => {
      jn(e, !1);
    }) : jn(e, t));
  },
  beforeUnmount(e, { value: t }) {
    jn(e, t);
  }
};
function jn(e, t) {
  e.style.display = t ? e[Ws] : "none", e[Sa] = !t;
}
const _f = Symbol(""), Sf = /(^|;)\s*display\s*:/;
function wf(e, t, n) {
  const s = e.style, r = ce(n);
  let i = !1;
  if (n && !r) {
    if (t)
      if (ce(t))
        for (const o of t.split(";")) {
          const l = o.slice(0, o.indexOf(":")).trim();
          n[l] == null && Fs(s, l, "");
        }
      else
        for (const o in t)
          n[o] == null && Fs(s, o, "");
    for (const o in n)
      o === "display" && (i = !0), Fs(s, o, n[o]);
  } else if (r) {
    if (t !== n) {
      const o = s[_f];
      o && (n += ";" + o), s.cssText = n, i = Sf.test(n);
    }
  } else t && e.removeAttribute("style");
  Ws in e && (e[Ws] = i ? s.display : "", e[Sa] && (s.display = "none"));
}
const fo = /\s*!important$/;
function Fs(e, t, n) {
  if (L(n))
    n.forEach((s) => Fs(e, t, s));
  else if (n == null && (n = ""), t.startsWith("--"))
    e.setProperty(t, n);
  else {
    const s = Cf(e, t);
    fo.test(n) ? e.setProperty(
      Ue(s),
      n.replace(fo, ""),
      "important"
    ) : e[s] = n;
  }
}
const ho = ["Webkit", "Moz", "ms"], Tr = {};
function Cf(e, t) {
  const n = Tr[t];
  if (n)
    return n;
  let s = Pe(t);
  if (s !== "filter" && s in e)
    return Tr[t] = s;
  s = nr(s);
  for (let r = 0; r < ho.length; r++) {
    const i = ho[r] + s;
    if (i in e)
      return Tr[t] = i;
  }
  return t;
}
const po = "http://www.w3.org/1999/xlink";
function mo(e, t, n, s, r, i = pu(t)) {
  s && t.startsWith("xlink:") ? n == null ? e.removeAttributeNS(po, t.slice(6, t.length)) : e.setAttributeNS(po, t, n) : n == null || i && !dl(n) ? e.removeAttribute(t) : e.setAttribute(
    t,
    i ? "" : tt(n) ? String(n) : n
  );
}
function go(e, t, n, s, r) {
  if (t === "innerHTML" || t === "textContent") {
    n != null && (e[t] = t === "innerHTML" ? ba(n) : n);
    return;
  }
  const i = e.tagName;
  if (t === "value" && i !== "PROGRESS" && // custom elements may use _value internally
  !i.includes("-")) {
    const l = i === "OPTION" ? e.getAttribute("value") || "" : e.value, a = n == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(n);
    (l !== a || !("_value" in e)) && (e.value = a), n == null && e.removeAttribute(t), e._value = n;
    return;
  }
  let o = !1;
  if (n === "" || n == null) {
    const l = typeof e[t];
    l === "boolean" ? n = dl(n) : n == null && l === "string" ? (n = "", o = !0) : l === "number" && (n = 0, o = !0);
  }
  try {
    e[t] = n;
  } catch (l) {
  }
  o && e.removeAttribute(r || t);
}
function wt(e, t, n, s) {
  e.addEventListener(t, n, s);
}
function Of(e, t, n, s) {
  e.removeEventListener(t, n, s);
}
const yo = Symbol("_vei");
function Tf(e, t, n, s, r = null) {
  const i = e[yo] || (e[yo] = {}), o = i[t];
  if (s && o)
    o.value = s;
  else {
    const [l, a] = xf(t);
    if (s) {
      const c = i[t] = Pf(
        s,
        r
      );
      wt(e, l, c, a);
    } else o && (Of(e, l, o, a), i[t] = void 0);
  }
}
const vo = /(?:Once|Passive|Capture)$/;
function xf(e) {
  let t;
  if (vo.test(e)) {
    t = {};
    let s;
    for (; s = e.match(vo); )
      e = e.slice(0, e.length - s[0].length), t[s[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : Ue(e.slice(2)), t];
}
let xr = 0;
const Ef = /* @__PURE__ */ Promise.resolve(), Af = () => xr || (Ef.then(() => xr = 0), xr = Date.now());
function Pf(e, t) {
  const n = (s) => {
    if (!s._vts)
      s._vts = Date.now();
    else if (s._vts <= n.attached)
      return;
    nt(
      Mf(s, n.value),
      t,
      5,
      [s]
    );
  };
  return n.value = e, n.attached = Af(), n;
}
function Mf(e, t) {
  if (L(t)) {
    const n = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      n.call(e), e._stopped = !0;
    }, t.map(
      (s) => (r) => !r._stopped && s && s(r)
    );
  } else
    return t;
}
const bo = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, Rf = (e, t, n, s, r, i) => {
  const o = r === "svg";
  t === "class" ? bf(e, s, o) : t === "style" ? wf(e, n, s) : Zs(t) ? ei(t) || Tf(e, t, n, s, i) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : Df(e, t, s, o)) ? (go(e, t, s), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && mo(e, t, s, o, i, t !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && (/[A-Z]/.test(t) || !ce(s)) ? go(e, Pe(t), s, i, t) : (t === "true-value" ? e._trueValue = s : t === "false-value" && (e._falseValue = s), mo(e, t, s, o));
};
function Df(e, t, n, s) {
  if (s)
    return !!(t === "innerHTML" || t === "textContent" || t in e && bo(t) && K(n));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "autocorrect" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const r = e.tagName;
    if (r === "IMG" || r === "VIDEO" || r === "CANVAS" || r === "SOURCE")
      return !1;
  }
  return bo(t) && ce(n) ? !1 : t in e;
}
const _o = {};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Nf(e, t, n) {
  const s = /* @__PURE__ */ ic(e, t);
  er(s) && de(s, t);
  class r extends Ci {
    constructor(o) {
      super(s, o, n);
    }
  }
  return r.def = s, r;
}
const $f = typeof HTMLElement != "undefined" ? HTMLElement : class {
};
class Ci extends $f {
  constructor(t, n = {}, s = xo) {
    super(), this._def = t, this._props = n, this._createApp = s, this._isVueCE = !0, this._instance = null, this._app = null, this._nonce = this._def.nonce, this._connected = !1, this._resolved = !1, this._numberProps = null, this._styleChildren = /* @__PURE__ */ new WeakSet(), this._ob = null, this.shadowRoot && s !== xo ? this._root = this.shadowRoot : t.shadowRoot !== !1 ? (this.attachShadow({ mode: "open" }), this._root = this.shadowRoot) : this._root = this;
  }
  connectedCallback() {
    if (!this.isConnected) return;
    !this.shadowRoot && !this._resolved && this._parseSlots(), this._connected = !0;
    let t = this;
    for (; t = t && (t.parentNode || t.host); )
      if (t instanceof Ci) {
        this._parent = t;
        break;
      }
    this._instance || (this._resolved ? this._mount(this._def) : t && t._pendingResolve ? this._pendingResolve = t._pendingResolve.then(() => {
      this._pendingResolve = void 0, this._resolveDef();
    }) : this._resolveDef());
  }
  _setParent(t = this._parent) {
    t && (this._instance.parent = t._instance, this._inheritParentContext(t));
  }
  _inheritParentContext(t = this._parent) {
    t && this._app && Object.setPrototypeOf(
      this._app._context.provides,
      t._instance.provides
    );
  }
  disconnectedCallback() {
    this._connected = !1, ds(() => {
      this._connected || (this._ob && (this._ob.disconnect(), this._ob = null), this._app && this._app.unmount(), this._instance && (this._instance.ce = void 0), this._app = this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    if (this._pendingResolve)
      return;
    for (let s = 0; s < this.attributes.length; s++)
      this._setAttr(this.attributes[s].name);
    this._ob = new MutationObserver((s) => {
      for (const r of s)
        this._setAttr(r.attributeName);
    }), this._ob.observe(this, { attributes: !0 });
    const t = (s, r = !1) => {
      this._resolved = !0, this._pendingResolve = void 0;
      const { props: i, styles: o } = s;
      let l;
      if (i && !L(i))
        for (const a in i) {
          const c = i[a];
          (c === Number || c && c.type === Number) && (a in this._props && (this._props[a] = Dr(this._props[a])), (l || (l = /* @__PURE__ */ Object.create(null)))[Pe(a)] = !0);
        }
      this._numberProps = l, this._resolveProps(s), this.shadowRoot && this._applyStyles(o), this._mount(s);
    }, n = this._def.__asyncLoader;
    n ? this._pendingResolve = n().then((s) => {
      s.configureApp = this._def.configureApp, t(this._def = s, !0);
    }) : t(this._def);
  }
  _mount(t) {
    this._app = this._createApp(t), this._inheritParentContext(), t.configureApp && t.configureApp(this._app), this._app._ceVNode = this._createVNode(), this._app.mount(this._root);
    const n = this._instance && this._instance.exposed;
    if (n)
      for (const s in n)
        ne(this, s) || Object.defineProperty(this, s, {
          // unwrap ref to be consistent with public instance behavior
          get: () => hi(n[s])
        });
  }
  _resolveProps(t) {
    const { props: n } = t, s = L(n) ? n : Object.keys(n || {});
    for (const r of Object.keys(this))
      r[0] !== "_" && s.includes(r) && this._setProp(r, this[r]);
    for (const r of s.map(Pe))
      Object.defineProperty(this, r, {
        get() {
          return this._getProp(r);
        },
        set(i) {
          this._setProp(r, i, !0, !0);
        }
      });
  }
  _setAttr(t) {
    if (t.startsWith("data-v-")) return;
    const n = this.hasAttribute(t);
    let s = n ? this.getAttribute(t) : _o;
    const r = Pe(t);
    n && this._numberProps && this._numberProps[r] && (s = Dr(s)), this._setProp(r, s, !1, !0);
  }
  /**
   * @internal
   */
  _getProp(t) {
    return this._props[t];
  }
  /**
   * @internal
   */
  _setProp(t, n, s = !0, r = !1) {
    if (n !== this._props[t] && (n === _o ? delete this._props[t] : (this._props[t] = n, t === "key" && this._app && (this._app._ceVNode.key = n)), r && this._instance && this._update(), s)) {
      const i = this._ob;
      i && i.disconnect(), n === !0 ? this.setAttribute(Ue(t), "") : typeof n == "string" || typeof n == "number" ? this.setAttribute(Ue(t), n + "") : n || this.removeAttribute(Ue(t)), i && i.observe(this, { attributes: !0 });
    }
  }
  _update() {
    const t = this._createVNode();
    this._app && (t.appContext = this._app._context), Qf(t, this._root);
  }
  _createVNode() {
    const t = {};
    this.shadowRoot || (t.onVnodeMounted = t.onVnodeUpdated = this._renderSlots.bind(this));
    const n = Ae(this._def, de(t, this._props));
    return this._instance || (n.ce = (s) => {
      this._instance = s, s.ce = this, s.isCE = !0;
      const r = (i, o) => {
        this.dispatchEvent(
          new CustomEvent(
            i,
            er(o[0]) ? de({ detail: o }, o[0]) : { detail: o }
          )
        );
      };
      s.emit = (i, ...o) => {
        r(i, o), Ue(i) !== i && r(Ue(i), o);
      }, this._setParent();
    }), n;
  }
  _applyStyles(t, n) {
    if (!t) return;
    if (n) {
      if (n === this._def || this._styleChildren.has(n))
        return;
      this._styleChildren.add(n);
    }
    const s = this._nonce;
    for (let r = t.length - 1; r >= 0; r--) {
      const i = document.createElement("style");
      s && i.setAttribute("nonce", s), i.textContent = t[r], this.shadowRoot.prepend(i);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _parseSlots() {
    const t = this._slots = {};
    let n;
    for (; n = this.firstChild; ) {
      const s = n.nodeType === 1 && n.getAttribute("slot") || "default";
      (t[s] || (t[s] = [])).push(n), this.removeChild(n);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _renderSlots() {
    const t = (this._teleportTarget || this).querySelectorAll("slot"), n = this._instance.type.__scopeId;
    for (let s = 0; s < t.length; s++) {
      const r = t[s], i = r.getAttribute("name") || "default", o = this._slots[i], l = r.parentNode;
      if (o)
        for (const a of o) {
          if (n && a.nodeType === 1) {
            const c = n + "-s", u = document.createTreeWalker(a, 1);
            a.setAttribute(c, "");
            let f;
            for (; f = u.nextNode(); )
              f.setAttribute(c, "");
          }
          l.insertBefore(a, r);
        }
      else
        for (; r.firstChild; ) l.insertBefore(r.firstChild, r);
      l.removeChild(r);
    }
  }
  /**
   * @internal
   */
  _injectChildStyle(t) {
    this._applyStyles(t.styles, t);
  }
  /**
   * @internal
   */
  _removeChildStyle(t) {
  }
}
const Qt = (e) => {
  const t = e.props["onUpdate:modelValue"] || !1;
  return L(t) ? (n) => Rs(t, n) : t;
};
function If(e) {
  e.target.composing = !0;
}
function So(e) {
  const t = e.target;
  t.composing && (t.composing = !1, t.dispatchEvent(new Event("input")));
}
const Ge = Symbol("_assign"), wo = {
  created(e, { modifiers: { lazy: t, trim: n, number: s } }, r) {
    e[Ge] = Qt(r);
    const i = s || r.props && r.props.type === "number";
    wt(e, t ? "change" : "input", (o) => {
      if (o.target.composing) return;
      let l = e.value;
      n && (l = l.trim()), i && (l = Ls(l)), e[Ge](l);
    }), n && wt(e, "change", () => {
      e.value = e.value.trim();
    }), t || (wt(e, "compositionstart", If), wt(e, "compositionend", So), wt(e, "change", So));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(e, { value: t }) {
    e.value = t == null ? "" : t;
  },
  beforeUpdate(e, { value: t, oldValue: n, modifiers: { lazy: s, trim: r, number: i } }, o) {
    if (e[Ge] = Qt(o), e.composing) return;
    const l = (i || e.type === "number") && !/^0\d/.test(e.value) ? Ls(e.value) : e.value, a = t == null ? "" : t;
    l !== a && (document.activeElement === e && e.type !== "range" && (s && t === n || r && e.value.trim() === a) || (e.value = a));
  }
}, Ff = {
  // #4096 array checkboxes need to be deep traversed
  deep: !0,
  created(e, t, n) {
    e[Ge] = Qt(n), wt(e, "change", () => {
      const s = e._modelValue, r = Rn(e), i = e.checked, o = e[Ge];
      if (L(s)) {
        const l = ii(s, r), a = l !== -1;
        if (i && !a)
          o(s.concat(r));
        else if (!i && a) {
          const c = [...s];
          c.splice(l, 1), o(c);
        }
      } else if (Dn(s)) {
        const l = new Set(s);
        i ? l.add(r) : l.delete(r), o(l);
      } else
        o(wa(e, i));
    });
  },
  // set initial checked on mount to wait for true-value/false-value
  mounted: Co,
  beforeUpdate(e, t, n) {
    e[Ge] = Qt(n), Co(e, t, n);
  }
};
function Co(e, { value: t, oldValue: n }, s) {
  e._modelValue = t;
  let r;
  if (L(t))
    r = ii(t, s.props.value) > -1;
  else if (Dn(t))
    r = t.has(s.props.value);
  else {
    if (t === n) return;
    r = un(t, wa(e, !0));
  }
  e.checked !== r && (e.checked = r);
}
const jf = {
  created(e, { value: t }, n) {
    e.checked = un(t, n.props.value), e[Ge] = Qt(n), wt(e, "change", () => {
      e[Ge](Rn(e));
    });
  },
  beforeUpdate(e, { value: t, oldValue: n }, s) {
    e[Ge] = Qt(s), t !== n && (e.checked = un(t, s.props.value));
  }
}, Lf = {
  // <select multiple> value need to be deep traversed
  deep: !0,
  created(e, { value: t, modifiers: { number: n } }, s) {
    const r = Dn(t);
    wt(e, "change", () => {
      const i = Array.prototype.filter.call(e.options, (o) => o.selected).map(
        (o) => n ? Ls(Rn(o)) : Rn(o)
      );
      e[Ge](
        e.multiple ? r ? new Set(i) : i : i[0]
      ), e._assigning = !0, ds(() => {
        e._assigning = !1;
      });
    }), e[Ge] = Qt(s);
  },
  // set value in mounted & updated because <select> relies on its children
  // <option>s.
  mounted(e, { value: t }) {
    Oo(e, t);
  },
  beforeUpdate(e, t, n) {
    e[Ge] = Qt(n);
  },
  updated(e, { value: t }) {
    e._assigning || Oo(e, t);
  }
};
function Oo(e, t) {
  const n = e.multiple, s = L(t);
  if (!(n && !s && !Dn(t))) {
    for (let r = 0, i = e.options.length; r < i; r++) {
      const o = e.options[r], l = Rn(o);
      if (n)
        if (s) {
          const a = typeof l;
          a === "string" || a === "number" ? o.selected = t.some((c) => String(c) === String(l)) : o.selected = ii(t, l) > -1;
        } else
          o.selected = t.has(l);
      else if (un(Rn(o), t)) {
        e.selectedIndex !== r && (e.selectedIndex = r);
        return;
      }
    }
    !n && e.selectedIndex !== -1 && (e.selectedIndex = -1);
  }
}
function Rn(e) {
  return "_value" in e ? e._value : e.value;
}
function wa(e, t) {
  const n = t ? "_trueValue" : "_falseValue";
  return n in e ? e[n] : t;
}
const hp = {
  created(e, t, n) {
    Ts(e, t, n, null, "created");
  },
  mounted(e, t, n) {
    Ts(e, t, n, null, "mounted");
  },
  beforeUpdate(e, t, n, s) {
    Ts(e, t, n, s, "beforeUpdate");
  },
  updated(e, t, n, s) {
    Ts(e, t, n, s, "updated");
  }
};
function kf(e, t) {
  switch (e) {
    case "SELECT":
      return Lf;
    case "TEXTAREA":
      return wo;
    default:
      switch (t) {
        case "checkbox":
          return Ff;
        case "radio":
          return jf;
        default:
          return wo;
      }
  }
}
function Ts(e, t, n, s, r) {
  const o = kf(
    e.tagName,
    n.props && n.props.type
  )[r];
  o && o(e, t, n, s);
}
const Uf = ["ctrl", "shift", "alt", "meta"], Hf = {
  stop: (e) => e.stopPropagation(),
  prevent: (e) => e.preventDefault(),
  self: (e) => e.target !== e.currentTarget,
  ctrl: (e) => !e.ctrlKey,
  shift: (e) => !e.shiftKey,
  alt: (e) => !e.altKey,
  meta: (e) => !e.metaKey,
  left: (e) => "button" in e && e.button !== 0,
  middle: (e) => "button" in e && e.button !== 1,
  right: (e) => "button" in e && e.button !== 2,
  exact: (e, t) => Uf.some((n) => e[`${n}Key`] && !t.includes(n))
}, pp = (e, t) => {
  const n = e._withMods || (e._withMods = {}), s = t.join(".");
  return n[s] || (n[s] = (r, ...i) => {
    for (let o = 0; o < t.length; o++) {
      const l = Hf[t[o]];
      if (l && l(r, t)) return;
    }
    return e(r, ...i);
  });
}, Vf = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
}, mp = (e, t) => {
  const n = e._withKeys || (e._withKeys = {}), s = t.join(".");
  return n[s] || (n[s] = (r) => {
    if (!("key" in r))
      return;
    const i = Ue(r.key);
    if (t.some(
      (o) => o === i || Vf[o] === i
    ))
      return e(r);
  });
}, Kf = /* @__PURE__ */ de({ patchProp: Rf }, df);
let To;
function Ca() {
  return To || (To = Nc(Kf));
}
const Qf = (...e) => {
  Ca().render(...e);
}, xo = (...e) => {
  const t = Ca().createApp(...e), { mount: n } = t;
  return t.mount = (s) => {
    const r = Bf(s);
    if (!r) return;
    const i = t._component;
    !K(i) && !i.render && !i.template && (i.template = r.innerHTML), r.nodeType === 1 && (r.textContent = "");
    const o = n(r, !1, qf(r));
    return r instanceof Element && (r.removeAttribute("v-cloak"), r.setAttribute("data-v-app", "")), o;
  }, t;
};
function qf(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function Bf(e) {
  return ce(e) ? document.querySelector(e) : e;
}
const gp = (e, t = "all") => {
  if (t === "none")
    return;
  const n = e == null ? void 0 : e.parentNode;
  if (n instanceof ShadowRoot) {
    const s = t === "all" ? document.querySelectorAll("link[rel='stylesheet'],style") : document.querySelectorAll(t);
    if (s)
      for (const r of s)
        n.appendChild(r.cloneNode(!0));
  }
};
var hr = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, ps = typeof window == "undefined" || "Deno" in globalThis;
function Je() {
}
function Wf(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Gf(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function zf(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function Eo(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Yf(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ao(e, t) {
  const {
    type: n = "all",
    exact: s,
    fetchStatus: r,
    predicate: i,
    queryKey: o,
    stale: l
  } = e;
  if (o) {
    if (s) {
      if (t.queryHash !== Oi(o, t.options))
        return !1;
    } else if (!ss(t.queryKey, o))
      return !1;
  }
  if (n !== "all") {
    const a = t.isActive();
    if (n === "active" && !a || n === "inactive" && a)
      return !1;
  }
  return !(typeof l == "boolean" && t.isStale() !== l || r && r !== t.state.fetchStatus || i && !i(t));
}
function Po(e, t) {
  const { exact: n, status: s, predicate: r, mutationKey: i } = e;
  if (i) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (ns(t.options.mutationKey) !== ns(i))
        return !1;
    } else if (!ss(t.options.mutationKey, i))
      return !1;
  }
  return !(s && t.state.status !== s || r && !r(t));
}
function Oi(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || ns)(e);
}
function ns(e) {
  return JSON.stringify(
    e,
    (t, n) => Br(n) ? Object.keys(n).sort().reduce((s, r) => (s[r] = n[r], s), {}) : n
  );
}
function ss(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n) => !ss(e[n], t[n])) : !1;
}
function Oa(e, t) {
  if (e === t)
    return e;
  const n = Mo(e) && Mo(t);
  if (n || Br(e) && Br(t)) {
    const s = n ? e : Object.keys(e), r = s.length, i = n ? t : Object.keys(t), o = i.length, l = n ? [] : {};
    let a = 0;
    for (let c = 0; c < o; c++) {
      const u = n ? c : i[c];
      (!n && s.includes(u) || n) && e[u] === void 0 && t[u] === void 0 ? (l[u] = void 0, a++) : (l[u] = Oa(e[u], t[u]), l[u] === e[u] && e[u] !== void 0 && a++);
    }
    return r === o && a === r ? e : l;
  }
  return t;
}
function yp(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Mo(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function Br(e) {
  if (!Ro(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(!Ro(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function Ro(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Jf(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function Xf(e, t, n) {
  return typeof n.structuralSharing == "function" ? n.structuralSharing(e, t) : n.structuralSharing !== !1 ? Oa(e, t) : t;
}
function Zf(e, t, n = 0) {
  const s = [...e, t];
  return n && s.length > n ? s.slice(1) : s;
}
function ed(e, t, n = 0) {
  const s = [t, ...e];
  return n && s.length > n ? s.slice(0, -1) : s;
}
var Ta = Symbol();
function xa(e, t) {
  return !e.queryFn && (t != null && t.initialPromise) ? () => t.initialPromise : !e.queryFn || e.queryFn === Ta ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
var en, $t, wn, tl, td = (tl = class extends hr {
  constructor() {
    super();
    X(this, en);
    X(this, $t);
    X(this, wn);
    B(this, wn, (t) => {
      if (!ps && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), () => {
          window.removeEventListener("visibilitychange", n);
        };
      }
    });
  }
  onSubscribe() {
    b(this, $t) || this.setEventListener(b(this, wn));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = b(this, $t)) == null || t.call(this), B(this, $t, void 0));
  }
  setEventListener(t) {
    var n;
    B(this, wn, t), (n = b(this, $t)) == null || n.call(this), B(this, $t, t((s) => {
      typeof s == "boolean" ? this.setFocused(s) : this.onFocus();
    }));
  }
  setFocused(t) {
    b(this, en) !== t && (B(this, en, t), this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((n) => {
      n(t);
    });
  }
  isFocused() {
    var t;
    return typeof b(this, en) == "boolean" ? b(this, en) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
  }
}, en = new WeakMap(), $t = new WeakMap(), wn = new WeakMap(), tl), Ea = new td(), Cn, It, On, nl, nd = (nl = class extends hr {
  constructor() {
    super();
    X(this, Cn, !0);
    X(this, It);
    X(this, On);
    B(this, On, (t) => {
      if (!ps && window.addEventListener) {
        const n = () => t(!0), s = () => t(!1);
        return window.addEventListener("online", n, !1), window.addEventListener("offline", s, !1), () => {
          window.removeEventListener("online", n), window.removeEventListener("offline", s);
        };
      }
    });
  }
  onSubscribe() {
    b(this, It) || this.setEventListener(b(this, On));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = b(this, It)) == null || t.call(this), B(this, It, void 0));
  }
  setEventListener(t) {
    var n;
    B(this, On, t), (n = b(this, It)) == null || n.call(this), B(this, It, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    b(this, Cn) !== t && (B(this, Cn, t), this.listeners.forEach((s) => {
      s(t);
    }));
  }
  isOnline() {
    return b(this, Cn);
  }
}, Cn = new WeakMap(), It = new WeakMap(), On = new WeakMap(), nl), Gs = new nd();
function sd(e) {
  return Math.min(1e3 * Fi(2, e), 3e4);
}
function Aa(e) {
  return (e != null ? e : "online") === "online" ? Gs.isOnline() : !0;
}
var Pa = class extends Error {
  constructor(e) {
    super("CancelledError"), this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function Er(e) {
  return e instanceof Pa;
}
function Ma(e) {
  let t = !1, n = 0, s = !1, r, i, o;
  const l = new Promise((S, P) => {
    i = S, o = P;
  }), a = (S) => {
    var P;
    s || (g(new Pa(S)), (P = e.abort) == null || P.call(e));
  }, c = () => {
    t = !0;
  }, u = () => {
    t = !1;
  }, f = () => Ea.isFocused() && (e.networkMode === "always" || Gs.isOnline()) && e.canRun(), h = () => Aa(e.networkMode) && e.canRun(), m = (S) => {
    var P;
    s || (s = !0, (P = e.onSuccess) == null || P.call(e, S), r == null || r(), i(S));
  }, g = (S) => {
    var P;
    s || (s = !0, (P = e.onError) == null || P.call(e, S), r == null || r(), o(S));
  }, v = () => new Promise((S) => {
    var P;
    r = ($) => {
      (s || f()) && S($);
    }, (P = e.onPause) == null || P.call(e);
  }).then(() => {
    var S;
    r = void 0, s || (S = e.onContinue) == null || S.call(e);
  }), M = () => {
    if (s)
      return;
    let S;
    const P = n === 0 ? e.initialPromise : void 0;
    try {
      S = P != null ? P : e.fn();
    } catch ($) {
      S = Promise.reject($);
    }
    Promise.resolve(S).then(m).catch(($) => {
      var q, x, k;
      if (s)
        return;
      const T = (q = e.retry) != null ? q : ps ? 0 : 3, F = (x = e.retryDelay) != null ? x : sd, j = typeof F == "function" ? F(n, $) : F, Q = T === !0 || typeof T == "number" && n < T || typeof T == "function" && T(n, $);
      if (t || !Q) {
        g($);
        return;
      }
      n++, (k = e.onFail) == null || k.call(e, n, $), Jf(j).then(() => f() ? void 0 : v()).then(() => {
        t ? g($) : M();
      });
    });
  };
  return {
    promise: l,
    cancel: a,
    continue: () => (r == null || r(), l),
    cancelRetry: c,
    continueRetry: u,
    canStart: h,
    start: () => (h() ? M() : v().then(M), l)
  };
}
function rd() {
  let e = [], t = 0, n = (l) => {
    l();
  }, s = (l) => {
    l();
  }, r = (l) => setTimeout(l, 0);
  const i = (l) => {
    t ? e.push(l) : r(() => {
      n(l);
    });
  }, o = () => {
    const l = e;
    e = [], l.length && r(() => {
      s(() => {
        l.forEach((a) => {
          n(a);
        });
      });
    });
  };
  return {
    batch: (l) => {
      let a;
      t++;
      try {
        a = l();
      } finally {
        t--, t || o();
      }
      return a;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (l) => (...a) => {
      i(() => {
        l(...a);
      });
    },
    schedule: i,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (l) => {
      n = l;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (l) => {
      s = l;
    },
    setScheduler: (l) => {
      r = l;
    }
  };
}
var $e = rd(), tn, sl, Ra = (sl = class {
  constructor() {
    X(this, tn);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Gf(this.gcTime) && B(this, tn, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e != null ? e : ps ? 1 / 0 : 300 * 1e3
    );
  }
  clearGcTimeout() {
    b(this, tn) && (clearTimeout(b(this, tn)), B(this, tn, void 0));
  }
}, tn = new WeakMap(), sl), Tn, xn, Be, we, as, nn, Xe, yt, rl, id = (rl = class extends Ra {
  constructor(t) {
    var n;
    super();
    X(this, Xe);
    X(this, Tn);
    X(this, xn);
    X(this, Be);
    X(this, we);
    X(this, as);
    X(this, nn);
    B(this, nn, !1), B(this, as, t.defaultOptions), this.setOptions(t.options), this.observers = [], B(this, Be, t.cache), this.queryKey = t.queryKey, this.queryHash = t.queryHash, B(this, Tn, ld(this.options)), this.state = (n = t.state) != null ? n : b(this, Tn), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var t;
    return (t = b(this, we)) == null ? void 0 : t.promise;
  }
  setOptions(t) {
    this.options = I(I({}, b(this, as)), t), this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && b(this, Be).remove(this);
  }
  setData(t, n) {
    const s = Xf(this.state.data, t, this.options);
    return _e(this, Xe, yt).call(this, {
      data: s,
      type: "success",
      dataUpdatedAt: n == null ? void 0 : n.updatedAt,
      manual: n == null ? void 0 : n.manual
    }), s;
  }
  setState(t, n) {
    _e(this, Xe, yt).call(this, { type: "setState", state: t, setStateOptions: n });
  }
  cancel(t) {
    var s, r;
    const n = (s = b(this, we)) == null ? void 0 : s.promise;
    return (r = b(this, we)) == null || r.cancel(t), n ? n.then(Je).catch(Je) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(b(this, Tn));
  }
  isActive() {
    return this.observers.some(
      (t) => Yf(t.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !zf(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var n;
    const t = this.observers.find((s) => s.shouldFetchOnWindowFocus());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = b(this, we)) == null || n.continue();
  }
  onOnline() {
    var n;
    const t = this.observers.find((s) => s.shouldFetchOnReconnect());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = b(this, we)) == null || n.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), b(this, Be).notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((n) => n !== t), this.observers.length || (b(this, we) && (b(this, nn) ? b(this, we).cancel({ revert: !0 }) : b(this, we).cancelRetry()), this.scheduleGc()), b(this, Be).notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || _e(this, Xe, yt).call(this, { type: "invalidate" });
  }
  fetch(t, n) {
    var a, c, u;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (n != null && n.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (b(this, we))
        return b(this, we).continueRetry(), b(this, we).promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const f = this.observers.find((h) => h.options.queryFn);
      f && this.setOptions(f.options);
    }
    const s = new AbortController(), r = (f) => {
      Object.defineProperty(f, "signal", {
        enumerable: !0,
        get: () => (B(this, nn, !0), s.signal)
      });
    }, i = () => {
      const f = xa(this.options, n), h = {
        queryKey: this.queryKey,
        meta: this.meta
      };
      return r(h), B(this, nn, !1), this.options.persister ? this.options.persister(
        f,
        h,
        this
      ) : f(h);
    }, o = {
      fetchOptions: n,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: i
    };
    r(o), (a = this.options.behavior) == null || a.onFetch(
      o,
      this
    ), B(this, xn, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((c = o.fetchOptions) == null ? void 0 : c.meta)) && _e(this, Xe, yt).call(this, { type: "fetch", meta: (u = o.fetchOptions) == null ? void 0 : u.meta });
    const l = (f) => {
      var h, m, g, v;
      Er(f) && f.silent || _e(this, Xe, yt).call(this, {
        type: "error",
        error: f
      }), Er(f) || ((m = (h = b(this, Be).config).onError) == null || m.call(
        h,
        f,
        this
      ), (v = (g = b(this, Be).config).onSettled) == null || v.call(
        g,
        this.state.data,
        f,
        this
      )), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return B(this, we, Ma({
      initialPromise: n == null ? void 0 : n.initialPromise,
      fn: o.fetchFn,
      abort: s.abort.bind(s),
      onSuccess: (f) => {
        var h, m, g, v;
        if (f === void 0) {
          l(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(f);
        } catch (M) {
          l(M);
          return;
        }
        (m = (h = b(this, Be).config).onSuccess) == null || m.call(h, f, this), (v = (g = b(this, Be).config).onSettled) == null || v.call(
          g,
          f,
          this.state.error,
          this
        ), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: l,
      onFail: (f, h) => {
        _e(this, Xe, yt).call(this, { type: "failed", failureCount: f, error: h });
      },
      onPause: () => {
        _e(this, Xe, yt).call(this, { type: "pause" });
      },
      onContinue: () => {
        _e(this, Xe, yt).call(this, { type: "continue" });
      },
      retry: o.options.retry,
      retryDelay: o.options.retryDelay,
      networkMode: o.options.networkMode,
      canRun: () => !0
    })), b(this, we).start();
  }
}, Tn = new WeakMap(), xn = new WeakMap(), Be = new WeakMap(), we = new WeakMap(), as = new WeakMap(), nn = new WeakMap(), Xe = new WeakSet(), yt = function(t) {
  const n = (s) => {
    var r, i;
    switch (t.type) {
      case "failed":
        return ie(I({}, s), {
          fetchFailureCount: t.failureCount,
          fetchFailureReason: t.error
        });
      case "pause":
        return ie(I({}, s), {
          fetchStatus: "paused"
        });
      case "continue":
        return ie(I({}, s), {
          fetchStatus: "fetching"
        });
      case "fetch":
        return ie(I(I({}, s), od(s.data, this.options)), {
          fetchMeta: (r = t.meta) != null ? r : null
        });
      case "success":
        return I(ie(I({}, s), {
          data: t.data,
          dataUpdateCount: s.dataUpdateCount + 1,
          dataUpdatedAt: (i = t.dataUpdatedAt) != null ? i : Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success"
        }), !t.manual && {
          fetchStatus: "idle",
          fetchFailureCount: 0,
          fetchFailureReason: null
        });
      case "error":
        const o = t.error;
        return Er(o) && o.revert && b(this, xn) ? ie(I({}, b(this, xn)), { fetchStatus: "idle" }) : ie(I({}, s), {
          error: o,
          errorUpdateCount: s.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: s.fetchFailureCount + 1,
          fetchFailureReason: o,
          fetchStatus: "idle",
          status: "error"
        });
      case "invalidate":
        return ie(I({}, s), {
          isInvalidated: !0
        });
      case "setState":
        return I(I({}, s), t.state);
    }
  };
  this.state = n(this.state), $e.batch(() => {
    this.observers.forEach((s) => {
      s.onQueryUpdate();
    }), b(this, Be).notify({ query: this, type: "updated", action: t });
  });
}, rl);
function od(e, t) {
  return I({
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: Aa(t.networkMode) ? "fetching" : "paused"
  }, e === void 0 && {
    error: null,
    status: "pending"
  });
}
function ld(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, s = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? s != null ? s : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var at, il, Da = (il = class extends hr {
  constructor(n = {}) {
    super();
    X(this, at);
    this.config = n, B(this, at, /* @__PURE__ */ new Map());
  }
  build(n, s, r) {
    var a;
    const i = s.queryKey, o = (a = s.queryHash) != null ? a : Oi(i, s);
    let l = this.get(o);
    return l || (l = new id({
      cache: this,
      queryKey: i,
      queryHash: o,
      options: n.defaultQueryOptions(s),
      state: r,
      defaultOptions: n.getQueryDefaults(i)
    }), this.add(l)), l;
  }
  add(n) {
    b(this, at).has(n.queryHash) || (b(this, at).set(n.queryHash, n), this.notify({
      type: "added",
      query: n
    }));
  }
  remove(n) {
    const s = b(this, at).get(n.queryHash);
    s && (n.destroy(), s === n && b(this, at).delete(n.queryHash), this.notify({ type: "removed", query: n }));
  }
  clear() {
    $e.batch(() => {
      this.getAll().forEach((n) => {
        this.remove(n);
      });
    });
  }
  get(n) {
    return b(this, at).get(n);
  }
  getAll() {
    return [...b(this, at).values()];
  }
  find(n) {
    const s = I({ exact: !0 }, n);
    return this.getAll().find(
      (r) => Ao(s, r)
    );
  }
  findAll(n = {}) {
    const s = this.getAll();
    return Object.keys(n).length > 0 ? s.filter((r) => Ao(n, r)) : s;
  }
  notify(n) {
    $e.batch(() => {
      this.listeners.forEach((s) => {
        s(n);
      });
    });
  }
  onFocus() {
    $e.batch(() => {
      this.getAll().forEach((n) => {
        n.onFocus();
      });
    });
  }
  onOnline() {
    $e.batch(() => {
      this.getAll().forEach((n) => {
        n.onOnline();
      });
    });
  }
}, at = new WeakMap(), il), ut, Re, sn, ct, Mt, ol, ad = (ol = class extends Ra {
  constructor(t) {
    super();
    X(this, ct);
    X(this, ut);
    X(this, Re);
    X(this, sn);
    this.mutationId = t.mutationId, B(this, Re, t.mutationCache), B(this, ut, []), this.state = t.state || ud(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = t, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    b(this, ut).includes(t) || (b(this, ut).push(t), this.clearGcTimeout(), b(this, Re).notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    B(this, ut, b(this, ut).filter((n) => n !== t)), this.scheduleGc(), b(this, Re).notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    b(this, ut).length || (this.state.status === "pending" ? this.scheduleGc() : b(this, Re).remove(this));
  }
  continue() {
    var t, n;
    return (n = (t = b(this, sn)) == null ? void 0 : t.continue()) != null ? n : (
      // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
      this.execute(this.state.variables)
    );
  }
  execute(t) {
    return ze(this, null, function* () {
      var r, i, o, l, a, c, u, f, h, m, g, v, M, S, P, $, T, F, j, Q, q;
      B(this, sn, Ma({
        fn: () => this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")),
        onFail: (x, k) => {
          _e(this, ct, Mt).call(this, { type: "failed", failureCount: x, error: k });
        },
        onPause: () => {
          _e(this, ct, Mt).call(this, { type: "pause" });
        },
        onContinue: () => {
          _e(this, ct, Mt).call(this, { type: "continue" });
        },
        retry: (r = this.options.retry) != null ? r : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode,
        canRun: () => b(this, Re).canRun(this)
      }));
      const n = this.state.status === "pending", s = !b(this, sn).canStart();
      try {
        if (!n) {
          _e(this, ct, Mt).call(this, { type: "pending", variables: t, isPaused: s }), yield (o = (i = b(this, Re).config).onMutate) == null ? void 0 : o.call(
            i,
            t,
            this
          );
          const k = yield (a = (l = this.options).onMutate) == null ? void 0 : a.call(l, t);
          k !== this.state.context && _e(this, ct, Mt).call(this, {
            type: "pending",
            context: k,
            variables: t,
            isPaused: s
          });
        }
        const x = yield b(this, sn).start();
        return yield (u = (c = b(this, Re).config).onSuccess) == null ? void 0 : u.call(
          c,
          x,
          t,
          this.state.context,
          this
        ), yield (h = (f = this.options).onSuccess) == null ? void 0 : h.call(f, x, t, this.state.context), yield (g = (m = b(this, Re).config).onSettled) == null ? void 0 : g.call(
          m,
          x,
          null,
          this.state.variables,
          this.state.context,
          this
        ), yield (M = (v = this.options).onSettled) == null ? void 0 : M.call(v, x, null, t, this.state.context), _e(this, ct, Mt).call(this, { type: "success", data: x }), x;
      } catch (x) {
        try {
          throw yield (P = (S = b(this, Re).config).onError) == null ? void 0 : P.call(
            S,
            x,
            t,
            this.state.context,
            this
          ), yield (T = ($ = this.options).onError) == null ? void 0 : T.call(
            $,
            x,
            t,
            this.state.context
          ), yield (j = (F = b(this, Re).config).onSettled) == null ? void 0 : j.call(
            F,
            void 0,
            x,
            this.state.variables,
            this.state.context,
            this
          ), yield (q = (Q = this.options).onSettled) == null ? void 0 : q.call(
            Q,
            void 0,
            x,
            t,
            this.state.context
          ), x;
        } finally {
          _e(this, ct, Mt).call(this, { type: "error", error: x });
        }
      } finally {
        b(this, Re).runNext(this);
      }
    });
  }
}, ut = new WeakMap(), Re = new WeakMap(), sn = new WeakMap(), ct = new WeakSet(), Mt = function(t) {
  const n = (s) => {
    switch (t.type) {
      case "failed":
        return ie(I({}, s), {
          failureCount: t.failureCount,
          failureReason: t.error
        });
      case "pause":
        return ie(I({}, s), {
          isPaused: !0
        });
      case "continue":
        return ie(I({}, s), {
          isPaused: !1
        });
      case "pending":
        return ie(I({}, s), {
          context: t.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: t.isPaused,
          status: "pending",
          variables: t.variables,
          submittedAt: Date.now()
        });
      case "success":
        return ie(I({}, s), {
          data: t.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        });
      case "error":
        return ie(I({}, s), {
          data: void 0,
          error: t.error,
          failureCount: s.failureCount + 1,
          failureReason: t.error,
          isPaused: !1,
          status: "error"
        });
    }
  };
  this.state = n(this.state), $e.batch(() => {
    b(this, ut).forEach((s) => {
      s.onMutationUpdate(t);
    }), b(this, Re).notify({
      mutation: this,
      type: "updated",
      action: t
    });
  });
}, ol);
function ud() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var Ve, us, ll, Na = (ll = class extends hr {
  constructor(n = {}) {
    super();
    X(this, Ve);
    X(this, us);
    this.config = n, B(this, Ve, /* @__PURE__ */ new Map()), B(this, us, Date.now());
  }
  build(n, s, r) {
    const i = new ad({
      mutationCache: this,
      mutationId: ++bs(this, us)._,
      options: n.defaultMutationOptions(s),
      state: r
    });
    return this.add(i), i;
  }
  add(n) {
    var i;
    const s = xs(n), r = (i = b(this, Ve).get(s)) != null ? i : [];
    r.push(n), b(this, Ve).set(s, r), this.notify({ type: "added", mutation: n });
  }
  remove(n) {
    var r;
    const s = xs(n);
    if (b(this, Ve).has(s)) {
      const i = (r = b(this, Ve).get(s)) == null ? void 0 : r.filter((o) => o !== n);
      i && (i.length === 0 ? b(this, Ve).delete(s) : b(this, Ve).set(s, i));
    }
    this.notify({ type: "removed", mutation: n });
  }
  canRun(n) {
    var r;
    const s = (r = b(this, Ve).get(xs(n))) == null ? void 0 : r.find((i) => i.state.status === "pending");
    return !s || s === n;
  }
  runNext(n) {
    var r, i;
    const s = (r = b(this, Ve).get(xs(n))) == null ? void 0 : r.find((o) => o !== n && o.state.isPaused);
    return (i = s == null ? void 0 : s.continue()) != null ? i : Promise.resolve();
  }
  clear() {
    $e.batch(() => {
      this.getAll().forEach((n) => {
        this.remove(n);
      });
    });
  }
  getAll() {
    return [...b(this, Ve).values()].flat();
  }
  find(n) {
    const s = I({ exact: !0 }, n);
    return this.getAll().find(
      (r) => Po(s, r)
    );
  }
  findAll(n = {}) {
    return this.getAll().filter((s) => Po(n, s));
  }
  notify(n) {
    $e.batch(() => {
      this.listeners.forEach((s) => {
        s(n);
      });
    });
  }
  resumePausedMutations() {
    const n = this.getAll().filter((s) => s.state.isPaused);
    return $e.batch(
      () => Promise.all(
        n.map((s) => s.continue().catch(Je))
      )
    );
  }
}, Ve = new WeakMap(), us = new WeakMap(), ll);
function xs(e) {
  var t, n;
  return (n = (t = e.options.scope) == null ? void 0 : t.id) != null ? n : String(e.mutationId);
}
function Do(e) {
  return {
    onFetch: (t, n) => {
      var u, f, h, m, g;
      const s = t.options, r = (h = (f = (u = t.fetchOptions) == null ? void 0 : u.meta) == null ? void 0 : f.fetchMore) == null ? void 0 : h.direction, i = ((m = t.state.data) == null ? void 0 : m.pages) || [], o = ((g = t.state.data) == null ? void 0 : g.pageParams) || [];
      let l = { pages: [], pageParams: [] }, a = 0;
      const c = () => ze(null, null, function* () {
        var $;
        let v = !1;
        const M = (T) => {
          Object.defineProperty(T, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? v = !0 : t.signal.addEventListener("abort", () => {
              v = !0;
            }), t.signal)
          });
        }, S = xa(t.options, t.fetchOptions), P = (T, F, j) => ze(null, null, function* () {
          if (v)
            return Promise.reject();
          if (F == null && T.pages.length)
            return Promise.resolve(T);
          const Q = {
            queryKey: t.queryKey,
            pageParam: F,
            direction: j ? "backward" : "forward",
            meta: t.options.meta
          };
          M(Q);
          const q = yield S(
            Q
          ), { maxPages: x } = t.options, k = j ? ed : Zf;
          return {
            pages: k(T.pages, q, x),
            pageParams: k(T.pageParams, F, x)
          };
        });
        if (r && i.length) {
          const T = r === "backward", F = T ? cd : No, j = {
            pages: i,
            pageParams: o
          }, Q = F(s, j);
          l = yield P(j, Q, T);
        } else {
          const T = e != null ? e : i.length;
          do {
            const F = a === 0 ? ($ = o[0]) != null ? $ : s.initialPageParam : No(s, l);
            if (a > 0 && F == null)
              break;
            l = yield P(l, F), a++;
          } while (a < T);
        }
        return l;
      });
      t.options.persister ? t.fetchFn = () => {
        var v, M;
        return (M = (v = t.options).persister) == null ? void 0 : M.call(
          v,
          c,
          {
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          n
        );
      } : t.fetchFn = c;
    }
  };
}
function No(e, { pages: t, pageParams: n }) {
  const s = t.length - 1;
  return t.length > 0 ? e.getNextPageParam(
    t[s],
    t,
    n[s],
    n
  ) : void 0;
}
function cd(e, { pages: t, pageParams: n }) {
  var s;
  return t.length > 0 ? (s = e.getPreviousPageParam) == null ? void 0 : s.call(e, t[0], t, n[0], n) : void 0;
}
var fe, Ft, jt, En, An, Lt, Pn, Mn, al, fd = (al = class {
  constructor(t = {}) {
    X(this, fe);
    X(this, Ft);
    X(this, jt);
    X(this, En);
    X(this, An);
    X(this, Lt);
    X(this, Pn);
    X(this, Mn);
    B(this, fe, t.queryCache || new Da()), B(this, Ft, t.mutationCache || new Na()), B(this, jt, t.defaultOptions || {}), B(this, En, /* @__PURE__ */ new Map()), B(this, An, /* @__PURE__ */ new Map()), B(this, Lt, 0);
  }
  mount() {
    bs(this, Lt)._++, b(this, Lt) === 1 && (B(this, Pn, Ea.subscribe((t) => ze(this, null, function* () {
      t && (yield this.resumePausedMutations(), b(this, fe).onFocus());
    }))), B(this, Mn, Gs.subscribe((t) => ze(this, null, function* () {
      t && (yield this.resumePausedMutations(), b(this, fe).onOnline());
    }))));
  }
  unmount() {
    var t, n;
    bs(this, Lt)._--, b(this, Lt) === 0 && ((t = b(this, Pn)) == null || t.call(this), B(this, Pn, void 0), (n = b(this, Mn)) == null || n.call(this), B(this, Mn, void 0));
  }
  isFetching(t) {
    return b(this, fe).findAll(ie(I({}, t), { fetchStatus: "fetching" })).length;
  }
  isMutating(t) {
    return b(this, Ft).findAll(ie(I({}, t), { status: "pending" })).length;
  }
  getQueryData(t) {
    var s;
    const n = this.defaultQueryOptions({ queryKey: t });
    return (s = b(this, fe).get(n.queryHash)) == null ? void 0 : s.state.data;
  }
  ensureQueryData(t) {
    const n = this.getQueryData(t.queryKey);
    if (n === void 0)
      return this.fetchQuery(t);
    {
      const s = this.defaultQueryOptions(t), r = b(this, fe).build(this, s);
      return t.revalidateIfStale && r.isStaleByTime(Eo(s.staleTime, r)) && this.prefetchQuery(s), Promise.resolve(n);
    }
  }
  getQueriesData(t) {
    return b(this, fe).findAll(t).map(({ queryKey: n, state: s }) => {
      const r = s.data;
      return [n, r];
    });
  }
  setQueryData(t, n, s) {
    const r = this.defaultQueryOptions({ queryKey: t }), i = b(this, fe).get(
      r.queryHash
    ), o = i == null ? void 0 : i.state.data, l = Wf(n, o);
    if (l !== void 0)
      return b(this, fe).build(this, r).setData(l, ie(I({}, s), { manual: !0 }));
  }
  setQueriesData(t, n, s) {
    return $e.batch(
      () => b(this, fe).findAll(t).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, n, s)
      ])
    );
  }
  getQueryState(t) {
    var s;
    const n = this.defaultQueryOptions({ queryKey: t });
    return (s = b(this, fe).get(n.queryHash)) == null ? void 0 : s.state;
  }
  removeQueries(t) {
    const n = b(this, fe);
    $e.batch(() => {
      n.findAll(t).forEach((s) => {
        n.remove(s);
      });
    });
  }
  resetQueries(t, n) {
    const s = b(this, fe), r = I({
      type: "active"
    }, t);
    return $e.batch(() => (s.findAll(t).forEach((i) => {
      i.reset();
    }), this.refetchQueries(r, n)));
  }
  cancelQueries(t = {}, n = {}) {
    const s = I({ revert: !0 }, n), r = $e.batch(
      () => b(this, fe).findAll(t).map((i) => i.cancel(s))
    );
    return Promise.all(r).then(Je).catch(Je);
  }
  invalidateQueries(t = {}, n = {}) {
    return $e.batch(() => {
      var r, i;
      if (b(this, fe).findAll(t).forEach((o) => {
        o.invalidate();
      }), t.refetchType === "none")
        return Promise.resolve();
      const s = ie(I({}, t), {
        type: (i = (r = t.refetchType) != null ? r : t.type) != null ? i : "active"
      });
      return this.refetchQueries(s, n);
    });
  }
  refetchQueries(t = {}, n) {
    var i;
    const s = ie(I({}, n), {
      cancelRefetch: (i = n == null ? void 0 : n.cancelRefetch) != null ? i : !0
    }), r = $e.batch(
      () => b(this, fe).findAll(t).filter((o) => !o.isDisabled()).map((o) => {
        let l = o.fetch(void 0, s);
        return s.throwOnError || (l = l.catch(Je)), o.state.fetchStatus === "paused" ? Promise.resolve() : l;
      })
    );
    return Promise.all(r).then(Je);
  }
  fetchQuery(t) {
    const n = this.defaultQueryOptions(t);
    n.retry === void 0 && (n.retry = !1);
    const s = b(this, fe).build(this, n);
    return s.isStaleByTime(
      Eo(n.staleTime, s)
    ) ? s.fetch(n) : Promise.resolve(s.state.data);
  }
  prefetchQuery(t) {
    return this.fetchQuery(t).then(Je).catch(Je);
  }
  fetchInfiniteQuery(t) {
    return t.behavior = Do(t.pages), this.fetchQuery(t);
  }
  prefetchInfiniteQuery(t) {
    return this.fetchInfiniteQuery(t).then(Je).catch(Je);
  }
  ensureInfiniteQueryData(t) {
    return t.behavior = Do(t.pages), this.ensureQueryData(t);
  }
  resumePausedMutations() {
    return Gs.isOnline() ? b(this, Ft).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return b(this, fe);
  }
  getMutationCache() {
    return b(this, Ft);
  }
  getDefaultOptions() {
    return b(this, jt);
  }
  setDefaultOptions(t) {
    B(this, jt, t);
  }
  setQueryDefaults(t, n) {
    b(this, En).set(ns(t), {
      queryKey: t,
      defaultOptions: n
    });
  }
  getQueryDefaults(t) {
    const n = [...b(this, En).values()];
    let s = {};
    return n.forEach((r) => {
      ss(t, r.queryKey) && (s = I(I({}, s), r.defaultOptions));
    }), s;
  }
  setMutationDefaults(t, n) {
    b(this, An).set(ns(t), {
      mutationKey: t,
      defaultOptions: n
    });
  }
  getMutationDefaults(t) {
    const n = [...b(this, An).values()];
    let s = {};
    return n.forEach((r) => {
      ss(t, r.mutationKey) && (s = I(I({}, s), r.defaultOptions));
    }), s;
  }
  defaultQueryOptions(t) {
    if (t._defaulted)
      return t;
    const n = ie(I(I(I({}, b(this, jt).queries), this.getQueryDefaults(t.queryKey)), t), {
      _defaulted: !0
    });
    return n.queryHash || (n.queryHash = Oi(
      n.queryKey,
      n
    )), n.refetchOnReconnect === void 0 && (n.refetchOnReconnect = n.networkMode !== "always"), n.throwOnError === void 0 && (n.throwOnError = !!n.suspense), !n.networkMode && n.persister && (n.networkMode = "offlineFirst"), n.enabled !== !0 && n.queryFn === Ta && (n.enabled = !1), n;
  }
  defaultMutationOptions(t) {
    return t != null && t._defaulted ? t : ie(I(I(I({}, b(this, jt).mutations), (t == null ? void 0 : t.mutationKey) && this.getMutationDefaults(t.mutationKey)), t), {
      _defaulted: !0
    });
  }
  clear() {
    b(this, fe).clear(), b(this, Ft).clear();
  }
}, fe = new WeakMap(), Ft = new WeakMap(), jt = new WeakMap(), En = new WeakMap(), An = new WeakMap(), Lt = new WeakMap(), Pn = new WeakMap(), Mn = new WeakMap(), al), dd = "VUE_QUERY_CLIENT";
function hd(e) {
  const t = e ? `:${e}` : "";
  return `${dd}${t}`;
}
function Sp(e, t) {
  Object.keys(e).forEach((n) => {
    e[n] = t[n];
  });
}
function Wr(e, t, n = "", s = 0) {
  if (t) {
    const r = t(e, n, s);
    if (r === void 0 && pe(e) || r !== void 0)
      return r;
  }
  if (Array.isArray(e))
    return e.map(
      (r, i) => Wr(r, t, String(i), s + 1)
    );
  if (typeof e == "object" && md(e)) {
    const r = Object.entries(e).map(([i, o]) => [
      i,
      Wr(o, t, i, s + 1)
    ]);
    return Object.fromEntries(r);
  }
  return e;
}
function pd(e, t) {
  return Wr(e, t);
}
function G(e, t = !1) {
  return pd(e, (n, s, r) => {
    if (r === 1 && s === "queryKey")
      return G(n, !0);
    if (t && gd(n))
      return G(n(), t);
    if (pe(n))
      return G(hi(n), t);
  });
}
function md(e) {
  if (Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function gd(e) {
  return typeof e == "function";
}
function wp(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
var yd = class extends Da {
  find(e) {
    return super.find(G(e));
  }
  findAll(e = {}) {
    return super.findAll(G(e));
  }
}, vd = class extends Na {
  find(e) {
    return super.find(G(e));
  }
  findAll(e = {}) {
    return super.findAll(G(e));
  }
}, $a = class extends fd {
  constructor(e = {}) {
    const t = {
      defaultOptions: e.defaultOptions,
      queryCache: e.queryCache || new yd(),
      mutationCache: e.mutationCache || new vd()
    };
    super(t), this.isRestoring = Vn(!1);
  }
  isFetching(e = {}) {
    return super.isFetching(G(e));
  }
  isMutating(e = {}) {
    return super.isMutating(G(e));
  }
  getQueryData(e) {
    return super.getQueryData(G(e));
  }
  ensureQueryData(e) {
    return super.ensureQueryData(G(e));
  }
  getQueriesData(e) {
    return super.getQueriesData(G(e));
  }
  setQueryData(e, t, n = {}) {
    return super.setQueryData(
      G(e),
      t,
      G(n)
    );
  }
  setQueriesData(e, t, n = {}) {
    return super.setQueriesData(
      G(e),
      t,
      G(n)
    );
  }
  getQueryState(e) {
    return super.getQueryState(G(e));
  }
  removeQueries(e = {}) {
    return super.removeQueries(G(e));
  }
  resetQueries(e = {}, t = {}) {
    return super.resetQueries(G(e), G(t));
  }
  cancelQueries(e = {}, t = {}) {
    return super.cancelQueries(G(e), G(t));
  }
  invalidateQueries(e = {}, t = {}) {
    var i, o;
    const n = G(e), s = G(t);
    if (super.invalidateQueries(
      ie(I({}, n), { refetchType: "none" }),
      s
    ), n.refetchType === "none")
      return Promise.resolve();
    const r = ie(I({}, n), {
      type: (o = (i = n.refetchType) != null ? i : n.type) != null ? o : "active"
    });
    return ds().then(() => super.refetchQueries(r, s));
  }
  refetchQueries(e = {}, t = {}) {
    return super.refetchQueries(
      G(e),
      G(t)
    );
  }
  fetchQuery(e) {
    return super.fetchQuery(G(e));
  }
  prefetchQuery(e) {
    return super.prefetchQuery(G(e));
  }
  fetchInfiniteQuery(e) {
    return super.fetchInfiniteQuery(G(e));
  }
  prefetchInfiniteQuery(e) {
    return super.prefetchInfiniteQuery(G(e));
  }
  setDefaultOptions(e) {
    super.setDefaultOptions(G(e));
  }
  setQueryDefaults(e, t) {
    super.setQueryDefaults(G(e), G(t));
  }
  getQueryDefaults(e) {
    return super.getQueryDefaults(G(e));
  }
  setMutationDefaults(e, t) {
    super.setMutationDefaults(
      G(e),
      G(t)
    );
  }
  getMutationDefaults(e) {
    return super.getMutationDefaults(G(e));
  }
}, bd = {
  install: (e, t = {}) => {
    const n = hd(t.queryClientKey);
    let s;
    if ("queryClient" in t && t.queryClient)
      s = t.queryClient;
    else {
      const o = "queryClientConfig" in t ? t.queryClientConfig : void 0;
      s = new $a(o);
    }
    ps || s.mount();
    let r = () => {
    };
    if (t.clientPersister) {
      s.isRestoring.value = !0;
      const [o, l] = t.clientPersister(s);
      r = o, l.then(() => {
        var a;
        s.isRestoring.value = !1, (a = t.clientPersisterOnSuccess) == null || a.call(t, s);
      });
    }
    const i = () => {
      s.unmount(), r();
    };
    if (e.onUnmount)
      e.onUnmount(i);
    else {
      const o = e.unmount;
      e.unmount = function() {
        i(), o();
      };
    }
    e.provide(n, s);
  }
};
const Ia = "https://sdk.offsetcommerce.com/v1/";
function zs(e, t = null) {
  if (t === null) {
    if (typeof window != "undefined") {
      const n = window.localStorage.getItem(`offset-${e}`);
      if (n)
        return JSON.parse(n);
    }
    return null;
  } else
    typeof window != "undefined" && window.localStorage.setItem(`offset-${e}`, JSON.stringify(t));
}
function $o(e) {
  return ["config"].some(
    (t) => e.startsWith(t)
  );
}
let js = {}, Ti = "cart";
function Cp(e) {
  Ti = e;
}
function Fa() {
  return Ti;
}
function Op() {
  var t, n, s, r;
  const e = Fa();
  return e === "offering" ? ((t = window.OFFSET) == null ? void 0 : t.checkoutOfferingUrl) || "/offering-checkout" : e === "event" ? ((n = window.OFFSET) == null ? void 0 : n.checkoutEventUrl) || "/event-checkout" : (r = (s = window.OFFSET) == null ? void 0 : s.checkoutUrl) != null ? r : "/checkout";
}
function Tp() {
  if (js = {}, typeof window != "undefined")
    for (const e of ["cart", "offering", "invoice"]) {
      const t = e === "cart" ? "session-id" : `session-id-${e}`;
      window.localStorage.removeItem(`offset-${t}`);
    }
}
function _d() {
  return ze(this, arguments, function* (e = {}) {
    if (!mn(e.sessionId))
      return e.sessionId;
    const t = Ti, n = t === "cart" ? "session-id" : `session-id-${t}`, s = zs(n);
    return mn(s) ? (js[t] || (js[t] = Sd("cart/session", {
      method: "POST",
      skipSessionId: !0,
      body: JSON.stringify({ type: t })
    }).then((r) => (zs(n, r), r))), js[t]) : s;
  });
}
function Sd(n) {
  return ze(this, arguments, function* (e, t = {}) {
    const s = t.skipSessionId ? null : yield _d(t);
    function r() {
      return ze(this, null, function* () {
        var m;
        const i = I({
          Accept: "application/json",
          "Content-Type": "application/json"
        }, (t == null ? void 0 : t.headers) || {}), l = Ia + e;
        i["X-API-Key"] = (m = window.OFFSET) == null ? void 0 : m.apiKey, mn(s) || (i["X-Session-Id"] = s);
        const a = wd(e);
        if (a)
          return ja(`Using inline data for endpoint ${e}`), a;
        const u = typeof window != "undefined" && new URLSearchParams(window.location.search).get("cantina") === "true" ? l + (l.includes("?") ? "&" : "?") + "cantina=true" : l, f = yield fetch(u, I({
          mode: "cors",
          credentials: "include",
          headers: i
        }, t));
        if (f.status === 200) {
          const g = yield f.json();
          if (g != null && !mn(g.error) && g.error === "Authentication Required")
            throw new Error("Authentication Required");
          return g != null && mn(g.error) && $o(e) && zs(e, g), g;
        }
        let h = `Request failed with status ${f.status} for endpoint ${e}`;
        try {
          const g = yield f.json();
          mn(g == null ? void 0 : g.error) || (h = g.error);
        } catch (g) {
        }
        throw new Error(h);
      });
    }
    if ($o(e)) {
      const i = zs(e);
      if (i)
        return r(), i;
    }
    return yield r();
  });
}
function wd(e) {
  const t = document.querySelector(
    `[data-offset-inline="${e}"]`
  );
  if (t)
    try {
      const n = t.content ? t.content.textContent : t.textContent && t.textContent != "" ? t.textContent : "{}";
      return JSON.parse(n);
    } catch (n) {
      ja(`Error parsing inline data for endpoint ${e}:`, n);
    }
  return null;
}
function mn(e) {
  return !e || e == null || e === "";
}
function Cd(e) {
  const t = `[${e}]`;
  return (...n) => {
    var s;
    (s = window.OFFSET) != null && s.debug && console.log(t, ...n);
  };
}
const ja = Cd("offset-core");
var Od = {
  // We need the wrapper function syntax below instead of direct references to
  // global setTimeout etc.
  //
  // BAD: `setTimeout: setTimeout`
  // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
  //
  // If we use direct references here, then anything that wants to spy on or
  // replace the global setTimeout (like tests) won't work since we'll already
  // have a hard reference to the original implementation at the time when this
  // file was imported.
  setTimeout: (e, t) => setTimeout(e, t),
  clearTimeout: (e) => clearTimeout(e),
  setInterval: (e, t) => setInterval(e, t),
  clearInterval: (e) => clearInterval(e)
}, kt, Xr, ul, Td = (ul = class {
  constructor() {
    // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
    // type at app boot; and if we leave that type, then any new timer provider
    // would need to support the default provider's concrete timer ID, which is
    // infeasible across environments.
    //
    // We settle for type safety for the TimeoutProvider type, and accept that
    // this class is unsafe internally to allow for extension.
    X(this, kt, Od);
    X(this, Xr, !1);
  }
  setTimeoutProvider(e) {
    B(this, kt, e);
  }
  setTimeout(e, t) {
    return b(this, kt).setTimeout(e, t);
  }
  clearTimeout(e) {
    b(this, kt).clearTimeout(e);
  }
  setInterval(e, t) {
    return b(this, kt).setInterval(e, t);
  }
  clearInterval(e) {
    b(this, kt).clearInterval(e);
  }
}, kt = new WeakMap(), Xr = new WeakMap(), ul), xd = new Td();
function Ys() {
}
function Ed(e) {
  var n;
  let t;
  if ((n = e.then((s) => (t = s, s), Ys)) == null || n.catch(Ys), t !== void 0)
    return { data: t };
}
function La(e) {
  return e;
}
function Ad(e) {
  return I(I({
    mutationKey: e.options.mutationKey,
    state: e.state
  }, e.options.scope && { scope: e.options.scope }), e.meta && { meta: e.meta });
}
function Pd(e, t, n) {
  const s = () => {
    var i;
    const r = (i = e.promise) == null ? void 0 : i.then(t).catch((o) => n(o) ? Promise.reject(new Error("redacted")) : Promise.reject(o));
    return r == null || r.catch(Ys), r;
  };
  return I(I(I({
    dehydratedAt: Date.now(),
    state: I(I({}, e.state), e.state.data !== void 0 && {
      data: t(e.state.data)
    }),
    queryKey: e.queryKey,
    queryHash: e.queryHash
  }, e.state.status === "pending" && {
    promise: s()
  }), e.meta && { meta: e.meta }), e.queryType && { queryType: e.queryType });
}
function Md(e) {
  return e.state.isPaused;
}
function Rd(e) {
  return e.state.status === "success";
}
function Dd(e) {
  return !0;
}
function Nd(e, t = {}) {
  var a, c, u, f, h, m, g, v, M, S, P, $;
  const n = (u = (c = t.shouldDehydrateMutation) != null ? c : (a = e.getDefaultOptions().dehydrate) == null ? void 0 : a.shouldDehydrateMutation) != null ? u : Md, s = e.getMutationCache().getAll().flatMap(
    (T) => n(T) ? [Ad(T)] : []
  ), r = (m = (h = t.shouldDehydrateQuery) != null ? h : (f = e.getDefaultOptions().dehydrate) == null ? void 0 : f.shouldDehydrateQuery) != null ? m : Rd, i = (M = (v = t.shouldRedactErrors) != null ? v : (g = e.getDefaultOptions().dehydrate) == null ? void 0 : g.shouldRedactErrors) != null ? M : Dd, o = ($ = (P = t.serializeData) != null ? P : (S = e.getDefaultOptions().dehydrate) == null ? void 0 : S.serializeData) != null ? $ : La, l = e.getQueryCache().getAll().flatMap(
    (T) => r(T) ? [Pd(T, o, i)] : []
  );
  return { mutations: s, queries: l };
}
function $d(e, t, n) {
  var a, c, u, f;
  if (typeof t != "object" || t === null)
    return;
  const s = e.getMutationCache(), r = e.getQueryCache(), i = (f = (u = (a = n == null ? void 0 : n.defaultOptions) == null ? void 0 : a.deserializeData) != null ? u : (c = e.getDefaultOptions().hydrate) == null ? void 0 : c.deserializeData) != null ? f : La, o = t.mutations || [], l = t.queries || [];
  o.forEach((g) => {
    var v = g, { state: h } = v, m = pr(v, ["state"]);
    var M, S;
    s.build(
      e,
      I(I(I({}, (M = e.getDefaultOptions().hydrate) == null ? void 0 : M.mutations), (S = n == null ? void 0 : n.defaultOptions) == null ? void 0 : S.mutations), m),
      h
    );
  }), l.forEach(
    ({
      queryKey: h,
      state: m,
      queryHash: g,
      meta: v,
      promise: M,
      dehydratedAt: S,
      queryType: P
    }) => {
      var k, W;
      const $ = M ? Ed(M) : void 0, T = m.data === void 0 ? $ == null ? void 0 : $.data : m.data, F = T === void 0 ? T : i(T);
      let j = r.get(g);
      const Q = (j == null ? void 0 : j.state.status) === "pending", q = (j == null ? void 0 : j.state.fetchStatus) === "fetching";
      if (j) {
        const N = $ && // We only need this undefined check to handle older dehydration
        // payloads that might not have dehydratedAt
        S !== void 0 && S > j.state.dataUpdatedAt;
        if (m.dataUpdatedAt > j.state.dataUpdatedAt || N) {
          const x = m, { fetchStatus: Y } = x, re = pr(x, ["fetchStatus"]);
          j.setState(I(ie(I({}, re), {
            data: F
          }), m.status === "pending" && F !== void 0 && I({
            status: "success"
          }, !q && {
            fetchStatus: "idle"
          })));
        }
      } else
        j = r.build(
          e,
          ie(I(I({}, (k = e.getDefaultOptions().hydrate) == null ? void 0 : k.queries), (W = n == null ? void 0 : n.defaultOptions) == null ? void 0 : W.queries), {
            queryKey: h,
            queryHash: g,
            meta: v,
            _type: P
          }),
          // Reset fetch status to idle to avoid
          // query being stuck in fetching state upon hydration
          ie(I({}, m), {
            data: F,
            fetchStatus: "idle",
            // Like above, if the query was pending at the moment of dehydration but has data,
            // we can assume it should be hydrated as successful.
            status: m.status === "pending" && F !== void 0 ? "success" : m.status
          })
        );
      M && // If the data was synchronously available, there is no need to set up
      // a retryer and thus no reason to call fetch
      !$ && !Q && !q && // Only hydrate if dehydration is newer than any existing data,
      // this is always true for new queries
      (S === void 0 || S > j.state.dataUpdatedAt) && j.fetch(void 0, {
        // RSC transformed promises are not thenable
        initialPromise: Promise.resolve(M).then(i)
      }).catch(Ys);
    }
  );
}
var Id = ["added", "removed", "updated"];
function Io(e) {
  return Id.includes(e);
}
function Fd(i) {
  return ze(this, arguments, function* ({
    queryClient: e,
    persister: t,
    maxAge: n = 1e3 * 60 * 60 * 24,
    buster: s = "",
    hydrateOptions: r
  }) {
    try {
      const o = yield t.restoreClient();
      if (o)
        if (o.timestamp) {
          const l = Date.now() - o.timestamp > n, a = o.buster !== s;
          if (l || a)
            return t.removeClient();
          $d(e, o.clientState, r);
        } else
          return t.removeClient();
    } catch (o) {
      throw yield t.removeClient(), o;
    }
  });
}
function Fo(r) {
  return ze(this, arguments, function* ({
    queryClient: e,
    persister: t,
    buster: n = "",
    dehydrateOptions: s
  }) {
    const i = {
      buster: n,
      timestamp: Date.now(),
      clientState: Nd(e, s)
    };
    yield t.persistClient(i);
  });
}
function jd(e) {
  const t = e.queryClient.getQueryCache().subscribe((s) => {
    Io(s.type) && Fo(e);
  }), n = e.queryClient.getMutationCache().subscribe((s) => {
    Io(s.type) && Fo(e);
  });
  return () => {
    t(), n();
  };
}
function Ld(e) {
  let t = !1, n;
  const s = () => {
    t = !0, n == null || n();
  }, r = Fd(e).then(() => {
    t || (n = jd(e));
  });
  return [s, r];
}
function Ar() {
}
function kd({
  storage: e,
  key: t = "REACT_QUERY_OFFLINE_CACHE",
  throttleTime: n = 1e3,
  serialize: s = JSON.stringify,
  deserialize: r = JSON.parse,
  retry: i
}) {
  if (e) {
    const o = (l) => {
      try {
        e.setItem(t, s(l));
        return;
      } catch (a) {
        return a;
      }
    };
    return {
      persistClient: Ud((l) => {
        let a = l, c = o(a), u = 0;
        for (; c && a; )
          u++, a = i == null ? void 0 : i({
            persistedClient: a,
            error: c,
            errorCount: u
          }), a && (c = o(a));
      }, n),
      restoreClient: () => {
        const l = e.getItem(t);
        if (l)
          return r(l);
      },
      removeClient: () => {
        e.removeItem(t);
      }
    };
  }
  return {
    persistClient: Ar,
    restoreClient: Ar,
    removeClient: Ar
  };
}
function Ud(e, t = 100) {
  let n = null, s;
  return function(...r) {
    s = r, n === null && (n = xd.setTimeout(() => {
      e(...s), n = null;
    }, t));
  };
}
var Hd = Object.defineProperty, jo = Object.getOwnPropertySymbols, Vd = Object.prototype.hasOwnProperty, Kd = Object.prototype.propertyIsEnumerable, Lo = (e, t, n) => t in e ? Hd(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Qd = (e, t) => {
  for (var n in t || (t = {})) Vd.call(t, n) && Lo(e, n, t[n]);
  if (jo) for (var n of jo(t)) Kd.call(t, n) && Lo(e, n, t[n]);
  return e;
};
function xi(e) {
  return e == null || e === "" || Array.isArray(e) && e.length === 0 || !(e instanceof Date) && typeof e == "object" && Object.keys(e).length === 0;
}
function qd(e) {
  return typeof e == "function" && "call" in e && "apply" in e;
}
function he(e) {
  return !xi(e);
}
function Ht(e, t = !0) {
  return e instanceof Object && e.constructor === Object && (t || Object.keys(e).length !== 0);
}
function ka(e = {}, t = {}) {
  let n = Qd({}, e);
  return Object.keys(t).forEach((s) => {
    let r = s;
    Ht(t[r]) && r in e && Ht(e[r]) ? n[r] = ka(e[r], t[r]) : n[r] = t[r];
  }), n;
}
function Bd(...e) {
  return e.reduce((t, n, s) => s === 0 ? n : ka(t, n), {});
}
function dt(e, ...t) {
  return qd(e) ? e(...t) : e;
}
function qt(e, t = !0) {
  return typeof e == "string" && (t || e !== "");
}
function ko(e) {
  return qt(e) ? e.replace(/(-|_)/g, "").toLowerCase() : e;
}
function Wd(e, t = "", n = {}) {
  let s = ko(t).split("."), r = s.shift();
  if (r) {
    if (Ht(e)) {
      let i = Object.keys(e).find((o) => ko(o) === r) || "";
      return Wd(dt(e[i], n), s.join("."), n);
    }
    return;
  }
  return dt(e, n);
}
function xp(e, t = !0) {
  return Array.isArray(e) && (t || e.length !== 0);
}
function Ep(e) {
  return e instanceof Date;
}
function Gd(e) {
  return he(e) && !isNaN(e);
}
function Ap() {
  return new Intl.Collator(void 0, { numeric: !0 }).compare;
}
function ln(e, t) {
  if (t) {
    let n = t.test(e);
    return t.lastIndex = 0, n;
  }
  return !1;
}
function zd(...e) {
  return Bd(...e);
}
function Wn(e) {
  return e && e.replace(/\/\*(?:(?!\*\/)[\s\S])*\*\/|[\r\n\t]+/g, "").replace(/ {2,}/g, " ").replace(/ ([{:}]) /g, "$1").replace(/([;,]) /g, "$1").replace(/ !/g, "!").replace(/: /g, ":").trim();
}
function Pp(e) {
  return qt(e, !1) ? e[0].toUpperCase() + e.slice(1) : e;
}
function Ua(e) {
  return qt(e) ? e.replace(/(_)/g, "-").replace(/[A-Z]/g, (t, n) => n === 0 ? t : "-" + t.toLowerCase()).toLowerCase() : e;
}
function Ha() {
  let e = /* @__PURE__ */ new Map();
  return { on(t, n) {
    let s = e.get(t);
    return s ? s.push(n) : s = [n], e.set(t, s), this;
  }, off(t, n) {
    let s = e.get(t);
    return s && s.splice(s.indexOf(n) >>> 0, 1), this;
  }, emit(t, n) {
    let s = e.get(t);
    s && s.forEach((r) => {
      r(n);
    });
  }, clear() {
    e.clear();
  } };
}
function Yd(e, t) {
  return e ? e.classList ? e.classList.contains(t) : new RegExp("(^| )" + t + "( |$)", "gi").test(e.className) : !1;
}
function Mp(e, t) {
  if (e && t) {
    let n = (s) => {
      Yd(e, s) || (e.classList ? e.classList.add(s) : e.className += " " + s);
    };
    [t].flat().filter(Boolean).forEach((s) => s.split(" ").forEach(n));
  }
}
function Rp(e, t) {
  if (e && t) {
    let n = (s) => {
      e.classList ? e.classList.remove(s) : e.className = e.className.replace(new RegExp("(^|\\b)" + s.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    };
    [t].flat().filter(Boolean).forEach((s) => s.split(" ").forEach(n));
  }
}
function Gr(e) {
  for (let t of document == null ? void 0 : document.styleSheets) try {
    for (let n of t == null ? void 0 : t.cssRules) for (let s of n == null ? void 0 : n.style) if (e.test(s)) return { name: s, value: n.style.getPropertyValue(s).trim() };
  } catch (n) {
  }
  return null;
}
function Va(e) {
  let t = { width: 0, height: 0 };
  if (e) {
    let [n, s] = [e.style.visibility, e.style.display];
    e.style.visibility = "hidden", e.style.display = "block", t.width = e.offsetWidth, t.height = e.offsetHeight, e.style.display = s, e.style.visibility = n;
  }
  return t;
}
function Ka() {
  let e = window, t = document, n = t.documentElement, s = t.getElementsByTagName("body")[0], r = e.innerWidth || n.clientWidth || s.clientWidth, i = e.innerHeight || n.clientHeight || s.clientHeight;
  return { width: r, height: i };
}
function zr(e) {
  return e ? Math.abs(e.scrollLeft) : 0;
}
function Jd() {
  let e = document.documentElement;
  return (window.pageXOffset || zr(e)) - (e.clientLeft || 0);
}
function Xd() {
  let e = document.documentElement;
  return (window.pageYOffset || e.scrollTop) - (e.clientTop || 0);
}
function Zd(e) {
  return e ? getComputedStyle(e).direction === "rtl" : !1;
}
function Dp(e, t, n = !0) {
  var s, r, i, o;
  if (e) {
    let l = e.offsetParent ? { width: e.offsetWidth, height: e.offsetHeight } : Va(e), a = l.height, c = l.width, u = t.offsetHeight, f = t.offsetWidth, h = t.getBoundingClientRect(), m = Xd(), g = Jd(), v = Ka(), M, S, P = "top";
    h.top + u + a > v.height ? (M = h.top + m - a, P = "bottom", M < 0 && (M = m)) : M = u + h.top + m, h.left + c > v.width ? S = Math.max(0, h.left + g + f - c) : S = h.left + g, Zd(e) ? e.style.insetInlineEnd = S + "px" : e.style.insetInlineStart = S + "px", e.style.top = M + "px", e.style.transformOrigin = P, n && (e.style.marginTop = P === "bottom" ? `calc(${(r = (s = Gr(/-anchor-gutter$/)) == null ? void 0 : s.value) != null ? r : "2px"} * -1)` : (o = (i = Gr(/-anchor-gutter$/)) == null ? void 0 : i.value) != null ? o : "");
  }
}
function Np(e, t) {
  e && (typeof t == "string" ? e.style.cssText = t : Object.entries(t || {}).forEach(([n, s]) => e.style[n] = s));
}
function $p(e, t) {
  return e instanceof HTMLElement ? e.offsetWidth : 0;
}
function Ip(e, t, n = !0, s = void 0) {
  var r;
  if (e) {
    let i = e.offsetParent ? { width: e.offsetWidth, height: e.offsetHeight } : Va(e), o = t.offsetHeight, l = t.getBoundingClientRect(), a = Ka(), c, u, f = s != null ? s : "top";
    if (!s && l.top + o + i.height > a.height ? (c = -1 * i.height, f = "bottom", l.top + c < 0 && (c = -1 * l.top)) : c = o, i.width > a.width ? u = l.left * -1 : l.left + i.width > a.width ? u = (l.left + i.width - a.width) * -1 : u = 0, e.style.top = c + "px", e.style.insetInlineStart = u + "px", e.style.transformOrigin = f, n) {
      let h = (r = Gr(/-anchor-gutter$/)) == null ? void 0 : r.value;
      e.style.marginTop = f === "bottom" ? `calc(${h != null ? h : "2px"} * -1)` : h != null ? h : "";
    }
  }
}
function Ei(e) {
  if (e) {
    let t = e.parentNode;
    return t && t instanceof ShadowRoot && t.host && (t = t.host), t;
  }
  return null;
}
function eh(e) {
  return !!(e !== null && typeof e != "undefined" && e.nodeName && Ei(e));
}
function ms(e) {
  return typeof Element != "undefined" ? e instanceof Element : e !== null && typeof e == "object" && e.nodeType === 1 && typeof e.nodeName == "string";
}
function Js(e, t = {}) {
  if (ms(e)) {
    let n = (s, r) => {
      var i, o;
      let l = (i = e == null ? void 0 : e.$attrs) != null && i[s] ? [(o = e == null ? void 0 : e.$attrs) == null ? void 0 : o[s]] : [];
      return [r].flat().reduce((a, c) => {
        if (c != null) {
          let u = typeof c;
          if (u === "string" || u === "number") a.push(c);
          else if (u === "object") {
            let f = Array.isArray(c) ? n(s, c) : Object.entries(c).map(([h, m]) => s === "style" && (m || m === 0) ? `${h.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}:${m}` : m ? h : void 0);
            a = f.length ? a.concat(f.filter((h) => !!h)) : a;
          }
        }
        return a;
      }, l);
    };
    Object.entries(t).forEach(([s, r]) => {
      if (r != null) {
        let i = s.match(/^on(.+)/);
        i ? e.addEventListener(i[1].toLowerCase(), r) : s === "p-bind" || s === "pBind" ? Js(e, r) : (r = s === "class" ? [...new Set(n("class", r))].join(" ").trim() : s === "style" ? n("style", r).join(";").trim() : r, (e.$attrs = e.$attrs || {}) && (e.$attrs[s] = r), e.setAttribute(s, r));
      }
    });
  }
}
function Fp(e, t = {}, ...n) {
  {
    let s = document.createElement(e);
    return Js(s, t), s.append(...n), s;
  }
}
function th(e, t) {
  return ms(e) ? Array.from(e.querySelectorAll(t)) : [];
}
function nh(e, t) {
  return ms(e) ? e.matches(t) ? e : e.querySelector(t) : null;
}
function jp(e, t) {
  if (ms(e)) {
    let n = e.getAttribute(t);
    return isNaN(n) ? n === "true" || n === "false" ? n === "true" : n : +n;
  }
}
function Lp(e, t = "") {
  let n = th(e, `button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [href]:not([tabindex = "-1"]):not([style*="display:none"]):not([hidden])${t},
            input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t}`), s = [];
  for (let r of n) getComputedStyle(r).display != "none" && getComputedStyle(r).visibility != "hidden" && s.push(r);
  return s;
}
function kp(e) {
  if (e) {
    let t = e.offsetHeight, n = getComputedStyle(e);
    return t -= parseFloat(n.paddingTop) + parseFloat(n.paddingBottom) + parseFloat(n.borderTopWidth) + parseFloat(n.borderBottomWidth), t;
  }
  return 0;
}
function Up(e) {
  var t;
  if (e) {
    let n = (t = Ei(e)) == null ? void 0 : t.childNodes, s = 0;
    if (n) for (let r = 0; r < n.length; r++) {
      if (n[r] === e) return s;
      n[r].nodeType === 1 && s++;
    }
  }
  return -1;
}
function Hp(e) {
  if (e) {
    let t = e.getBoundingClientRect();
    return { top: t.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0), left: t.left + (window.pageXOffset || zr(document.documentElement) || zr(document.body) || 0) };
  }
  return { top: "auto", left: "auto" };
}
function Vp(e, t) {
  return e ? e.offsetHeight : 0;
}
function Qa(e, t = []) {
  let n = Ei(e);
  return n === null ? t : Qa(n, t.concat([n]));
}
function Kp(e) {
  let t = [];
  if (e) {
    let n = Qa(e), s = /(auto|scroll)/, r = (i) => {
      try {
        let o = window.getComputedStyle(i, null);
        return s.test(o.getPropertyValue("overflow")) || s.test(o.getPropertyValue("overflowX")) || s.test(o.getPropertyValue("overflowY"));
      } catch (o) {
        return !1;
      }
    };
    for (let i of n) {
      let o = i.nodeType === 1 && i.dataset.scrollselectors;
      if (o) {
        let l = o.split(",");
        for (let a of l) {
          let c = nh(i, a);
          c && r(c) && t.push(c);
        }
      }
      i.nodeType !== 9 && r(i) && t.push(i);
    }
  }
  return t;
}
function Qp(e) {
  if (e) {
    let t = e.offsetWidth, n = getComputedStyle(e);
    return t -= parseFloat(n.paddingLeft) + parseFloat(n.paddingRight) + parseFloat(n.borderLeftWidth) + parseFloat(n.borderRightWidth), t;
  }
  return 0;
}
function sh() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}
function qp() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
function rh(e, t = "", n) {
  ms(e) && n !== null && n !== void 0 && e.setAttribute(t, n);
}
var ih = Object.defineProperty, oh = Object.defineProperties, lh = Object.getOwnPropertyDescriptors, Xs = Object.getOwnPropertySymbols, qa = Object.prototype.hasOwnProperty, Ba = Object.prototype.propertyIsEnumerable, Uo = (e, t, n) => t in e ? ih(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ze = (e, t) => {
  for (var n in t || (t = {})) qa.call(t, n) && Uo(e, n, t[n]);
  if (Xs) for (var n of Xs(t)) Ba.call(t, n) && Uo(e, n, t[n]);
  return e;
}, Pr = (e, t) => oh(e, lh(t)), gt = (e, t) => {
  var n = {};
  for (var s in e) qa.call(e, s) && t.indexOf(s) < 0 && (n[s] = e[s]);
  if (e != null && Xs) for (var s of Xs(e)) t.indexOf(s) < 0 && Ba.call(e, s) && (n[s] = e[s]);
  return n;
}, ah = Ha(), bt = ah, rs = /{([^}]*)}/g, Wa = /(\d+\s+[\+\-\*\/]\s+\d+)/g, Ga = /var\([^)]+\)/g;
function Ho(e) {
  return qt(e) ? e.replace(/[A-Z]/g, (t, n) => n === 0 ? t : "." + t.toLowerCase()).toLowerCase() : e;
}
function uh(e) {
  return Ht(e) && e.hasOwnProperty("$value") && e.hasOwnProperty("$type") ? e.$value : e;
}
function ch(e) {
  return e.replaceAll(/ /g, "").replace(/[^\w]/g, "-");
}
function Yr(e = "", t = "") {
  return ch(`${qt(e, !1) && qt(t, !1) ? `${e}-` : e}${t}`);
}
function za(e = "", t = "") {
  return `--${Yr(e, t)}`;
}
function fh(e = "") {
  let t = (e.match(/{/g) || []).length, n = (e.match(/}/g) || []).length;
  return (t + n) % 2 !== 0;
}
function Ya(e, t = "", n = "", s = [], r) {
  if (qt(e)) {
    let i = e.trim();
    if (fh(i)) return;
    if (ln(i, rs)) {
      let o = i.replaceAll(rs, (l) => {
        let a = l.replace(/{|}/g, "").split(".").filter((c) => !s.some((u) => ln(c, u)));
        return `var(${za(n, Ua(a.join("-")))}${he(r) ? `, ${r}` : ""})`;
      });
      return ln(o.replace(Ga, "0"), Wa) ? `calc(${o})` : o;
    }
    return i;
  } else if (Gd(e)) return e;
}
function dh(e, t, n) {
  qt(t, !1) && e.push(`${t}:${n};`);
}
function pn(e, t) {
  return e ? `${e}{${t}}` : "";
}
function Ja(e, t) {
  if (e.indexOf("dt(") === -1) return e;
  function n(o, l) {
    let a = [], c = 0, u = "", f = null, h = 0;
    for (; c <= o.length; ) {
      let m = o[c];
      if ((m === '"' || m === "'" || m === "`") && o[c - 1] !== "\\" && (f = f === m ? null : m), !f && (m === "(" && h++, m === ")" && h--, (m === "," || c === o.length) && h === 0)) {
        let g = u.trim();
        g.startsWith("dt(") ? a.push(Ja(g, l)) : a.push(s(g)), u = "", c++;
        continue;
      }
      m !== void 0 && (u += m), c++;
    }
    return a;
  }
  function s(o) {
    let l = o[0];
    if ((l === '"' || l === "'" || l === "`") && o[o.length - 1] === l) return o.slice(1, -1);
    let a = Number(o);
    return isNaN(a) ? o : a;
  }
  let r = [], i = [];
  for (let o = 0; o < e.length; o++) if (e[o] === "d" && e.slice(o, o + 3) === "dt(") i.push(o), o += 2;
  else if (e[o] === ")" && i.length > 0) {
    let l = i.pop();
    i.length === 0 && r.push([l, o]);
  }
  if (!r.length) return e;
  for (let o = r.length - 1; o >= 0; o--) {
    let [l, a] = r[o], c = e.slice(l + 3, a), u = n(c, t), f = t(...u);
    e = e.slice(0, l) + f + e.slice(a + 1);
  }
  return e;
}
var an = (...e) => hh(Oe.getTheme(), ...e), hh = (e = {}, t, n, s) => {
  if (t) {
    let { variable: r, options: i } = Oe.defaults || {}, { prefix: o, transform: l } = (e == null ? void 0 : e.options) || i || {}, a = ln(t, rs) ? t : `{${t}}`;
    return s === "value" || xi(s) && l === "strict" ? Oe.getTokenValue(t) : Ya(a, void 0, o, [r.excludedKeyRegex], n);
  }
  return "";
};
function Es(e, ...t) {
  if (e instanceof Array) {
    let n = e.reduce((s, r, i) => {
      var o;
      return s + r + ((o = dt(t[i], { dt: an })) != null ? o : "");
    }, "");
    return Ja(n, an);
  }
  return dt(e, { dt: an });
}
function ph(e, t = {}) {
  let n = Oe.defaults.variable, { prefix: s = n.prefix, selector: r = n.selector, excludedKeyRegex: i = n.excludedKeyRegex } = t, o = [], l = [], a = [{ node: e, path: s }];
  for (; a.length; ) {
    let { node: u, path: f } = a.pop();
    for (let h in u) {
      let m = u[h], g = uh(m), v = ln(h, i) ? Yr(f) : Yr(f, Ua(h));
      if (Ht(g)) a.push({ node: g, path: v });
      else {
        let M = za(v), S = Ya(g, v, s, [i]);
        dh(l, M, S);
        let P = v;
        s && P.startsWith(s + "-") && (P = P.slice(s.length + 1)), o.push(P.replace(/-/g, "."));
      }
    }
  }
  let c = l.join("");
  return { value: l, tokens: o, declarations: c, css: pn(r, c) };
}
var Ye = { regex: { rules: { class: { pattern: /^\.([a-zA-Z][\w-]*)$/, resolve(e) {
  return { type: "class", selector: e, matched: this.pattern.test(e.trim()) };
} }, attr: { pattern: /^\[(.*)\]$/, resolve(e) {
  return { type: "attr", selector: `:root${e},:host${e}`, matched: this.pattern.test(e.trim()) };
} }, media: { pattern: /^@media (.*)$/, resolve(e) {
  return { type: "media", selector: e, matched: this.pattern.test(e.trim()) };
} }, system: { pattern: /^system$/, resolve(e) {
  return { type: "system", selector: "@media (prefers-color-scheme: dark)", matched: this.pattern.test(e.trim()) };
} }, custom: { resolve(e) {
  return { type: "custom", selector: e, matched: !0 };
} } }, resolve(e) {
  let t = Object.keys(this.rules).filter((n) => n !== "custom").map((n) => this.rules[n]);
  return [e].flat().map((n) => {
    var s;
    return (s = t.map((r) => r.resolve(n)).find((r) => r.matched)) != null ? s : this.rules.custom.resolve(n);
  });
} }, _toVariables(e, t) {
  return ph(e, { prefix: t == null ? void 0 : t.prefix });
}, getCommon({ name: e = "", theme: t = {}, params: n, set: s, defaults: r }) {
  var i, o, l, a, c, u, f;
  let { preset: h, options: m } = t, g, v, M, S, P, $, T;
  if (he(h) && m.transform !== "strict") {
    let { primitive: F, semantic: j, extend: Q } = h, q = j || {}, { colorScheme: x } = q, k = gt(q, ["colorScheme"]), W = Q || {}, { colorScheme: N } = W, Y = gt(W, ["colorScheme"]), re = x || {}, { dark: ye } = re, ue = gt(re, ["dark"]), te = N || {}, { dark: J } = te, Ie = gt(te, ["dark"]), Fe = he(F) ? this._toVariables({ primitive: F }, m) : {}, me = he(k) ? this._toVariables({ semantic: k }, m) : {}, ge = he(ue) ? this._toVariables({ light: ue }, m) : {}, Bt = he(ye) ? this._toVariables({ dark: ye }, m) : {}, Et = he(Y) ? this._toVariables({ semantic: Y }, m) : {}, gs = he(Ie) ? this._toVariables({ light: Ie }, m) : {}, At = he(J) ? this._toVariables({ dark: J }, m) : {}, [cn, Nn] = [(i = Fe.declarations) != null ? i : "", Fe.tokens], [ys, Wt] = [(o = me.declarations) != null ? o : "", me.tokens || []], [Ai, d] = [(l = ge.declarations) != null ? l : "", ge.tokens || []], [p, y] = [(a = Bt.declarations) != null ? a : "", Bt.tokens || []], [C, _] = [(c = Et.declarations) != null ? c : "", Et.tokens || []], [w, R] = [(u = gs.declarations) != null ? u : "", gs.tokens || []], [A, E] = [(f = At.declarations) != null ? f : "", At.tokens || []];
    g = this.transformCSS(e, cn, "light", "variable", m, s, r), v = Nn;
    let O = this.transformCSS(e, `${ys}${Ai}`, "light", "variable", m, s, r), H = this.transformCSS(e, `${p}`, "dark", "variable", m, s, r);
    M = `${O}${H}`, S = [.../* @__PURE__ */ new Set([...Wt, ...d, ...y])];
    let D = this.transformCSS(e, `${C}${w}color-scheme:light`, "light", "variable", m, s, r), U = this.transformCSS(e, `${A}color-scheme:dark`, "dark", "variable", m, s, r);
    P = `${D}${U}`, $ = [.../* @__PURE__ */ new Set([..._, ...R, ...E])], T = dt(h.css, { dt: an });
  }
  return { primitive: { css: g, tokens: v }, semantic: { css: M, tokens: S }, global: { css: P, tokens: $ }, style: T };
}, getPreset({ name: e = "", preset: t = {}, options: n, params: s, set: r, defaults: i, selector: o }) {
  var l, a, c;
  let u, f, h;
  if (he(t) && n.transform !== "strict") {
    let m = e.replace("-directive", ""), g = t, { colorScheme: v, extend: M, css: S } = g, P = gt(g, ["colorScheme", "extend", "css"]), $ = M || {}, { colorScheme: T } = $, F = gt($, ["colorScheme"]), j = v || {}, { dark: Q } = j, q = gt(j, ["dark"]), x = T || {}, { dark: k } = x, W = gt(x, ["dark"]), N = he(P) ? this._toVariables({ [m]: Ze(Ze({}, P), F) }, n) : {}, Y = he(q) ? this._toVariables({ [m]: Ze(Ze({}, q), W) }, n) : {}, re = he(Q) ? this._toVariables({ [m]: Ze(Ze({}, Q), k) }, n) : {}, [ye, ue] = [(l = N.declarations) != null ? l : "", N.tokens || []], [te, J] = [(a = Y.declarations) != null ? a : "", Y.tokens || []], [Ie, Fe] = [(c = re.declarations) != null ? c : "", re.tokens || []], me = this.transformCSS(m, `${ye}${te}`, "light", "variable", n, r, i, o), ge = this.transformCSS(m, Ie, "dark", "variable", n, r, i, o);
    u = `${me}${ge}`, f = [.../* @__PURE__ */ new Set([...ue, ...J, ...Fe])], h = dt(S, { dt: an });
  }
  return { css: u, tokens: f, style: h };
}, getPresetC({ name: e = "", theme: t = {}, params: n, set: s, defaults: r }) {
  var i;
  let { preset: o, options: l } = t, a = (i = o == null ? void 0 : o.components) == null ? void 0 : i[e];
  return this.getPreset({ name: e, preset: a, options: l, params: n, set: s, defaults: r });
}, getPresetD({ name: e = "", theme: t = {}, params: n, set: s, defaults: r }) {
  var i, o;
  let l = e.replace("-directive", ""), { preset: a, options: c } = t, u = ((i = a == null ? void 0 : a.components) == null ? void 0 : i[l]) || ((o = a == null ? void 0 : a.directives) == null ? void 0 : o[l]);
  return this.getPreset({ name: l, preset: u, options: c, params: n, set: s, defaults: r });
}, applyDarkColorScheme(e) {
  return !(e.darkModeSelector === "none" || e.darkModeSelector === !1);
}, getColorSchemeOption(e, t) {
  var n;
  return this.applyDarkColorScheme(e) ? this.regex.resolve(e.darkModeSelector === !0 ? t.options.darkModeSelector : (n = e.darkModeSelector) != null ? n : t.options.darkModeSelector) : [];
}, getLayerOrder(e, t = {}, n, s) {
  let { cssLayer: r } = t;
  return r ? `@layer ${dt(r.order || r.name || "primeui", n)}` : "";
}, getCommonStyleSheet({ name: e = "", theme: t = {}, params: n, props: s = {}, set: r, defaults: i }) {
  let o = this.getCommon({ name: e, theme: t, params: n, set: r, defaults: i }), l = Object.entries(s).reduce((a, [c, u]) => a.push(`${c}="${u}"`) && a, []).join(" ");
  return Object.entries(o || {}).reduce((a, [c, u]) => {
    if (Ht(u) && Object.hasOwn(u, "css")) {
      let f = Wn(u.css), h = `${c}-variables`;
      a.push(`<style type="text/css" data-primevue-style-id="${h}" ${l}>${f}</style>`);
    }
    return a;
  }, []).join("");
}, getStyleSheet({ name: e = "", theme: t = {}, params: n, props: s = {}, set: r, defaults: i }) {
  var o;
  let l = { name: e, theme: t, params: n, set: r, defaults: i }, a = (o = e.includes("-directive") ? this.getPresetD(l) : this.getPresetC(l)) == null ? void 0 : o.css, c = Object.entries(s).reduce((u, [f, h]) => u.push(`${f}="${h}"`) && u, []).join(" ");
  return a ? `<style type="text/css" data-primevue-style-id="${e}-variables" ${c}>${Wn(a)}</style>` : "";
}, createTokens(e = {}, t, n = "", s = "", r = {}) {
  let i = function(l, a = {}, c = []) {
    if (c.includes(this.path)) return console.warn(`Circular reference detected at ${this.path}`), { colorScheme: l, path: this.path, paths: a, value: void 0 };
    c.push(this.path), a.name = this.path, a.binding || (a.binding = {});
    let u = this.value;
    if (typeof this.value == "string" && rs.test(this.value)) {
      let f = this.value.trim().replace(rs, (h) => {
        var m;
        let g = h.slice(1, -1), v = this.tokens[g];
        if (!v) return console.warn(`Token not found for path: ${g}`), "__UNRESOLVED__";
        let M = v.computed(l, a, c);
        return Array.isArray(M) && M.length === 2 ? `light-dark(${M[0].value},${M[1].value})` : (m = M == null ? void 0 : M.value) != null ? m : "__UNRESOLVED__";
      });
      u = Wa.test(f.replace(Ga, "0")) ? `calc(${f})` : f;
    }
    return xi(a.binding) && delete a.binding, c.pop(), { colorScheme: l, path: this.path, paths: a, value: u.includes("__UNRESOLVED__") ? void 0 : u };
  }, o = (l, a, c) => {
    Object.entries(l).forEach(([u, f]) => {
      let h = ln(u, t.variable.excludedKeyRegex) ? a : a ? `${a}.${Ho(u)}` : Ho(u), m = c ? `${c}.${u}` : u;
      Ht(f) ? o(f, h, m) : (r[h] || (r[h] = { paths: [], computed: (g, v = {}, M = []) => {
        if (r[h].paths.length === 1) return r[h].paths[0].computed(r[h].paths[0].scheme, v.binding, M);
        if (g && g !== "none") for (let S = 0; S < r[h].paths.length; S++) {
          let P = r[h].paths[S];
          if (P.scheme === g) return P.computed(g, v.binding, M);
        }
        return r[h].paths.map((S) => S.computed(S.scheme, v[S.scheme], M));
      } }), r[h].paths.push({ path: m, value: f, scheme: m.includes("colorScheme.light") ? "light" : m.includes("colorScheme.dark") ? "dark" : "none", computed: i, tokens: r }));
    });
  };
  return o(e, n, s), r;
}, getTokenValue(e, t, n) {
  var s;
  let r = ((l) => l.split(".").filter((a) => !ln(a.toLowerCase(), n.variable.excludedKeyRegex)).join("."))(t), i = t.includes("colorScheme.light") ? "light" : t.includes("colorScheme.dark") ? "dark" : void 0, o = [(s = e[r]) == null ? void 0 : s.computed(i)].flat().filter((l) => l);
  return o.length === 1 ? o[0].value : o.reduce((l = {}, a) => {
    let c = a, { colorScheme: u } = c, f = gt(c, ["colorScheme"]);
    return l[u] = f, l;
  }, void 0);
}, getSelectorRule(e, t, n, s) {
  return n === "class" || n === "attr" ? pn(he(t) ? `${e}${t},${e} ${t}` : e, s) : pn(e, pn(t != null ? t : ":root,:host", s));
}, transformCSS(e, t, n, s, r = {}, i, o, l) {
  if (he(t)) {
    let { cssLayer: a } = r;
    if (s !== "style") {
      let c = this.getColorSchemeOption(r, o);
      t = n === "dark" ? c.reduce((u, { type: f, selector: h }) => (he(h) && (u += h.includes("[CSS]") ? h.replace("[CSS]", t) : this.getSelectorRule(h, l, f, t)), u), "") : pn(l != null ? l : ":root,:host", t);
    }
    if (a) {
      let c = { name: "primeui" };
      Ht(a) && (c.name = dt(a.name, { name: e, type: s })), he(c.name) && (t = pn(`@layer ${c.name}`, t), i == null || i.layerNames(c.name));
    }
    return t;
  }
  return "";
} }, Oe = { defaults: { variable: { prefix: "p", selector: ":root,:host", excludedKeyRegex: /^(primitive|semantic|components|directives|variables|colorscheme|light|dark|common|root|states|extend|css)$/gi }, options: { prefix: "p", darkModeSelector: "system", cssLayer: !1 } }, _theme: void 0, _layerNames: /* @__PURE__ */ new Set(), _loadedStyleNames: /* @__PURE__ */ new Set(), _loadingStyles: /* @__PURE__ */ new Set(), _tokens: {}, update(e = {}) {
  let { theme: t } = e;
  t && (this._theme = Pr(Ze({}, t), { options: Ze(Ze({}, this.defaults.options), t.options) }), this._tokens = Ye.createTokens(this.preset, this.defaults), this.clearLoadedStyleNames());
}, get theme() {
  return this._theme;
}, get preset() {
  var e;
  return ((e = this.theme) == null ? void 0 : e.preset) || {};
}, get options() {
  var e;
  return ((e = this.theme) == null ? void 0 : e.options) || {};
}, get tokens() {
  return this._tokens;
}, getTheme() {
  return this.theme;
}, setTheme(e) {
  this.update({ theme: e }), bt.emit("theme:change", e);
}, getPreset() {
  return this.preset;
}, setPreset(e) {
  this._theme = Pr(Ze({}, this.theme), { preset: e }), this._tokens = Ye.createTokens(e, this.defaults), this.clearLoadedStyleNames(), bt.emit("preset:change", e), bt.emit("theme:change", this.theme);
}, getOptions() {
  return this.options;
}, setOptions(e) {
  this._theme = Pr(Ze({}, this.theme), { options: e }), this.clearLoadedStyleNames(), bt.emit("options:change", e), bt.emit("theme:change", this.theme);
}, getLayerNames() {
  return [...this._layerNames];
}, setLayerNames(e) {
  this._layerNames.add(e);
}, getLoadedStyleNames() {
  return this._loadedStyleNames;
}, isStyleNameLoaded(e) {
  return this._loadedStyleNames.has(e);
}, setLoadedStyleName(e) {
  this._loadedStyleNames.add(e);
}, deleteLoadedStyleName(e) {
  this._loadedStyleNames.delete(e);
}, clearLoadedStyleNames() {
  this._loadedStyleNames.clear();
}, getTokenValue(e) {
  return Ye.getTokenValue(this.tokens, e, this.defaults);
}, getCommon(e = "", t) {
  return Ye.getCommon({ name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
}, getComponent(e = "", t) {
  let n = { name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
  return Ye.getPresetC(n);
}, getDirective(e = "", t) {
  let n = { name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
  return Ye.getPresetD(n);
}, getCustomPreset(e = "", t, n, s) {
  let r = { name: e, preset: t, options: this.options, selector: n, params: s, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
  return Ye.getPreset(r);
}, getLayerOrderCSS(e = "") {
  return Ye.getLayerOrder(e, this.options, { names: this.getLayerNames() }, this.defaults);
}, transformCSS(e = "", t, n = "style", s) {
  return Ye.transformCSS(e, t, s, n, this.options, { layerNames: this.setLayerNames.bind(this) }, this.defaults);
}, getCommonStyleSheet(e = "", t, n = {}) {
  return Ye.getCommonStyleSheet({ name: e, theme: this.theme, params: t, props: n, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
}, getStyleSheet(e, t, n = {}) {
  return Ye.getStyleSheet({ name: e, theme: this.theme, params: t, props: n, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
}, onStyleMounted(e) {
  this._loadingStyles.add(e);
}, onStyleUpdated(e) {
  this._loadingStyles.add(e);
}, onStyleLoaded(e, { name: t }) {
  this._loadingStyles.size && (this._loadingStyles.delete(t), bt.emit(`theme:${t}:load`, e), !this._loadingStyles.size && bt.emit("theme:load"));
} }, Se = {
  STARTS_WITH: "startsWith",
  CONTAINS: "contains",
  NOT_CONTAINS: "notContains",
  ENDS_WITH: "endsWith",
  EQUALS: "equals",
  NOT_EQUALS: "notEquals",
  LESS_THAN: "lt",
  LESS_THAN_OR_EQUAL_TO: "lte",
  GREATER_THAN: "gt",
  GREATER_THAN_OR_EQUAL_TO: "gte",
  DATE_IS: "dateIs",
  DATE_IS_NOT: "dateIsNot",
  DATE_BEFORE: "dateBefore",
  DATE_AFTER: "dateAfter"
}, mh = `
    *,
    ::before,
    ::after {
        box-sizing: border-box;
    }

    /* Non vue overlay animations */
    .p-connected-overlay {
        opacity: 0;
        transform: scaleY(0.8);
        transition:
            transform 0.12s cubic-bezier(0, 0, 0.2, 1),
            opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
    }

    .p-connected-overlay-visible {
        opacity: 1;
        transform: scaleY(1);
    }

    .p-connected-overlay-hidden {
        opacity: 0;
        transform: scaleY(1);
        transition: opacity 0.1s linear;
    }

    /* Vue based overlay animations */
    .p-connected-overlay-enter-from {
        opacity: 0;
        transform: scaleY(0.8);
    }

    .p-connected-overlay-leave-to {
        opacity: 0;
    }

    .p-connected-overlay-enter-active {
        transition:
            transform 0.12s cubic-bezier(0, 0, 0.2, 1),
            opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
    }

    .p-connected-overlay-leave-active {
        transition: opacity 0.1s linear;
    }

    /* Toggleable Content */
    .p-toggleable-content-enter-from,
    .p-toggleable-content-leave-to {
        max-height: 0;
    }

    .p-toggleable-content-enter-to,
    .p-toggleable-content-leave-from {
        max-height: 1000px;
    }

    .p-toggleable-content-leave-active {
        overflow: hidden;
        transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);
    }

    .p-toggleable-content-enter-active {
        overflow: hidden;
        transition: max-height 1s ease-in-out;
    }

    .p-disabled,
    .p-disabled * {
        cursor: default;
        pointer-events: none;
        user-select: none;
    }

    .p-disabled,
    .p-component:disabled {
        opacity: dt('disabled.opacity');
    }

    .pi {
        font-size: dt('icon.size');
    }

    .p-icon {
        width: dt('icon.size');
        height: dt('icon.size');
    }

    .p-overlay-mask {
        background: dt('mask.background');
        color: dt('mask.color');
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .p-overlay-mask-enter {
        animation: p-overlay-mask-enter-animation dt('mask.transition.duration') forwards;
    }

    .p-overlay-mask-leave {
        animation: p-overlay-mask-leave-animation dt('mask.transition.duration') forwards;
    }

    @keyframes p-overlay-mask-enter-animation {
        from {
            background: transparent;
        }
        to {
            background: dt('mask.background');
        }
    }
    @keyframes p-overlay-mask-leave-animation {
        from {
            background: dt('mask.background');
        }
        to {
            background: transparent;
        }
    }
`;
function is(e) {
  "@babel/helpers - typeof";
  return is = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, is(e);
}
function Vo(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    t && (s = s.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, s);
  }
  return n;
}
function Ko(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vo(Object(n), !0).forEach(function(s) {
      gh(e, s, n[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vo(Object(n)).forEach(function(s) {
      Object.defineProperty(e, s, Object.getOwnPropertyDescriptor(n, s));
    });
  }
  return e;
}
function gh(e, t, n) {
  return (t = yh(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function yh(e) {
  var t = vh(e, "string");
  return is(t) == "symbol" ? t : t + "";
}
function vh(e, t) {
  if (is(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var s = n.call(e, t);
    if (is(s) != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function bh(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  Tt() && Tt().components ? mi(e) : t ? e() : ds(e);
}
var _h = 0;
function Sh(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = Vn(!1), s = Vn(e), r = Vn(null), i = sh() ? window.document : void 0, o = t.document, l = o === void 0 ? i : o, a = t.immediate, c = a === void 0 ? !0 : a, u = t.manual, f = u === void 0 ? !1 : u, h = t.name, m = h === void 0 ? "style_".concat(++_h) : h, g = t.id, v = g === void 0 ? void 0 : g, M = t.media, S = M === void 0 ? void 0 : M, P = t.nonce, $ = P === void 0 ? void 0 : P, T = t.first, F = T === void 0 ? !1 : T, j = t.onMounted, Q = j === void 0 ? void 0 : j, q = t.onUpdated, x = q === void 0 ? void 0 : q, k = t.onLoad, W = k === void 0 ? void 0 : k, N = t.props, Y = N === void 0 ? {} : N, re = function() {
  }, ye = function(J) {
    var Ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (l) {
      var Fe = Ko(Ko({}, Y), Ie), me = Fe.name || m, ge = Fe.id || v, Bt = Fe.nonce || $;
      r.value = l.querySelector('style[data-primevue-style-id="'.concat(me, '"]')) || l.getElementById(ge) || l.createElement("style"), r.value.isConnected || (s.value = J || e, Js(r.value, {
        type: "text/css",
        id: ge,
        media: S,
        nonce: Bt
      }), F ? l.head.prepend(r.value) : l.head.appendChild(r.value), rh(r.value, "data-primevue-style-id", me), Js(r.value, Fe), r.value.onload = function(Et) {
        return W == null ? void 0 : W(Et, {
          name: me
        });
      }, Q == null || Q(me)), !n.value && (re = Ut(s, function(Et) {
        r.value.textContent = Et, x == null || x(me);
      }, {
        immediate: !0
      }), n.value = !0);
    }
  }, ue = function() {
    !l || !n.value || (re(), eh(r.value) && l.head.removeChild(r.value), n.value = !1, r.value = null);
  };
  return c && !f && bh(ye), {
    id: v,
    name: m,
    el: r,
    css: s,
    unload: ue,
    load: ye,
    isLoaded: ci(n)
  };
}
function os(e) {
  "@babel/helpers - typeof";
  return os = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, os(e);
}
var Qo, qo, Bo, Wo;
function Go(e, t) {
  return Th(e) || Oh(e, t) || Ch(e, t) || wh();
}
function wh() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ch(e, t) {
  if (e) {
    if (typeof e == "string") return zo(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? zo(e, t) : void 0;
  }
}
function zo(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, s = Array(t); n < t; n++) s[n] = e[n];
  return s;
}
function Oh(e, t) {
  var n = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var s, r, i, o, l = [], a = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t !== 0) for (; !(a = (s = i.call(n)).done) && (l.push(s.value), l.length !== t); a = !0) ;
    } catch (u) {
      c = !0, r = u;
    } finally {
      try {
        if (!a && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw r;
      }
    }
    return l;
  }
}
function Th(e) {
  if (Array.isArray(e)) return e;
}
function Yo(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    t && (s = s.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, s);
  }
  return n;
}
function Mr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Yo(Object(n), !0).forEach(function(s) {
      xh(e, s, n[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Yo(Object(n)).forEach(function(s) {
      Object.defineProperty(e, s, Object.getOwnPropertyDescriptor(n, s));
    });
  }
  return e;
}
function xh(e, t, n) {
  return (t = Eh(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Eh(e) {
  var t = Ah(e, "string");
  return os(t) == "symbol" ? t : t + "";
}
function Ah(e, t) {
  if (os(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var s = n.call(e, t);
    if (os(s) != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function As(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var Ph = function(t) {
  var n = t.dt;
  return `
.p-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    opacity: 0;
    overflow: hidden;
    padding: 0;
    pointer-events: none;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}

.p-overflow-hidden {
    overflow: hidden;
    padding-right: `.concat(n("scrollbar.width"), `;
}
`);
}, Mh = {}, Rh = {}, dn = {
  name: "base",
  css: Ph,
  style: mh,
  classes: Mh,
  inlineStyles: Rh,
  load: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(i) {
      return i;
    }, r = s(Es(Qo || (Qo = As(["", ""])), t));
    return he(r) ? Sh(Wn(r), Mr({
      name: this.name
    }, n)) : {};
  },
  loadCSS: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.load(this.css, t);
  },
  loadStyle: function() {
    var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return this.load(this.style, n, function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return Oe.transformCSS(n.name || t.name, "".concat(r).concat(Es(qo || (qo = As(["", ""])), s)));
    });
  },
  getCommonTheme: function(t) {
    return Oe.getCommon(this.name, t);
  },
  getComponentTheme: function(t) {
    return Oe.getComponent(this.name, t);
  },
  getDirectiveTheme: function(t) {
    return Oe.getDirective(this.name, t);
  },
  getPresetTheme: function(t, n, s) {
    return Oe.getCustomPreset(this.name, t, n, s);
  },
  getLayerOrderThemeCSS: function() {
    return Oe.getLayerOrderCSS(this.name);
  },
  getStyleSheet: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.css) {
      var s = dt(this.css, {
        dt: an
      }) || "", r = Wn(Es(Bo || (Bo = As(["", "", ""])), s, t)), i = Object.entries(n).reduce(function(o, l) {
        var a = Go(l, 2), c = a[0], u = a[1];
        return o.push("".concat(c, '="').concat(u, '"')) && o;
      }, []).join(" ");
      return he(r) ? '<style type="text/css" data-primevue-style-id="'.concat(this.name, '" ').concat(i, ">").concat(r, "</style>") : "";
    }
    return "";
  },
  getCommonThemeStyleSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return Oe.getCommonStyleSheet(this.name, t, n);
  },
  getThemeStyleSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = [Oe.getStyleSheet(this.name, t, n)];
    if (this.style) {
      var r = this.name === "base" ? "global-style" : "".concat(this.name, "-style"), i = Es(Wo || (Wo = As(["", ""])), dt(this.style, {
        dt: an
      })), o = Wn(Oe.transformCSS(r, i)), l = Object.entries(n).reduce(function(a, c) {
        var u = Go(c, 2), f = u[0], h = u[1];
        return a.push("".concat(f, '="').concat(h, '"')) && a;
      }, []).join(" ");
      he(o) && s.push('<style type="text/css" data-primevue-style-id="'.concat(r, '" ').concat(l, ">").concat(o, "</style>"));
    }
    return s.join("");
  },
  extend: function(t) {
    return Mr(Mr({}, this), {}, {
      css: void 0,
      style: void 0
    }, t);
  }
}, Ps = Ha();
function ls(e) {
  "@babel/helpers - typeof";
  return ls = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ls(e);
}
function Jo(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    t && (s = s.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, s);
  }
  return n;
}
function Ms(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Jo(Object(n), !0).forEach(function(s) {
      Dh(e, s, n[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Jo(Object(n)).forEach(function(s) {
      Object.defineProperty(e, s, Object.getOwnPropertyDescriptor(n, s));
    });
  }
  return e;
}
function Dh(e, t, n) {
  return (t = Nh(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Nh(e) {
  var t = $h(e, "string");
  return ls(t) == "symbol" ? t : t + "";
}
function $h(e, t) {
  if (ls(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var s = n.call(e, t);
    if (ls(s) != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ih = {
  ripple: !1,
  inputStyle: null,
  inputVariant: null,
  locale: {
    startsWith: "Starts with",
    contains: "Contains",
    notContains: "Not contains",
    endsWith: "Ends with",
    equals: "Equals",
    notEquals: "Not equals",
    noFilter: "No Filter",
    lt: "Less than",
    lte: "Less than or equal to",
    gt: "Greater than",
    gte: "Greater than or equal to",
    dateIs: "Date is",
    dateIsNot: "Date is not",
    dateBefore: "Date is before",
    dateAfter: "Date is after",
    clear: "Clear",
    apply: "Apply",
    matchAll: "Match All",
    matchAny: "Match Any",
    addRule: "Add Rule",
    removeRule: "Remove Rule",
    accept: "Yes",
    reject: "No",
    choose: "Choose",
    upload: "Upload",
    cancel: "Cancel",
    completed: "Completed",
    pending: "Pending",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    chooseYear: "Choose Year",
    chooseMonth: "Choose Month",
    chooseDate: "Choose Date",
    prevDecade: "Previous Decade",
    nextDecade: "Next Decade",
    prevYear: "Previous Year",
    nextYear: "Next Year",
    prevMonth: "Previous Month",
    nextMonth: "Next Month",
    prevHour: "Previous Hour",
    nextHour: "Next Hour",
    prevMinute: "Previous Minute",
    nextMinute: "Next Minute",
    prevSecond: "Previous Second",
    nextSecond: "Next Second",
    am: "am",
    pm: "pm",
    today: "Today",
    weekHeader: "Wk",
    firstDayOfWeek: 0,
    showMonthAfterYear: !1,
    dateFormat: "mm/dd/yy",
    weak: "Weak",
    medium: "Medium",
    strong: "Strong",
    passwordPrompt: "Enter a password",
    emptyFilterMessage: "No results found",
    searchMessage: "{0} results are available",
    selectionMessage: "{0} items selected",
    emptySelectionMessage: "No selected item",
    emptySearchMessage: "No results found",
    fileChosenMessage: "{0} files",
    noFileChosenMessage: "No file chosen",
    emptyMessage: "No available options",
    aria: {
      trueLabel: "True",
      falseLabel: "False",
      nullLabel: "Not Selected",
      star: "1 star",
      stars: "{star} stars",
      selectAll: "All items selected",
      unselectAll: "All items unselected",
      close: "Close",
      previous: "Previous",
      next: "Next",
      navigation: "Navigation",
      scrollTop: "Scroll Top",
      moveTop: "Move Top",
      moveUp: "Move Up",
      moveDown: "Move Down",
      moveBottom: "Move Bottom",
      moveToTarget: "Move to Target",
      moveToSource: "Move to Source",
      moveAllToTarget: "Move All to Target",
      moveAllToSource: "Move All to Source",
      pageLabel: "Page {page}",
      firstPageLabel: "First Page",
      lastPageLabel: "Last Page",
      nextPageLabel: "Next Page",
      prevPageLabel: "Previous Page",
      rowsPerPageLabel: "Rows per page",
      jumpToPageDropdownLabel: "Jump to Page Dropdown",
      jumpToPageInputLabel: "Jump to Page Input",
      selectRow: "Row Selected",
      unselectRow: "Row Unselected",
      expandRow: "Row Expanded",
      collapseRow: "Row Collapsed",
      showFilterMenu: "Show Filter Menu",
      hideFilterMenu: "Hide Filter Menu",
      filterOperator: "Filter Operator",
      filterConstraint: "Filter Constraint",
      editRow: "Row Edit",
      saveEdit: "Save Edit",
      cancelEdit: "Cancel Edit",
      listView: "List View",
      gridView: "Grid View",
      slide: "Slide",
      slideNumber: "{slideNumber}",
      zoomImage: "Zoom Image",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      rotateRight: "Rotate Right",
      rotateLeft: "Rotate Left",
      listLabel: "Option List"
    }
  },
  filterMatchModeOptions: {
    text: [Se.STARTS_WITH, Se.CONTAINS, Se.NOT_CONTAINS, Se.ENDS_WITH, Se.EQUALS, Se.NOT_EQUALS],
    numeric: [Se.EQUALS, Se.NOT_EQUALS, Se.LESS_THAN, Se.LESS_THAN_OR_EQUAL_TO, Se.GREATER_THAN, Se.GREATER_THAN_OR_EQUAL_TO],
    date: [Se.DATE_IS, Se.DATE_IS_NOT, Se.DATE_BEFORE, Se.DATE_AFTER]
  },
  zIndex: {
    modal: 1100,
    overlay: 1e3,
    menu: 1e3,
    tooltip: 1100
  },
  theme: void 0,
  unstyled: !1,
  pt: void 0,
  ptOptions: {
    mergeSections: !0,
    mergeProps: !1
  },
  csp: {
    nonce: void 0
  }
}, Fh = Symbol();
function jh(e, t) {
  var n = {
    config: or(t)
  };
  return e.config.globalProperties.$primevue = n, e.provide(Fh, n), Lh(), kh(e, n), n;
}
var gn = [];
function Lh() {
  bt.clear(), gn.forEach(function(e) {
    return e == null ? void 0 : e();
  }), gn = [];
}
function kh(e, t) {
  var n = Vn(!1), s = function() {
    var c;
    if (((c = t.config) === null || c === void 0 ? void 0 : c.theme) !== "none" && !Oe.isStyleNameLoaded("common")) {
      var u, f, h = ((u = dn.getCommonTheme) === null || u === void 0 ? void 0 : u.call(dn)) || {}, m = h.primitive, g = h.semantic, v = h.global, M = h.style, S = {
        nonce: (f = t.config) === null || f === void 0 || (f = f.csp) === null || f === void 0 ? void 0 : f.nonce
      };
      dn.load(m == null ? void 0 : m.css, Ms({
        name: "primitive-variables"
      }, S)), dn.load(g == null ? void 0 : g.css, Ms({
        name: "semantic-variables"
      }, S)), dn.load(v == null ? void 0 : v.css, Ms({
        name: "global-variables"
      }, S)), dn.loadStyle(Ms({
        name: "global-style"
      }, S), M), Oe.setLoadedStyleName("common");
    }
  };
  bt.on("theme:change", function(a) {
    n.value || (e.config.globalProperties.$primevue.config.theme = a, n.value = !0);
  });
  var r = Ut(t.config, function(a, c) {
    Ps.emit("config:change", {
      newValue: a,
      oldValue: c
    });
  }, {
    immediate: !0,
    deep: !0
  }), i = Ut(function() {
    return t.config.ripple;
  }, function(a, c) {
    Ps.emit("config:ripple:change", {
      newValue: a,
      oldValue: c
    });
  }, {
    immediate: !0,
    deep: !0
  }), o = Ut(function() {
    return t.config.theme;
  }, function(a, c) {
    n.value || Oe.setTheme(a), t.config.unstyled || s(), n.value = !1, Ps.emit("config:theme:change", {
      newValue: a,
      oldValue: c
    });
  }, {
    immediate: !0,
    deep: !1
  }), l = Ut(function() {
    return t.config.unstyled;
  }, function(a, c) {
    !a && t.config.theme && s(), Ps.emit("config:unstyled:change", {
      newValue: a,
      oldValue: c
    });
  }, {
    immediate: !0,
    deep: !0
  });
  gn.push(r), gn.push(i), gn.push(o), gn.push(l);
}
var Uh = {
  install: function(t, n) {
    var s = zd(Ih, n);
    jh(t, s);
  }
};
const Hh = 20, Xo = /* @__PURE__ */ new Set();
let Zo = 0;
function Vh(e) {
  if (e instanceof Error)
    return e.message || e.name;
  if (typeof e == "string")
    return e;
  try {
    return JSON.stringify(e);
  } catch (t) {
    return String(e);
  }
}
function Kh(e) {
  return e instanceof Error ? e.stack : void 0;
}
function Qh() {
  try {
    const e = Fa(), t = e === "cart" ? "session-id" : `session-id-${e}`, n = window.localStorage.getItem(`offset-${t}`);
    return n ? JSON.parse(n) : void 0;
  } catch (e) {
    return;
  }
}
function Jr(e, t = {}) {
  var l, a;
  const n = (l = window.OFFSET) == null ? void 0 : l.apiKey;
  if (!n)
    return;
  const s = Vh(e), r = Kh(e), i = `${(a = t.component) != null ? a : ""}::${s}::${r != null ? r : ""}`;
  if (Xo.has(i) || Zo >= Hh)
    return;
  Xo.add(i), Zo++, fetch(`${Ia}errors`, {
    method: "POST",
    mode: "cors",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-API-Key": n
    },
    body: JSON.stringify({
      message: s,
      stack: r,
      component: t.component,
      url: window.location.href,
      hostname: window.location.hostname,
      sessionId: Qh()
    })
  }).catch(() => {
  });
}
const Xa = 1440 * 60 * 1e3, Za = new $a({
  defaultOptions: {
    queries: {
      gcTime: Xa
    }
  }
}), eu = kd({ storage: window.localStorage });
new URLSearchParams(window.location.search).has("refresh") && eu.removeClient();
Ld({
  queryClient: Za,
  persister: eu,
  maxAge: Xa,
  buster: "v1",
  dehydrateOptions: {
    shouldDehydrateQuery: (e) => e.queryKey[0] === "product"
  }
});
let el = !1;
function qh() {
  el || (el = !0, window.addEventListener("error", (e) => {
    var t;
    Jr((t = e.error) != null ? t : e.message, { component: "window.onerror" });
  }), window.addEventListener("unhandledrejection", (e) => {
    Jr(e.reason, { component: "window.onunhandledrejection" });
  }));
}
function Bp(e, t) {
  qh();
  const n = /* @__PURE__ */ Nf(t, {
    configureApp(r) {
      r.use(bd, { queryClient: Za }), r.use(Uh), r.config.errorHandler = (i, o) => {
        var l;
        Jr(i, { component: ((l = o == null ? void 0 : o.$options) == null ? void 0 : l.__name) || e }), console.error(i);
      };
    }
  }), s = n.prototype.connectedCallback;
  n.prototype.connectedCallback = function() {
    const r = this.querySelectorAll("[slot]");
    if (r && r.length) {
      this._props.slots || (this._props.slots = {});
      for (const i of r)
        this._props.slots[i.slot] = i;
    }
    s.call(this);
  }, customElements.get(e) || customElements.define(e, n);
}
export {
  Vp as $,
  jf as A,
  ds as B,
  Kp as C,
  Jh as D,
  dt as E,
  Ke as F,
  Jc as G,
  qt as H,
  xp as I,
  he as J,
  ko as K,
  Wd as L,
  dn as M,
  bt as N,
  qd as O,
  nh as P,
  ms as Q,
  xi as R,
  Oe as S,
  Pp as T,
  Ht as U,
  Ps as V,
  jp as W,
  Rp as X,
  kp as Y,
  Qp as Z,
  $p as _,
  Vn as a,
  Hp as a0,
  Mp as a1,
  Fp as a2,
  Zh as a3,
  tp as a4,
  ep as a5,
  Ha as a6,
  sh as a7,
  Yh as a8,
  rh as a9,
  Ia as aA,
  Tp as aB,
  Lf as aC,
  hp as aD,
  hr as aE,
  yp as aF,
  ns as aG,
  ud as aH,
  $e as aI,
  G as aJ,
  Lu as aK,
  Sp as aL,
  Gh as aM,
  wp as aN,
  Yf as aO,
  Eo as aP,
  Je as aQ,
  ps as aR,
  Gf as aS,
  zf as aT,
  Ea as aU,
  od as aV,
  Xf as aW,
  op as aX,
  Ns as aY,
  hd as aZ,
  Ap as aa,
  Lp as ab,
  th as ac,
  Up as ad,
  Ep as ae,
  Ip as af,
  Dp as ag,
  qp as ah,
  Np as ai,
  si as aj,
  fp as ak,
  dp as al,
  mp as am,
  ip as an,
  lp as ao,
  rp as ap,
  Op as aq,
  Jr as ar,
  pe as as,
  Wl as at,
  Ff as au,
  Fa as av,
  vu as aw,
  Wh as ax,
  wo as ay,
  up as az,
  gp as b,
  Vr as c,
  Bp as d,
  ap as e,
  hi as f,
  ma as g,
  Ae as h,
  Yc as i,
  sp as j,
  cp as k,
  Kr as l,
  lf as m,
  ri as n,
  mi as o,
  np as p,
  Ut as q,
  Sd as r,
  Cp as s,
  gu as t,
  Xh as u,
  mn as v,
  ec as w,
  pp as x,
  Gl as y,
  zh as z
};
